const PX_PER_INCH = 36;
const MIN_BORDER_PT = 16;                                    // border thickness: default AND minimum
const MIN_BORDER_PX = MIN_BORDER_PT * PX_PER_INCH / 72;      // = 8 px
        const MAX_PLAQUES = 10;                                      // most identical plaques per order
        const FONT_MIN_PT = 35;
        const FONT_MAX_PT = 96;
        // Font size limits are the same for every plaque size.
        const REF_PLAQUE_W = 10;
        const REF_PLAQUE_H = 6;

        let state = {
            shape: 'rect-sharp',
            width: 12,
            height: 10,
            borderStyle: 'outline',
            borderThickness: MIN_BORDER_PX,         // default = minimum = 16 pt
            innerBorderThickness: MIN_BORDER_PX,    // inner line of Double Inset / Wide Inset: default = minimum = 16 pt
            material: 'brass',
            surfaceMode: 'finish',
            color: '#ffffff',
            finish: 'finish-black-background',
            finishName: 'Black Background',
            relief: 'raised',
            designDepth: '2d',
            quantity: 1,                            // number of identical plaques ordered Quantity
            fontFamily: "'Arial', sans-serif",
            emblem: 'none',
            emblemLabel: '',
            emblemHtml: '',
            customImage: null,
            mounting: 'screws',
            screwCount: 4,
            screwCustom: [],
            zoomLevel: 1,
            elements: [

                { id: 'text-0', type: 'text', index: 0, x: 50, y: 115, w: 404, h: 30 }

            ],
            textLines: [
                { text: "Your custom text", size: "36pt", weight: "font-normal", align: "center", style: "norm", fontFamily: "'Arial', sans-serif" }

            ]
        };

        function plaqueSizePx() {
            return { w: state.width * PX_PER_INCH, h: state.height * PX_PER_INCH };
        }

        function plaqueTextScaleFor(w, h) {
            return Math.min(w / REF_PLAQUE_W, h / REF_PLAQUE_H);
        }

        function fontMinPt() {
            return FONT_MIN_PT;
        }

        function fontMaxPt() {
            return FONT_MAX_PT;
        }

        function plaqueFontPx(sizeStr) {
            const pt = Math.max(fontMinPt(), parseFloat(sizeStr) || fontMinPt());
            return (pt / 72) * PX_PER_INCH;
        }

        function defaultElementsForPlaque() {
            const { w, h } = plaqueSizePx();
            const mx = w * 0.08;
            const tw = w - mx * 2;
            return [

                { id: 'text-0', type: 'text', index: 0, x: mx, y: h * 0.34, w: tw, h: h * 0.11, userSized: false },
                { id: 'text-1', type: 'text', index: 1, x: mx, y: h * 0.46, w: tw, h: h * 0.16, userSized: false },
                { id: 'text-2', type: 'text', index: 2, x: mx, y: h * 0.64, w: tw, h: h * 0.11, userSized: false },
                { id: 'text-3', type: 'text', index: 3, x: mx, y: h * 0.76, w: tw, h: h * 0.11, userSized: false }
            ];
        }

        function scaleElementsToPlaque(oldW, oldH, newW, newH) {
            if (!oldW || !oldH || (oldW === newW && oldH === newH)) return;
            const sx = newW / oldW;
            const sy = newH / oldH;
            // Scale font sizes with the plaque, within the fixed 35–96pt range.
            const prevScale = plaqueTextScaleFor(oldW, oldH);
            const nextScale = plaqueTextScaleFor(newW, newH);
            const minPt = FONT_MIN_PT;
            const maxPt = FONT_MAX_PT;
            state.textLines.forEach(line => {
                const pt = parseFloat(line.size) || minPt;
                const scaled = Math.round(pt * nextScale / prevScale);
                line.size = Math.min(maxPt, Math.max(minPt, scaled)) + 'pt';
            });
            state.elements.forEach(el => {
                el.x *= sx;
                el.y *= sy;
                el.w *= sx;
                el.h *= sy;
            });
        }

        // Resizing preserves the minimum effective font size of 35pt.
        // Manual enlargement has no upper limit.
        function textMinScale(el) {
            const line = state.textLines[el.index];
            const minPt = fontMinPt();
            const basePt = Math.max(minPt, parseFloat(line && line.size) || minPt);
            return minPt / basePt;   // Scale is 1 at the minimum size and less than 1 above it.
        }

        function textMinBox(el) {
            const ms = textMinScale(el);
            return { w: (el.naturalW || 8) * ms, h: (el.naturalH || 8) * ms };
        }

        /* Real size of a text line as the customer sees it on the plaque.
           Dragging the corner handles stretches the text with scale(), so line.size (the dropdown value)
           is only the starting size. Effective size = starting size x vertical scale. */
        function effectiveTextPt(el) {
            const line = state.textLines[el.index];
            const basePt = Math.max(fontMinPt(), parseFloat(line && line.size) || fontMinPt());
            if (!el.naturalH || !el.h) return Math.round(basePt);
            return Math.max(fontMinPt(), Math.round(basePt * el.h / el.naturalH));
        }

        /* Horizontal stretch compared with vertical (100 = letters keep their normal proportions). */
        function textStretchPct(el) {
            if (!el.naturalW || !el.naturalH || !el.w || !el.h) return 100;
            return Math.round((el.w / el.naturalW) / (el.h / el.naturalH) * 100);
        }

        /* Keep every "Font Size" dropdown in the sidebar equal to the size actually shown on the plaque. */
        function syncTextSizeSelects() {
            state.elements.filter(el => el.type === 'text').forEach(el => {
                const select = document.querySelector(`select[data-size-line="${el.index}"]`);
                if (!select) return;
                const pt = effectiveTextPt(el);
                select.querySelectorAll('option[data-custom]').forEach(option => option.remove());
                if (![...select.options].some(option => parseFloat(option.value) === pt)) {
                    const option = document.createElement('option');
                    option.value = pt + 'pt';
                    option.textContent = pt + 'pt';
                    option.dataset.custom = '1';       // sizes above the dropdown range (resized on the plaque)
                    select.appendChild(option);
                }
                select.value = pt + 'pt';
            });
        }

        function resetTextFit(index) {
            const el = state.elements.find(item => item.type === 'text' && item.index === index);
            if (el) el.userSized = false;
        }

        function layoutTextElement(wrapper, el, line) {
            const textDiv = wrapper.querySelector('.plaque-text');
            if (!textDiv) return;
            textDiv.style.transform = 'none';
            const bounds = plaqueSizePx();
            const margin = borderTextMargin();
            textDiv.style.maxWidth = Math.max(1, bounds.w - margin * 2) + 'px';
            textDiv.style.textAlign = line.align;
            const nw = Math.max(1, textDiv.scrollWidth);
            const nh = Math.max(1, textDiv.scrollHeight);
            el.naturalW = nw;
            el.naturalH = nh;
            if (!el.userSized) {
                const prevW = el.w || nw;
                const prevH = el.h || nh;
                const prevX = el.x;
                const prevY = el.y;
                el.w = nw;
                el.h = nh;
                if (line.align === 'center') el.x = prevX + (prevW - el.w) / 2;
                else if (line.align === 'right') el.x = prevX + prevW - el.w;
                el.y = prevY + (prevH - el.h) / 2;
            }
            const minBox = textMinBox(el);
            el.w = Math.max(el.w, minBox.w);
            el.h = Math.max(el.h, minBox.h);
            constrainElementPosition(el);
            wrapper.style.left = el.x + 'px';
            wrapper.style.top = el.y + 'px';
            wrapper.style.width = el.w + 'px';
            wrapper.style.height = el.h + 'px';
            textDiv.style.transform = `scale(${el.w / nw}, ${el.h / nh})`;
        }

        function stretchTextDom(domEl, found) {
            if (!domEl || found.type !== 'text') return;
            const textDiv = domEl.querySelector('.plaque-text');
            if (!textDiv || !found.naturalW || !found.naturalH) return;
            textDiv.style.transform = `scale(${found.w / found.naturalW}, ${found.h / found.naturalH})`;
        }

        let currentSelectedElementId = null;
        let nextTextElementId = 4;

        const commonColors = [
            { name: 'White', hex: '#ffffff' },
            { name: 'Black', hex: '#000000' },
            { name: 'Brown', hex: '#5D2D24' }
        ];
        function plaqueQty() {
            const n = Math.floor(Number(state.quantity));
            return Number.isFinite(n) ? Math.min(MAX_PLAQUES, Math.max(1, n)) : 1;
        }
        function setPlaqueQuantity(value) {
            state.quantity = Math.min(MAX_PLAQUES, Math.max(1, Math.floor(Number(value)) || 1));
            refreshPriceDisplays();
        }
        function changePlaqueQuantity(delta) { setPlaqueQuantity(plaqueQty() + delta); }
        function refreshPriceDisplays() {
            const price = getPriceBreakdown();
            const set = (id, text) => { const el = document.getElementById(id); if (el) el.innerText = text; };
            set('headerPrice', '$' + price.total.toFixed(2));
            set('modalBasePrice', '$' + price.base.toFixed(2));
            set('modalColorCharge', '$' + price.colorCharge.toFixed(2) + ' USD');
            set('modalPrice', '$' + price.total.toFixed(2));
            set('modalPerPlaque', '$' + (price.perPlaque + price.colorChargeEach).toFixed(2) + ' each');
            const estimate = document.getElementById('surfaceEstimate');
            if (estimate) estimate.textContent = 'Estimated total: $' + price.total.toFixed(2) + ' USD' + (price.colorCharge ? ' (includes $' + price.colorCharge.toFixed(2) + ' custom color charge: $39.00 x ' + price.qty + ' plaque' + (price.qty > 1 ? 's' : '') + ')' : '');
            const input = document.getElementById('plaqueQtyInput');
            if (input && document.activeElement !== input) input.value = price.qty;
        }
        function getPriceBreakdown() {
            const rate = state.designDepth === '3d' ? 8 : 5;
            const qty = plaqueQty();
            const perPlaque = state.width * state.height * rate;
            const base = perPlaque * qty;
            const colorChargeEach = state.surfaceMode === 'color' && !commonColors.some(c => c.hex.toLowerCase() === state.color.toLowerCase()) ? 39 : 0;
            const colorCharge = colorChargeEach * qty;      // charged for every plaque (2 plaques = $78)
            return { rate, qty, perPlaque, base, colorChargeEach, colorCharge, total: base + colorCharge };
        } 
        function surfaceName() {
            if (state.surfaceMode !== 'color') return state.finishName;
            const common = commonColors.find(c => c.hex.toLowerCase() === state.color.toLowerCase());
            return common ? common.name : 'Custom ' + state.color.toUpperCase();
        }
        function getSurfaceMetal() {
            if (state.surfaceMode !== 'color') return finishes.find(f => f.id === state.finish) || finishes[5];
            const channels = [1, 3, 5].map(i => parseInt(state.color.slice(i, i + 2), 16) / 255);
            const luminance = channels.map(c => c <= .04045 ? c / 12.92 : ((c + .055) / 1.055) ** 2.4).reduce((sum, c, i) => sum + c * [.2126, .7152, .0722][i], 0);
            if (luminance > .45) return { ink: '#59472c', highlight: '#8b7652', edge: '#352b20' };
            return state.material === 'bronze' ? { ink: '#d9bd93', highlight: '#f1dec1', edge: '#a58a65' } : { ink: '#e2ca8c', highlight: '#f6e7b7', edge: '#ab925a' };
        }
        function setSurfaceMode(mode) {
            if (!['finish', 'color'].includes(mode)) return;
            state.surfaceMode = mode;
            updatePlaqueUI();
        }
        function setPlaqueColor(hex) {
            if (!/^#[0-9a-f]{6}$/i.test(hex)) return false;
            state.color = hex.toLowerCase();
            state.surfaceMode = 'color';
            document.getElementById('colorHexError').classList.add('hidden');
            document.getElementById('colorHex').removeAttribute('aria-invalid');
            updatePlaqueUI();
            return true;
        }
        function setColorHex(input) {
            let hex = input.value.trim();
            if (!hex.startsWith('#')) hex = '#' + hex;
            if (/^#[0-9a-f]{3}$/i.test(hex)) hex = '#' + [...hex.slice(1)].map(c => c + c).join('');
            if (!setPlaqueColor(hex)) {
                input.setAttribute('aria-invalid', 'true');
                document.getElementById('colorHexError').classList.remove('hidden');
            }
        }
        function setColorHue(value) {
            const h = Number(value);
            if (!Number.isFinite(h) || h < 0 || h > 360) return;
            const channel = n => { const k = (n + h / 30) % 12; return Math.round((.5 - .5 * Math.max(-1, Math.min(k - 3, 9 - k, 1))) * 255).toString(16).padStart(2, '0'); };
            setPlaqueColor('#' + channel(0) + channel(8) + channel(4));
        }
        function renderSurfaceControls() {
            const colorMode = state.surfaceMode === 'color';
            document.getElementById('finishOptions').classList.toggle('hidden', colorMode);
            document.getElementById('colorOptions').classList.toggle('hidden', !colorMode);
            document.getElementById('modeFinish').setAttribute('aria-pressed', String(!colorMode));
            document.getElementById('modeColor').setAttribute('aria-pressed', String(colorMode));
            document.getElementById('commonColors').innerHTML = commonColors.map(c => `<button type="button" onclick="setPlaqueColor('${c.hex}')" aria-pressed="${state.color.toLowerCase() === c.hex.toLowerCase()}" class="p-3 rounded-lg border ${state.color.toLowerCase() === c.hex.toLowerCase() ? 'border-amber-600 bg-amber-50 ring-2 ring-amber-600/20' : 'border-slate-200 bg-white'}"><span class="block h-8 rounded border border-slate-300 mb-2" style="background:${c.hex}"></span><span class="text-xs font-semibold">${c.name}</span></button>`).join('');
            document.getElementById('customColorPicker').value = state.color;
            if (document.activeElement !== document.getElementById('colorHex')) document.getElementById('colorHex').value = state.color.toUpperCase();
            if (document.activeElement !== document.getElementById('colorHue')) {
                const [r,g,b] = [1,3,5].map(i => parseInt(state.color.slice(i,i+2),16)/255);
                const max = Math.max(r,g,b), delta = max - Math.min(r,g,b);
                const hue = !delta ? 0 : (60 * (max === r ? (g-b)/delta : max === g ? (b-r)/delta+2 : (r-g)/delta+4) + 360) % 360;
                document.getElementById('colorHue').value = Math.round(hue);
            }
            const price = getPriceBreakdown();
            document.getElementById('colorChargeInfo').textContent = price.colorCharge ? 'Custom color charge: +$39.00 USD per plaque.' : 'Common color selected — no extra charge.';
            document.getElementById('surfaceEstimate').textContent = 'Estimated total: $' + price.total.toFixed(2) + ' USD' + (price.colorCharge ? ' (includes $' + price.colorCharge.toFixed(2) + ' custom color charge: $39.00 x ' + price.qty + ' plaque' + (price.qty > 1 ? 's' : '') + ')' : '');
        }

        const materials = [
            { id: 'brass', name: 'Brass' },
            { id: 'bronze', name: 'Bronze' }
        ];

        function renderMaterials() {
            document.getElementById('materialsGrid').innerHTML = materials.map(material => `
                <button type="button" onclick="setMaterial('${material.id}')" aria-pressed="${state.material === material.id}" class="p-3 rounded-xl border ${state.material === material.id ? 'border-amber-600 bg-amber-50 ring-2 ring-amber-600/20' : 'border-slate-200 bg-white'} flex flex-col items-center gap-2 hover:border-amber-600 transition w-full">
                    <span class="material-swatch material-swatch-${material.id}" aria-hidden="true"></span>
                    <span class="text-sm font-semibold text-slate-800">${material.name}</span>
                </button>
            `).join('');
        }

        function setMaterial(id) {
            if (!materials.some(material => material.id === id)) return;
            state.material = id;
            renderMaterials();
            renderFinishes();
            updatePlaqueUI();
        }

        const finishes = [
          {
                    "id": "finish-dark-bronze",
                    "name": "Dark Bronze",
                    "class": "finish-dark-bronze",
                    "ink": "#dfcf8d",
                    "highlight": "#f3e6b2",
                    "edge": "#ab965a"
          },
          {
                    "id": "finish-patina",
                    "name": "Patina",
                    "class": "finish-patina",
                    "ink": "#323632",
                    "highlight": "#737f77",
                    "edge": "#292d29"
          },
          {
                    "id": "finish-bronze",
                    "name": "Bronze",
                    "class": "finish-bronze",
                    "ink": "#dfd2aa",
                    "highlight": "#f1e8c8",
                    "edge": "#b4a67d"
          },
          {
                    "id": "finish-brass",
                    "name": "Brass",
                    "class": "finish-brass",
                    "ink": "#e6dbaf",
                    "highlight": "#fff3d0",
                    "edge": "#c3b580"
          },
          {
                    "id": "finish-oil-rubbed-bronze",
                    "name": "Oil-Rubbed Bronze",
                    "class": "finish-oil-rubbed-bronze",
                    "ink": "#d1bd98",
                    "highlight": "#e7d8bb",
                    "edge": "#a18d70"
          },
          {
                    "id": "finish-black-background",
                    "name": "Black Background",
                    "class": "finish-black-background",
                    "ink": "#ceb579",
                    "highlight": "#e4cd95",
                    "edge": "#aa8f53"
          }
];

        const borderStyles = [
            { id: 'outline', name: 'Thin Outline + Gap', icon: 'fa-vector-square' },
            { id: 'plain', name: 'Plain Single', icon: 'fa-square' },
            { id: 'bar', name: 'Double Inset', icon: 'fa-clone' },
            { id: 'square', name: 'Wide Inset', icon: 'fa-stop' },
            { id: 'solid', name: 'Thick Solid', icon: 'fa-square-full' },
            { id: 'square-rounded', name: 'Outer Square / Inner Rounded', icon: 'fa-square' },
            { id: 'notch', name: 'Dashed Accent', icon: 'fa-square-caret-right' },
            { id: 'none', name: 'No Border', icon: 'fa-ban' }
        ];

        const mountingOptions = [
            { id: 'screws', name: 'Corner Rosette Screws (Visible)', desc: 'Standard decorative mounting with matching screws' },
            { id: 'studs', name: 'Blind Threaded Studs (Hidden)', desc: 'Clean flush mount with rear welded threaded bolts' },
            { id: 'adhesive', name: 'Industrial Adhesive Backing', desc: 'High bond foam tape for flat walls' }
        ];

        // ===== Emblem / Nautical Motif picker =====
        // Source: Iconify API (api.iconify.design) - 200,000+ symbols with built-in search.
        // Show the built-in Font Awesome list if the symbol API is unavailable.
        const ICONIFY_API = 'https://api.iconify.design';
        const EMBLEM_PAGE_SIZE = 48;
        const EMBLEM_PER_TERM = 8;
        const EMBLEM_ID_RE = /^[a-z0-9_-]+:[a-z0-9_.-]+$/i;

        const EMBLEM_CATEGORIES = [
            { id: 'classic', label: 'Classic', icons: ['fa6-solid:compass', 'fa6-solid:anchor', 'fa6-solid:shield-halved', 'fa6-solid:star-of-david', 'fa6-solid:cross', 'fa6-solid:dove', 'fa6-solid:tree'] },
            { id: 'nautical', label: 'Nautical', terms: ['anchor', 'ship', 'sailboat', 'ship wheel', 'compass', 'lighthouse', 'lifebuoy', 'wave', 'fish', 'whale', 'shell', 'mermaid', 'octopus', 'trident'] },
            { id: 'religious', label: 'Religious', terms: ['cross', 'star of david', 'crescent', 'om', 'dove', 'church', 'praying hands', 'menorah', 'khanda', 'lotus', 'ankh', 'yin yang', 'bible'] },
            { id: 'memorial', label: 'Memorial', terms: ['heart', 'candle', 'angel', 'dove', 'rose', 'ribbon', 'paw', 'wings', 'halo', 'butterfly', 'infinity'] },
            { id: 'heraldry', label: 'Heraldry', terms: ['shield', 'crown', 'sword', 'laurel wreath', 'fleur de lis', 'crest', 'banner', 'castle', 'key', 'lion', 'knight'] },
            { id: 'military', label: 'Military', terms: ['medal', 'flag', 'badge', 'dog tag', 'helmet', 'star', 'eagle', 'firefighter', 'police', 'rifle'] },
            { id: 'animals', label: 'Animals', terms: ['eagle', 'lion', 'horse', 'deer', 'wolf', 'bear', 'owl', 'dragon', 'paw', 'dog', 'cat', 'butterfly'] },
            { id: 'nature', label: 'Nature', terms: ['tree', 'oak leaf', 'flower', 'rose', 'sun', 'moon', 'mountain', 'star', 'wheat', 'feather', 'pine'] },
            { id: 'symbols', label: 'Symbols', terms: ['star', 'heart', 'infinity', 'peace', 'diamond', 'crown', 'key', 'lock', 'bell', 'trophy', 'music'] }
        ];

        // Fallback symbols from the Font Awesome stylesheet loaded by this page.
        const EMBLEM_BUILTIN = ['anchor', 'ship', 'sailboat', 'life-ring', 'compass', 'water', 'fish', 'dove', 'cross', 'star-of-david', 'tree', 'shield-halved',
            'crown', 'feather', 'horse', 'dragon', 'paw', 'leaf', 'sun', 'moon', 'star', 'heart', 'key', 'flag', 'medal', 'church', 'mosque', 'om', 'yin-yang',
            'khanda', 'ankh', 'peace', 'hands-praying', 'cat', 'dog', 'snowflake', 'fire', 'bolt', 'gem', 'ring'];

        // Font Awesome 6 Free by Dave Gandy, CC BY 4.0; sourced through Iconify.
        // https://github.com/iconify/icon-sets/blob/master/json/fa6-solid.json
        // LOCAL_EMBLEMS / LOCAL_EMBLEM_CATEGORIES -> js/emblems-data.js
        const emblemSearchCache = new Map();
        const localSvgCache = new Map();
        const normalizeEmblemQuery = value => value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
        const emblemSynonyms = {
            nautical: 'anchor ship sailboat compass life ring water fish ferry',
            boat: 'ship sailboat ferry', wheel: 'dharmachakra', lifebuoy: 'life ring',
            wave: 'water', ocean: 'water anchor fish ship', sea: 'water anchor fish ship',
            memorial: 'heart candle dove ribbon cross', crest: 'shield crown',
            badge: 'shield medal certificate', wreath: 'award leaf',
            flower: 'seedling clover spa', rose: 'seedling spa', lotus: 'spa',
            eagle: 'crow dove', bird: 'crow dove', religion: 'cross church om mosque',
            military: 'medal flag helmet rifle person military',
            praying: 'hands praying', mountain: 'mountain', pine: 'tree',
            infinity: 'infinity', butterfly: 'locust', dogtag: 'id badge'
        };
        const localEmblemIndex = Object.keys(LOCAL_EMBLEMS).map(id => {
            const name = id.slice(id.indexOf(':') + 1);
            const categories = Object.entries(LOCAL_EMBLEM_CATEGORIES).filter(([,names]) => names.includes(name)).map(([category]) => category);
            return { id, name: normalizeEmblemQuery(name), text: normalizeEmblemQuery(name + ' ' + categories.join(' ')) };
        });

        function localEmblemSvg(id) {
            if (localSvgCache.has(id)) return localSvgCache.get(id);
            const icon = LOCAL_EMBLEMS[id];
            if (!icon) return '';
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${icon.width} ${icon.height}" width="100%" height="100%" preserveAspectRatio="xMidYMid meet" aria-hidden="true">${icon.body}</svg>`;
            localSvgCache.set(id, svg);
            return svg;
        }

        function findLocalEmblems(query, category) {
            const q = normalizeEmblemQuery(query);
            if (q) {
                const words = q.split(' ');
                const related = (emblemSynonyms[q] || '').split(' ').filter(Boolean);
                return localEmblemIndex.map(item => ({ item, score:
                    item.name === q ? 0 : item.name.startsWith(q) ? 1 :
                    words.every(word => item.text.includes(word)) ? 2 :
                    related.length && related.some(word => item.name.split(' ').includes(word)) ? 3 : 99
                })).filter(hit => hit.score < 99).sort((a,b) => a.score - b.score || a.item.name.localeCompare(b.item.name)).map(hit => hit.item.id);
            }
            const cat = EMBLEM_CATEGORIES.find(item => item.id === category) || EMBLEM_CATEGORIES[0];
            if (cat.icons) return cat.icons.filter(id => LOCAL_EMBLEMS[id]);
            const ids = new Set();
            (cat.terms || []).forEach(term => findLocalEmblems(term, '').slice(0,8).forEach(id => ids.add(id)));
            return [...ids];
        }

        function renderLocalEmblems(append) {
            const ids = findLocalEmblems(emblemUI.query, emblemUI.category);
            const start = append ? emblemUI.start : 0;
            const page = ids.slice(start, start + EMBLEM_PAGE_SIZE);
            renderEmblemGrid(page, append);
            emblemUI.start = Math.min(ids.length, start + page.length);
            emblemUI.total = ids.length;
            document.getElementById('emblemLoadMore').classList.toggle('hidden', emblemUI.start >= ids.length);
            document.getElementById('emblemStatus').textContent = ids.length
                ? `Offline library: ${emblemUI.start} of ${ids.length} matching symbols. Ready to use.`
                : 'No offline matches. Try another word or choose an online icon set for a wider search.';
        }

        const emblemUI = { category: 'classic', query: '', start: 0, total: 0, token: 0, debounce: null };
        const emblemSvgCache = new Map();
        let emblemSelectionToken = 0;

        function emblemSetValue() {
            return document.getElementById('emblemSetSelect').value;
        }

        function emblemLabelFromId(id) {
            return id.split(':').pop().replace(/[-_.]/g, ' ');
        }

        async function emblemSearchApi(term, set, start, limit) {
            let url = `${ICONIFY_API}/search?query=${encodeURIComponent(term)}&limit=${limit}&start=${start}`;
            if (set) url += `&prefixes=${encodeURIComponent(set)}`;
            if (emblemSearchCache.has(url)) return emblemSearchCache.get(url);
            const res = await fetch(url, { signal: AbortSignal.timeout(8000) });
            if (!res.ok) throw new Error('Iconify search failed: ' + res.status);
            const data = await res.json();
            const result = { icons: (data.icons || []).filter(id => EMBLEM_ID_RE.test(id)), total: data.total || 0 };
            if (emblemSearchCache.size >= 80) emblemSearchCache.delete(emblemSearchCache.keys().next().value);
            emblemSearchCache.set(url, result);
            return result;
        }

        function emblemButtonClasses(selected) {
            return 'emblem-btn aspect-square p-1.5 rounded-xl border flex items-center justify-center transition ' +
                (selected ? 'border-amber-600 bg-amber-50 ring-2 ring-amber-600/20' : 'border-slate-200 bg-slate-50 hover:border-slate-300');
        }

        function renderEmblemChips() {
            const wrap = document.getElementById('emblemCategoryChips');
            wrap.innerHTML = EMBLEM_CATEGORIES.map(c => {
                const active = !emblemUI.query && emblemUI.category === c.id;
                return `<button onclick="setEmblemCategory('${c.id}')" class="px-2.5 py-1 rounded-full text-[11px] font-medium border transition ${active ? 'border-amber-600 bg-amber-50 text-amber-800' : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300'}">${c.label}</button>`;
            }).join('');
        }

        function renderEmblemGrid(ids, append) {
            const grid = document.getElementById('emblemResults');
            const html = ids.map(id => {
                if (LOCAL_EMBLEMS[id]) {
                    return `<button type="button" data-emblem-id="${id}" title="${emblemLabelFromId(id)}" aria-label="${emblemLabelFromId(id)}" onclick="selectEmblem('${id}')" class="${emblemButtonClasses(state.emblem === id)}"><span class="w-7 h-7 pointer-events-none text-slate-700">${localEmblemSvg(id)}</span></button>`;
                }
                if (id.startsWith('fa:')) {
                    const n = id.slice(3);
                    return `<button type="button" data-emblem-id="${id}" title="${n.replace(/-/g, ' ')}" onclick="selectEmblem('${id}')" class="${emblemButtonClasses(state.emblem === id)}"><i class="fa-solid fa-${n} text-xl text-slate-700"></i></button>`;
                }
                const [prefix, name] = id.split(':');
                return `<button type="button" data-emblem-id="${id}" title="${emblemLabelFromId(id)} (${prefix})" onclick="selectEmblem('${id}')" class="${emblemButtonClasses(state.emblem === id)}"><img src="${ICONIFY_API}/${prefix}/${name}.svg?height=28" loading="lazy" alt="" class="w-7 h-7 object-contain pointer-events-none"></button>`;
            }).join('');
            if (append) grid.insertAdjacentHTML('beforeend', html);
            else grid.innerHTML = html;
        }

        function updateEmblemHighlight() {
            document.querySelectorAll('#emblemResults .emblem-btn').forEach(btn => {
                btn.className = emblemButtonClasses(btn.dataset.emblemId === state.emblem);
            });
            const noneBtn = document.getElementById('emblemNoneBtn');
            if (noneBtn) {
                const isNone = state.emblem === 'none';
                noneBtn.className = 'text-[11px] font-medium px-2.5 py-1 rounded-lg border transition flex items-center space-x-1.5 ' +
                    (isNone ? 'border-amber-600 bg-amber-50 text-amber-800' : 'border-slate-200 bg-slate-50 text-slate-600 hover:border-slate-300');
            }
            const info = document.getElementById('emblemSelectedInfo');
            if (info) {
                if (state.emblem === 'none') info.textContent = 'Selected: none';
                else info.textContent = 'Selected: ' + (state.emblemLabel || state.emblem);
            }
            const addButton = document.getElementById('addLogoBtn');
            addButton.disabled = pendingNewLogo || !currentSymbolLogo();
            addButton.querySelector('span').textContent = pendingNewLogo ? 'Choose the New Logo Above' : 'Add Logo';
            if (pendingNewLogo && info) info.textContent = 'Choose a symbol above to add a new logo. Existing logos will stay unchanged.';
        }

        function showEmblemFallback(reason) {
            document.getElementById('emblemSetSelect').value = 'local';
            renderLocalEmblems(false);
            document.getElementById('emblemStatus').textContent = reason + ' ' + document.getElementById('emblemStatus').textContent;
        }

        async function loadEmblemResults(append) {
            if (emblemSetValue() === 'local') {
                ++emblemUI.token;
                renderLocalEmblems(append);
                return;
            }
            const token = ++emblemUI.token;
            const status = document.getElementById('emblemStatus');
            const moreBtn = document.getElementById('emblemLoadMore');
            const set = emblemSetValue();
            try {
                if (emblemUI.query) {
                    const start = append ? emblemUI.start : 0;
                    if (!append) { status.textContent = 'Searching…'; moreBtn.classList.add('hidden'); }
                    const r = await emblemSearchApi(emblemUI.query, set, start, EMBLEM_PAGE_SIZE);
                    if (token !== emblemUI.token) return;
                    emblemUI.start = start + EMBLEM_PAGE_SIZE;
                    emblemUI.total = r.total;
                    renderEmblemGrid(r.icons, append);
                    const shown = Math.min(emblemUI.start, r.total);
                    status.textContent = r.total ? `"${emblemUI.query}": ${shown} of ${r.total.toLocaleString()} symbols` : `"${emblemUI.query}": no symbols found. Try another word or select "All icon sets".`;
                    moreBtn.classList.toggle('hidden', emblemUI.start >= r.total);
                } else {
                    const cat = EMBLEM_CATEGORIES.find(c => c.id === emblemUI.category) || EMBLEM_CATEGORIES[0];
                    moreBtn.classList.add('hidden');
                    if (cat.icons) {
                        renderEmblemGrid(cat.icons, false);
                        status.textContent = cat.label + ' symbols';
                        return;
                    }
                    status.textContent = 'Loading ' + cat.label.toLowerCase() + ' symbols…';
                    const results = await Promise.all(cat.terms.map(t => emblemSearchApi(t, set, 0, 32)));
                    if (token !== emblemUI.token) return;
                    const seen = new Set();
                    const ids = [];
                    results.forEach(r => r.icons.slice(0, EMBLEM_PER_TERM).forEach(id => { if (!seen.has(id)) { seen.add(id); ids.push(id); } }));
                    renderEmblemGrid(ids, false);
                    status.textContent = `${cat.label}: ${ids.length} symbols. Search above to find more.`;
                }
            } catch (err) {
                if (token !== emblemUI.token) return;
                console.error(err);
                showEmblemFallback('Could not connect to the symbol library (Iconify).');
            }
        }

        function setEmblemCategory(id) {
            clearTimeout(emblemUI.debounce);
            emblemUI.category = id;
            emblemUI.query = '';
            document.getElementById('emblemSearchInput').value = '';
            document.getElementById('emblemSearchClear').classList.add('hidden');
            renderEmblemChips();
            loadEmblemResults(false);
        }

        function onEmblemSearchInput() {
            const input = document.getElementById('emblemSearchInput');
            document.getElementById('emblemSearchClear').classList.toggle('hidden', !input.value);
            clearTimeout(emblemUI.debounce);
            ++emblemUI.token;
            emblemUI.query = input.value.trim();
            renderEmblemChips();
            if (emblemSetValue() === 'local') loadEmblemResults(false);
            else emblemUI.debounce = setTimeout(() => loadEmblemResults(false), 200);
        }

        function clearEmblemSearch() {
            clearTimeout(emblemUI.debounce);
            document.getElementById('emblemSearchInput').value = '';
            document.getElementById('emblemSearchClear').classList.add('hidden');
            emblemUI.query = '';
            renderEmblemChips();
            loadEmblemResults(false);
        }

        function reloadEmblemResults() {
            clearTimeout(emblemUI.debounce);
            loadEmblemResults(false);
        }

        function loadMoreEmblems() {
            loadEmblemResults(true);
        }

        function prepareEmblemSvg(text) {
            const ns = 'http://www.w3.org/2000/svg';
            const doc = new DOMParser().parseFromString(text, 'image/svg+xml');
            const source = doc.documentElement;
            if (source.localName !== 'svg' || source.namespaceURI !== ns || doc.querySelector('parsererror')) throw new Error('Invalid SVG');
            // Rebuild only passive vector geometry. Never insert arbitrary SVG markup.
            const tags = new Set(['svg', 'g', 'path', 'rect', 'circle', 'ellipse', 'line', 'polyline', 'polygon', 'defs', 'clipPath', 'mask', 'linearGradient', 'radialGradient', 'stop', 'title', 'desc']);
            const attrs = new Set(['viewBox', 'preserveAspectRatio', 'id', 'd', 'x', 'y', 'x1', 'x2', 'y1', 'y2', 'cx', 'cy', 'r', 'rx', 'ry', 'width', 'height', 'points', 'transform', 'fill', 'fill-rule', 'fill-opacity', 'stroke', 'stroke-width', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-opacity', 'opacity', 'clip-path', 'clip-rule', 'clipPathUnits', 'mask', 'maskUnits', 'maskContentUnits', 'gradientUnits', 'gradientTransform', 'spreadMethod', 'offset', 'stop-color', 'stop-opacity', 'fx', 'fy']);
            function clean(node) {
                if (node.namespaceURI !== ns || !tags.has(node.localName)) return null;
                const out = document.createElementNS(ns, node.localName);
                for (const attr of node.attributes) {
                    if (attr.namespaceURI || !attrs.has(attr.name)) continue;
                    const value = attr.value.trim();
                    if (/url\s*\(/i.test(value) && !/^url\(#[a-zA-Z_][\w.-]*\)$/.test(value)) continue;
                    if (/[\\<>]/.test(value) || /(?:javascript|data|https?):/i.test(value)) continue;
                    out.setAttribute(attr.name, value);
                }
                for (const child of node.children) {
                    const safe = clean(child);
                    if (safe) out.appendChild(safe);
                }
                if (node.localName === 'title' || node.localName === 'desc') out.textContent = node.textContent;
                return out;
            }
            const svg = clean(source);
            svg.setAttribute('width', '100%');
            svg.setAttribute('height', '100%');
            svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
            return new XMLSerializer().serializeToString(svg);
        }

        function applyEmblem(id, label, html) {
            const target = pendingNewLogo ? null : currentSymbolLogo();
            const artwork = { symbolId: id, label: label || id, html, image: null };
            const logo = target || createLogoElement(artwork);
            if (target) Object.assign(target, artwork);
            pendingNewLogo = false;
            activeSymbolLogoId = logo.id;
            currentSelectedElementId = logo.id;
            state.emblem = id;
            state.emblemLabel = label;
            state.emblemHtml = html;
            updateEmblemHighlight();
            updatePlaqueUI();
        }

        async function selectEmblem(id) {
            const selectionToken = ++emblemSelectionToken;
            document.getElementById('addLogoBtn').disabled = true;
            if (LOCAL_EMBLEMS[id]) {
                applyEmblem(id, emblemLabelFromId(id), localEmblemSvg(id));
                return;
            }
            if (id.startsWith('fa:')) {
                const n = id.slice(3);
                if (!EMBLEM_BUILTIN.includes(n)) return;
                applyEmblem(id, n.replace(/-/g, ' '), `<i class="fa-solid fa-${n}"></i>`);
                return;
            }
            if (!EMBLEM_ID_RE.test(id)) return;
            const status = document.getElementById('emblemStatus');
            try {
                let svg = emblemSvgCache.get(id);
                if (!svg) {
                    const [prefix, name] = id.split(':');
                    const res = await fetch(`${ICONIFY_API}/${prefix}/${name}.svg`);
                    if (!res.ok) throw new Error('SVG fetch failed: ' + res.status);
                    svg = prepareEmblemSvg(await res.text());
                    emblemSvgCache.set(id, svg);
                }
                if (selectionToken !== emblemSelectionToken) return;
                applyEmblem(id, emblemLabelFromId(id), svg);
            } catch (err) {
                console.error(err);
                if (selectionToken !== emblemSelectionToken) return;
                updateEmblemHighlight();
                status.textContent = 'Could not load this symbol (online library unavailable). Try again, or switch to the "Instant offline library" above.';
            }
        }

        function clearEmblem() {
            ++emblemSelectionToken;
            const target = currentSymbolLogo();
            if (!pendingNewLogo && target) {
                state.elements = state.elements.filter(el => el.id !== target.id);
                if (currentSelectedElementId === target.id) currentSelectedElementId = null;
                activeSymbolLogoId = null;
            }
            pendingNewLogo = false;
            updatePlaqueUI();
        }

        function setEmblem(emblemId) {   // Legacy name retained for compatibility.
            if (emblemId === 'none') clearEmblem();
            else selectEmblem(emblemId);
        }

        function initEmblemPicker() {
            const localOption = document.querySelector('#emblemSetSelect option[value="local"]');
            if (localOption) localOption.textContent = 'Instant offline library (' + Object.keys(LOCAL_EMBLEMS).length.toLocaleString() + ' symbols)';
            renderEmblemChips();
            loadEmblemResults(false);
            updateEmblemHighlight();
        }

        function initializeDesigner() {
            state.elements = defaultElementsForPlaque().filter(el => el.type !== 'text' || el.index < state.textLines.length);
            populateDimensionDropdowns();
            renderMaterials();
            renderFinishes();
            renderBorderStyles();
            renderMountingOptions();
            renderTextLinesInputs();
            initEmblemPicker();
            renderButterflyIcon();
            setShape(state.shape);
        }
        document.addEventListener('DOMContentLoaded', initializeDesigner, { once: true });

        function populateDimensionDropdowns() {
            const wSelect = document.getElementById('widthSelect');
            const hSelect = document.getElementById('heightSelect');
            let wOptions = '';
            let hOptions = '';
            for (let i = 3; i <= 100; i++) wOptions += `<option value="${i}">${i} inches</option>`;
            for (let i = 2; i <= 100; i++) hOptions += `<option value="${i}">${i} inches</option>`;
            wSelect.innerHTML = wOptions;
            hSelect.innerHTML = hOptions;
            wSelect.value = state.width;
            hSelect.value = state.height;
        }

        function switchTab(tabId) {
            ['shape', 'content', 'finish'].forEach(t => {
                document.getElementById(`tabContent-${t}`).classList.add('hidden');
                document.getElementById(`tabBtn-${t}`).className = "flex-1 py-3.5 text-xs font-bold uppercase tracking-wider text-slate-500 hover:text-slate-800 border-b-2 border-transparent flex flex-col items-center justify-center space-y-1 transition";
            });
            document.getElementById(`tabContent-${tabId}`).classList.remove('hidden');
            document.getElementById(`tabBtn-${tabId}`).className = "flex-1 py-3.5 text-xs font-bold uppercase tracking-wider text-amber-700 border-b-2 border-amber-600 flex flex-col items-center justify-center space-y-1 transition";
            const panel = document.querySelector('.studio-controls');
            if (panel && isMobileLayout()) panel.scrollTo({ top: 0, behavior: 'auto' });
            if (typeof setSheetState === 'function' && isMobileLayout() && document.body.classList.contains('sheet-min')) setSheetState('normal');
        }

        function updateDimensionsFromDropdowns() {
            const oldW = state.width;
            const oldH = state.height;
            state.width = parseInt(document.getElementById('widthSelect').value, 10);
            state.height = parseInt(document.getElementById('heightSelect').value, 10);
            if (state.shape === 'circle') {
                state.height = state.width;
                document.getElementById('heightSelect').value = state.width;
            }
            scaleElementsToPlaque(oldW, oldH, state.width, state.height);
            renderTextLinesInputs();   // Refresh font size selections after resizing the plaque.
            updatePlaqueUI();
        }

        function renderFinishes() {
            const grid = document.getElementById('finishesGrid');
            grid.innerHTML = finishes.map(f => `
                <button type="button" data-finish-id="${f.id}" onclick="setFinish('${f.id}', '${f.name}')" class="finish-tile p-3 rounded-xl border ${state.finish === f.id ? 'border-amber-600 ring-2 ring-amber-600/20' : 'border-slate-200 bg-white'} flex flex-col items-center space-y-2 hover:border-slate-300 transition text-left w-full shadow-sm">
                    <div class="w-full finish-sample finish-surface rounded-lg ${f.class} material-${state.material} border border-white/10 shadow-inner"></div>
                    <span class="text-[11px] font-medium text-slate-700 text-center">${f.name}</span>
                </button>
            `).join('');
        }

        function renderBorderStyles() {
            const grid = document.getElementById('borderStylesGrid');
            grid.innerHTML = borderStyles.map(b => `
                <button onclick="setBorderStyle('${b.id}')" class="border-style-tile p-2.5 rounded-xl border ${state.borderStyle === b.id ? 'border-amber-600 bg-amber-50 text-amber-800' : 'border-slate-200 bg-slate-50 text-slate-600'} flex flex-col items-center space-y-1 hover:border-slate-300 transition text-center shadow-sm">
                    <i class="fa-solid ${b.icon} text-base"></i>
                    <span class="text-[10px] font-medium leading-tight">${b.name}</span>
                </button>
            `).join('');
            syncBorderControls();
        }

        function renderMountingOptions() {
            const container = document.getElementById('mountingContainer');
            container.innerHTML = mountingOptions.map(m => `
                <label onclick="setMounting('${m.id}')" class="flex items-start space-x-3 p-3 rounded-xl border ${state.mounting === m.id ? 'border-amber-600 bg-amber-50' : 'border-slate-200 bg-slate-50'} cursor-pointer hover:border-slate-300 transition shadow-sm">
                    <input type="radio" name="mounting" ${state.mounting === m.id ? 'checked' : ''} class="mt-0.5 accent-amber-600">
                    <div>
                        <div class="text-xs font-bold text-slate-800">${m.name}</div>
                        <div class="text-[10px] text-slate-500">${m.desc}</div>
                    </div>
                </label>
            `).join('')
            + (state.mounting === 'screws' ? `
                <div class="p-3 rounded-xl border border-slate-200 bg-white shadow-sm">
                    <div class="text-xs font-bold text-slate-800 mb-2">Number of screws</div>
                    <div class="grid grid-cols-2 gap-2">
                        ${[4, 2].map(n => `<button type="button" onclick="setScrewCount(${n})" class="px-3 py-2 rounded-lg border text-xs font-semibold transition ${state.screwCount === n ? 'border-amber-600 bg-amber-50 text-amber-700' : 'border-slate-200 bg-slate-50 text-slate-600 hover:border-slate-300'}">${n} Screws<span class="block text-[10px] font-normal text-slate-500">${n === 4 ? 'All four corners' : 'Two screws, centred'}</span></button>`).join('')}
                    </div>
                    <div class="flex items-center justify-between gap-2 mt-2">
                        <span class="text-[10px] text-slate-500">Tip: drag a screw on the plaque to move it.</span>
                        ${(state.screwCustom || []).some(Boolean) ? '<button type="button" onclick="resetScrewPositions()" class="text-[10px] font-semibold text-amber-700 hover:underline whitespace-nowrap">Reset positions</button>' : ''}
                    </div>
                </div>` : '');
        }

        function resetScrewPositions() {
            state.screwCustom = [];
            renderMountingOptions();
            updatePlaqueUI();
        }

        function setScrewCount(n) {
            state.screwCount = n === 2 ? 2 : 4;
            state.screwCustom = [];
            renderMountingOptions();
            updatePlaqueUI();
        }

        function mountingLabel() {
            const m = (mountingOptions.find(o => o.id === state.mounting) || {}).name || state.mounting;
            return state.mounting === 'screws' ? m + ' - ' + (state.screwCount === 2 ? '2 screws' : '4 screws') : m;
        }

        function escapeHtmlAttribute(value) {
            return String(value).replace(/[&<>"']/g, char => ({
                '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
            })[char]);
        }

        function renderTextLinesInputs() {
            const container = document.getElementById('textLinesContainer');
            container.innerHTML = state.textLines.map((line, index) => `
                <div class="bg-white text-slate-800 p-4 rounded-xl border border-slate-200 shadow-sm space-y-3">
                    <div class="flex justify-between items-center">
                        <span class="text-amber-700 font-semibold text-sm">Line ${index + 1}</span>
                        <div class="flex items-center space-x-2">
                            <button onclick="moveTextLine(${index}, -1)" ${index === 0 ? 'disabled class="opacity-30 cursor-not-allowed"' : ''} class="w-6 h-6 rounded bg-slate-50 border border-slate-200 text-slate-600 text-xs flex items-center justify-center hover:bg-slate-200"><i class="fa-solid fa-arrow-up"></i></button>
                            <button onclick="moveTextLine(${index}, 1)" ${index === state.textLines.length - 1 ? 'disabled class="opacity-30 cursor-not-allowed"' : ''} class="w-6 h-6 rounded bg-slate-50 border border-slate-200 text-slate-600 text-xs flex items-center justify-center hover:bg-slate-200"><i class="fa-solid fa-arrow-down"></i></button>
                            <button onclick="removeTextLine(${index})" class="text-slate-500 hover:text-red-400 transition-colors">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div>
                        <input type="text" value="${escapeHtmlAttribute(line.text)}" oninput="updateLineText(${index}, this.value)" class="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-2 text-slate-800 text-sm focus:outline-none focus:border-amber-600" />
                    </div>

                    <div class="grid grid-cols-2 gap-3">
                        <div>
                            <label class="block text-xs text-slate-500 mb-1">Font Face</label>
                            <div class="relative">
                                <select onchange="updateLineFont(${index}, this.value)" class="w-full bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 text-slate-800 text-xs appearance-none focus:outline-none focus:border-amber-600">
                                    <option value="'Arial', sans-serif" ${line.fontFamily === "'Arial', sans-serif" ? 'selected' : ''}>Arial</option>
                                    <option value="'Copperplate Gothic', 'Copperplate Gothic Light', 'Copperplate Gothic Bold', serif" ${line.fontFamily === "'Copperplate Gothic', 'Copperplate Gothic Light', 'Copperplate Gothic Bold', serif" ? 'selected' : ''}>Copperplate Gothic</option>
                                    <option value="'Clarendon BT', serif" ${line.fontFamily === "'Clarendon BT', serif" ? 'selected' : ''}>Clarendon BT</option>
                                    <option value="'Cinzel', serif" ${line.fontFamily === "'Cinzel', serif" ? 'selected' : ''}>Cinzel (capital style)</option>
                                    <option value="'Trajan Pro', serif" ${line.fontFamily === "'Trajan Pro', serif" ? 'selected' : ''}>Trajan Pro (capitals only)</option>
                                    <option value="'Georgia', serif" ${line.fontFamily === "'Georgia', serif" ? 'selected' : ''}>Georgia</option>
                                    <option value="'Baskerville', serif" ${line.fontFamily === "'Baskerville', serif" ? 'selected' : ''}>Baskerville</option>
                                    <option value="'Magnolia Script', cursive" ${line.fontFamily === "'Magnolia Script', cursive" ? 'selected' : ''}>Magnolia Script</option>
                                </select>
                                <span class="absolute right-3 top-3 text-slate-500 pointer-events-none text-xs">▼</span>
                            </div>
                        </div>
                        <div>
                            <label class="block text-xs text-slate-500 mb-1">Font Size</label>
                            <div class="relative">
                                <select data-size-line="${index}" onchange="updateLineSize(${index}, this.value)" class="w-full bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 text-slate-800 text-xs appearance-none focus:outline-none focus:border-amber-600">
                                    ${Array.from({length: fontMaxPt() - fontMinPt() + 1}, (_, i) => i + fontMinPt()).map(pt => `
                                        <option value="${pt}pt" ${parseFloat(line.size) === pt ? 'selected' : ''}>${pt}pt</option>
                                    `).join('')}
                                </select>
                                <span class="absolute right-3 top-3 text-slate-500 pointer-events-none text-xs">▼</span>
                            </div>
                        </div>
                    </div>

                    <div class="flex justify-between items-center pt-2">
                        <div class="flex bg-slate-50 border border-slate-200 rounded-lg overflow-hidden p-0.5 gap-1">
                            <button onclick="updateLineAlign(${index}, 'left')" class="p-2 ${line.align === 'left' ? 'bg-amber-100 text-amber-800' : 'text-slate-500 hover:text-slate-800'} rounded">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M3 4h18v2H3V4zm0 5h12v2H3V9zm0 5h18v2H3v-2zm0 5h12v2H3v-2z"/></svg>
                            </button>
                            <button onclick="updateLineAlign(${index}, 'center')" class="p-2 ${line.align === 'center' ? 'bg-amber-100 text-amber-800' : 'text-slate-500 hover:text-slate-800'} rounded">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M3 4h18v2H3V4zm3 5h12v2H6V9zm-3 5h18v2H3v-2zm3 5h12v2H6v-2z"/></svg>
                            </button>
                            <button onclick="updateLineAlign(${index}, 'right')" class="p-2 ${line.align === 'right' ? 'bg-amber-100 text-amber-800' : 'text-slate-500 hover:text-slate-800'} rounded">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M3 4h18v2H3V4zm6 5h12v2H9V9zm-6 5h18v2H3v-2zm6 5h12v2H9v-2z"/></svg>
                            </button>
                        </div>

                        <div class="flex bg-slate-50 border border-slate-200 rounded-lg overflow-hidden p-0.5 text-xs gap-1">
                            <button onclick="updateLineStyle(${index}, 'norm')" class="px-3 py-1.5 ${line.style === 'norm' ? 'bg-amber-100 text-amber-800' : 'text-slate-500 hover:text-slate-800'} rounded">Norm</button>
                            <button onclick="updateLineStyle(${index}, 'bold')" class="px-3 py-1.5 ${line.style === 'bold' ? 'bg-amber-100 text-amber-800' : 'text-slate-500 hover:text-slate-800'} font-bold rounded">B</button>
                            <button onclick="updateLineStyle(${index}, 'italic')" class="px-3 py-1.5 ${line.style === 'italic' ? 'bg-amber-100 text-amber-800' : 'text-slate-500 hover:text-slate-800'} italic rounded">I</button>
                        </div>
                    </div>

                    <div class="pt-1">
                        <div class="flex items-center justify-between mb-1">
                            <label class="text-xs text-slate-500">Text Curve</label>
                            <div class="flex items-center gap-2">
                                <span id="curveVal-${index}" class="text-[11px] font-semibold text-slate-700">${curveLabel(line.curve)}</span>
                                <button type="button" onclick="updateLineCurve(${index}, 0, true)" class="text-[10px] font-semibold text-amber-700 hover:underline">Straight</button>
                            </div>
                        </div>
                        <input id="curveRange-${index}" type="range" min="-100" max="100" step="1" value="${line.curve || 0}" oninput="updateLineCurve(${index}, this.value)" class="w-full accent-amber-600 cursor-pointer">
                        <div class="flex justify-between text-[10px] text-slate-400"><span>Smile (curve down)</span><span>Arch (curve up)</span></div>
                    </div>
                </div>
            `).join('');
            syncTextSizeSelects();   // show the size actually used on the plaque, not just the starting size
        }

        function curveLabel(c) {
            c = Math.round(Number(c) || 0);
            return c === 0 ? 'Straight' : (c > 0 ? 'Arch ' + c + '%' : 'Smile ' + (-c) + '%');
        }

        function updateLineCurve(index, val, syncSlider) {
            const line = state.textLines[index];
            if (!line) return;
            line.curve = Math.max(-100, Math.min(100, Math.round(Number(val) || 0)));
            resetTextFit(index);
            updatePlaqueUI();
            const lab = document.getElementById('curveVal-' + index);
            if (lab) lab.textContent = curveLabel(line.curve);
            const rng = document.getElementById('curveRange-' + index);
            if (rng && (syncSlider || rng.value !== String(line.curve))) rng.value = line.curve;
            if (inlineEditor && inlineEditor.index === index) inlineEditor.sync();
        }

        function setShape(shapeId, showReference = false) {
            if (shapeEdit.active) { shapeEdit.active = false; shapeEdit.sel = -1; shapeEdit.drag = -1; syncShapeEditUI(); }
            state.shape = shapeId;
            state.screwCustom = [];
            if (shapeId !== 'rect-sharp' && state.borderStyle === 'square-rounded') {
                state.borderStyle = 'plain';
                renderBorderStyles();
            }
            document.querySelectorAll('.shape-btn').forEach(btn => {
                btn.className = "shape-btn p-2.5 rounded-xl border border-slate-200 bg-slate-50 text-slate-600 flex flex-col items-center space-y-1.5 hover:border-slate-300 transition shadow-sm";
            });
            const activeBtn = document.getElementById(`shape-${shapeId}`);
            if (activeBtn) {
                activeBtn.className = "shape-btn p-2.5 rounded-xl border border-amber-600 bg-amber-50 text-amber-800 flex flex-col items-center space-y-1.5 transition shadow-sm";
            }

            if(shapeId === 'circle') {
                const oldH = state.height;
                state.height = state.width;
                document.getElementById('heightSelect').value = state.width;
                scaleElementsToPlaque(state.width, oldH, state.width, state.height);
                renderTextLinesInputs();
            }
            updatePlaqueUI();
            if (showReference) openShapePhoto(shapeId);
        }

        function borderThicknessPt() {
            // Use the plaque's physical scale, as plaqueFontPx does for lettering.
            return Number((Math.max(MIN_BORDER_PX, state.borderThickness) * 72 / PX_PER_INCH).toFixed(2));
        }

        function innerBorderThicknessPt() {
            return Number((Math.max(MIN_BORDER_PX, state.innerBorderThickness) * 72 / PX_PER_INCH).toFixed(2));
        }

        // Double Inset ('bar') and Wide Inset ('square') have a second, inner border line.
        function hasInnerBorder() {
            return state.borderStyle === 'bar' || state.borderStyle === 'square';
        }

        function borderLabel() {
            const style = borderStyles.find(border => border.id === state.borderStyle);
            const name = style ? style.name : state.borderStyle;
            if (state.borderStyle === 'none') return name;
            if (hasInnerBorder()) return name + ' (outer ' + borderThicknessPt() + ' pt, inner ' + innerBorderThicknessPt() + ' pt)';
            return name + ' (' + borderThicknessPt() + ' pt)';
        }

        // Space kept free of text: outer border and, for the two inset styles, the thicker inner line too.
        function borderTextMargin() {
            const t = Math.max(MIN_BORDER_PX, state.borderThickness);
            let margin = Math.max(6, t + 4);
            if (hasInnerBorder()) {
                const innerW = Math.max(MIN_BORDER_PX, state.innerBorderThickness);
                const outerLine = state.borderStyle === 'square' ? Math.max(3, t / 2) : Math.max(2, t / 2);
                const gap = state.borderStyle === 'square' ? 7 : 6;
                // plaque edge -> thin rim (3) -> outer line -> gap -> inner line -> small breathing room (4)
                margin = Math.max(margin, 3 + outerLine + gap + innerW + 4);
            }
            return margin;
        }

        function syncBorderControls() {
            const setText = (id, text) => { const el = document.getElementById(id); if (el) el.innerText = text; };
            const outer = document.getElementById('borderThicknessInput');
            const inner = document.getElementById('innerBorderThicknessInput');
            const box = document.getElementById('innerBorderControl');
            if (outer) { outer.min = MIN_BORDER_PX; outer.value = state.borderThickness; }
            if (inner) { inner.min = MIN_BORDER_PX; inner.value = state.innerBorderThickness; }
            setText('borderThicknessVal', borderThicknessPt() + ' pt');
            setText('innerBorderThicknessVal', innerBorderThicknessPt() + ' pt');
            if (box) box.classList.toggle('hidden', !hasInnerBorder());
        }

        function updateBorderThickness() {
            const value = parseInt(document.getElementById('borderThicknessInput').value);
            state.borderThickness = Math.max(MIN_BORDER_PX, isNaN(value) ? MIN_BORDER_PX : value);   // never below 16 pt
            syncBorderControls();
            updatePlaqueUI();
        }

        function updateInnerBorderThickness() {
            const value = parseInt(document.getElementById('innerBorderThicknessInput').value);
            state.innerBorderThickness = Math.max(MIN_BORDER_PX, isNaN(value) ? MIN_BORDER_PX : value);   // never below 16 pt
            syncBorderControls();
            updatePlaqueUI();
        }

        function setBorderStyle(borderId) {
            // This frame requires a square-cornered rectangular outline.
            if (borderId === 'square-rounded' && state.shape !== 'rect-sharp') setShape('rect-sharp');
            state.borderStyle = borderId;
            renderBorderStyles();
            updatePlaqueUI();
        }

        const finishReferencePhotos = (window.PLAQUE_ASSETS && window.PLAQUE_ASSETS.finishes) || {};
        let finishPhotoReturnTarget = null;

        function openFinishPhoto(finishId) {
            const finish = finishes.find(item => item.id === finishId);
            if (!finish || !finishReferencePhotos[finishId]) return;
            const dialog = document.getElementById('finishPhotoDialog');
            finishPhotoReturnTarget = document.querySelector('[data-finish-id="' + finishId + '"]');
            document.getElementById('finishPhotoTitle').textContent = finish.name;
            document.getElementById('referencePhotoEyebrow').textContent = 'Actual Finish Reference';
            document.getElementById('finishPhotoDescription').textContent = 'A real plaque showing your selected finish. The photograph illustrates the surface finish; your shape, text, and logos follow your design. Tone and texture may vary slightly with lighting and casting.';
            document.getElementById('shapeReferenceOutline').style.display = 'none';
            document.getElementById('finishPhotoImage').style.display = 'block';
            const photo = document.getElementById('finishPhotoImage');
            const error = document.getElementById('finishPhotoError');
            error.hidden = true;
            photo.hidden = false;
            photo.onload = () => { error.hidden = true; };
            photo.onerror = () => { error.hidden = false; };
            photo.alt = 'Actual ' + finish.name + ' finish on a completed plaque';
            photo.src = finishReferencePhotos[finishId];
            if (!dialog.open) dialog.showModal();
        }

        // Add further original product photos here when they are supplied.
        const shapeReferencePhotos = (window.PLAQUE_ASSETS && window.PLAQUE_ASSETS.shapes) || {};
        const shapeReferencePhotoKeys = {
            'rect-sharp': 'finish-brass',
            'tabbed-arch': 'finish-dark-bronze'
        };

        function openShapePhoto(shapeId) {
            const button = document.getElementById('shape-' + shapeId);
            if (!button) return;
            const label = button.querySelector('span').textContent.trim();
            const dialog = document.getElementById('finishPhotoDialog');
            const photo = document.getElementById('finishPhotoImage');
            const outline = document.getElementById('shapeReferenceOutline');
            const source = shapeReferencePhotos[shapeId] || finishReferencePhotos[shapeReferencePhotoKeys[shapeId]];
            finishPhotoReturnTarget = button;
            document.getElementById('finishPhotoTitle').textContent = label;
            document.getElementById('finishPhotoError').hidden = true;
            document.getElementById('referencePhotoEyebrow').textContent = source ? 'Actual Shape Reference' : 'Shape Outline Preview';
            photo.style.display = source ? 'block' : 'none';
            outline.style.display = source ? 'none' : 'block';
            if (source) {
                photo.alt = 'Original plaque photograph showing the ' + label + ' shape';
                photo.onload = () => { document.getElementById('finishPhotoError').hidden = true; };
                photo.onerror = () => { document.getElementById('finishPhotoError').hidden = false; };
                photo.src = source;
            } else {
                photo.onload = null;
                photo.onerror = null;
                photo.removeAttribute('src');
                const w = 432, h = shapeId === 'circle' ? 432 : 320;
                outline.setAttribute('viewBox', '-16 -16 ' + (w + 32) + ' ' + (h + 32));
                outline.innerHTML = '<path d="' + getShapePathD(w, h, shapeId, 0) + '" fill="#ddd0a6" stroke="#756443" stroke-width="2" stroke-linejoin="miter"/>';
            }
            document.getElementById('finishPhotoDescription').textContent = source
                ? 'An original plaque showing this shape. The reference has its own text and finish; your plaque follows the dimensions and design you choose.'
                : 'Illustrated outline only. An original plaque photograph for this shape has not been added yet.';
            if (!dialog.open) dialog.showModal();
        }

        function closeFinishPhoto() {
            document.getElementById('finishPhotoDialog').close();
        }

        document.getElementById('finishPhotoDialog').addEventListener('close', () => {
            if (finishPhotoReturnTarget && finishPhotoReturnTarget.isConnected) finishPhotoReturnTarget.focus();
        });
        document.getElementById('finishPhotoDialog').addEventListener('click', event => {
            if (event.target !== event.currentTarget) return;
            const bounds = event.currentTarget.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeFinishPhoto();
        });

        function setFinish(finishId, finishName) {
            const chosen = finishes.find(item => item.id === finishId);
            if (!chosen) return;
            state.surfaceMode = 'finish';
            state.finish = finishId;
            state.finishName = chosen.name;
            renderFinishes();
            updatePlaqueUI();
            openFinishPhoto(finishId);
        }

        function setDesignDepth(depth) {
            if (!['2d', '3d'].includes(depth)) return;
            state.designDepth = depth;
            updatePlaqueUI();
        }

        function renderDesignDepth() {
            ['2d', '3d'].forEach(depth => {
                const button = document.getElementById('depth-' + depth);
                const active = state.designDepth === depth;
                button.setAttribute('aria-pressed', String(active));
                button.className = 'depth-btn p-3.5 rounded-xl border flex flex-col items-center gap-1.5 transition ' + (active ? 'border-amber-600 bg-amber-50 text-amber-800' : 'border-slate-200 bg-slate-50 text-slate-600 hover:border-slate-300');
            });
        }

        function logoDepthFilter() {
            if (state.designDepth === '3d') return state.relief === 'raised'
                ? 'drop-shadow(0 -1px 0 rgba(255,255,255,.4)) drop-shadow(2px 2px 0 rgba(70,53,28,.8)) drop-shadow(3px 4px 2px rgba(0,0,0,.6))'
                : 'drop-shadow(0 1px 0 rgba(255,255,255,.4)) drop-shadow(-2px -2px 2px rgba(0,0,0,.8))';
            return state.relief === 'raised'
                ? 'drop-shadow(1px 1px 0 rgba(255,255,255,0.25)) drop-shadow(-1px -1px 1px rgba(0,0,0,0.9))'
                : 'drop-shadow(0 1px 1px rgba(255,255,255,0.35)) drop-shadow(0 -1px 1px rgba(0,0,0,0.95))';
        }

        function setReliefStyle(reliefId) {
            state.relief = reliefId;
            document.querySelectorAll('.relief-btn').forEach(btn => {
                btn.className = "relief-btn p-3.5 rounded-xl border border-slate-200 bg-slate-50 text-slate-600 flex flex-col items-center space-y-1.5 hover:border-slate-300 transition shadow-sm";
            });
            document.getElementById(`relief-${reliefId}`).className = "relief-btn p-3.5 rounded-xl border border-amber-600 bg-amber-50 text-amber-800 flex flex-col items-center space-y-1.5 transition shadow-sm";
            updatePlaqueUI();
        }

        let nextLogoId = 1;
        let pendingNewLogo = false;
        let activeSymbolLogoId = null;

        function currentSymbolLogo() {
            return state.elements.find(el => el.id === activeSymbolLogoId && el.type === 'emblem' && !el.image)
                || state.elements.filter(el => el.type === 'emblem' && !el.image).at(-1);
        }

        function syncSymbolTarget() {
            const selected = state.elements.find(el => el.id === currentSelectedElementId && el.type === 'emblem' && !el.image);
            if (selected && (selected.id !== activeSymbolLogoId || pendingNewLogo)) {
                ++emblemSelectionToken;
                pendingNewLogo = false;
                activeSymbolLogoId = selected.id;
            }
            const target = pendingNewLogo ? null : currentSymbolLogo();
            state.emblem = target ? target.symbolId : 'none';
            state.emblemLabel = target ? target.label : '';
            state.emblemHtml = target ? target.html : '';
            updateEmblemHighlight();
        }

        function createLogoElement(artwork) {
            const { w, h } = plaqueSizePx();
            const count = state.elements.filter(el => el.type === 'emblem').length;
            const size = Math.max(20, Math.min(w * .18, h * .22));
            const step = (count % 5) * Math.min(18, size * .25);
            const el = { id: 'logo-' + nextLogoId++, type: 'emblem', x: (w - size) / 2 + step, y: h * .08 + step, w: size, h: size, ...artwork };
            constrainElementPosition(el);
            state.elements.push(el);
            currentSelectedElementId = el.id;
            return el;
        }

        function addLogo() {
            if (!currentSymbolLogo() || pendingNewLogo) return;
            ++emblemSelectionToken;
            pendingNewLogo = true;
            currentSelectedElementId = null;
            updatePlaqueUI();
        }

        function selectLogo(id) {
            if (!state.elements.some(el => el.id === id && el.type === 'emblem')) return;
            currentSelectedElementId = id;
            updatePlaqueUI();
        }

        function removeLogo(id) {
            ++emblemSelectionToken;
            if (activeSymbolLogoId === id) activeSymbolLogoId = null;
            state.elements = state.elements.filter(el => !(el.id === id && el.type === 'emblem'));
            if (currentSelectedElementId === id) currentSelectedElementId = null;
            updatePlaqueUI();
        }

        function renderLogoLists() {
            syncSymbolTarget();
            const logos = state.elements.filter(el => el.type === 'emblem');
            const row = el => {
                const selected = el.id === currentSelectedElementId;
                const label = escapeHtmlAttribute(el.label);
                const preview = el.image ? `<img src="${escapeHtmlAttribute(el.image)}" alt="" class="w-full h-full object-contain">` : el.html;
                return `<div class="flex items-center gap-2 p-2 rounded-lg border ${selected ? 'border-amber-600 bg-amber-50' : 'border-slate-200 bg-white'}">
                    <button type="button" onclick="selectLogo('${el.id}')" aria-pressed="${selected}" class="flex items-center gap-2 flex-1 min-w-0 text-left" title="Select ${label}">
                        <span class="w-8 h-8 shrink-0 pointer-events-none text-slate-700 flex items-center justify-center">${preview}</span>
                        <span class="text-xs text-slate-700 truncate">${label}</span>
                    </button>
                    <button type="button" onclick="removeLogo('${el.id}')" class="px-2 py-2 text-xs font-medium text-rose-700 hover:bg-rose-50" aria-label="Remove ${label}">Remove</button>
                </div>`;
            };
            document.getElementById('addedLogosList').innerHTML = logos.filter(el => !el.image).map(row).join('');
            document.getElementById('uploadedLogosList').innerHTML = logos.filter(el => el.image).map(row).join('');
        }

        function readLogoFile(file) {
            return new Promise((resolve, reject) => {
                if (!file.type.startsWith('image/')) { reject(new Error('Please choose an image file.')); return; }
                const reader = new FileReader();
                reader.onerror = () => reject(new Error('Could not read ' + file.name));
                reader.onload = () => {
                    const image = new Image();
                    image.onload = () => resolve({ image: reader.result, label: file.name, html: '', symbolId: null });
                    image.onerror = () => reject(new Error('Could not open ' + file.name + '. Please choose a supported image format.'));
                    image.src = reader.result;
                };
                reader.readAsDataURL(file);
            });
        }

        async function handleImageUpload(event) {
            const files = Array.from(event.target.files || []);
            event.target.value = '';
            if (!files.length) return;
            const results = await Promise.allSettled(files.map(readLogoFile));
            let added = 0;
            results.forEach(result => {
                if (result.status === 'fulfilled') { createLogoElement(result.value); added++; }
            });
            updatePlaqueUI();
            const failed = results.length - added;
            showNotification(added + ' image logo(s) added.' + (failed ? ' ' + failed + ' file(s) could not be opened. Please choose supported image files.' : ''));
        }

        function setMounting(mountId) {
            state.mounting = mountId;
            renderMountingOptions();
            updatePlaqueUI();
        }

        function addTextBlock() {
            const { w, h } = plaqueSizePx();
            const mx = w * 0.08;
            const fontPx = plaqueFontPx(fontMinPt() + 'pt');
            state.elements = state.elements.filter(el => el.type !== 'text' || el.index < state.textLines.length);
            const lastText = [...state.elements].reverse().find(el => el.type === 'text');
            const y = lastText ? lastText.y + lastText.h + 6 : h * 0.5;
            state.textLines.push({ text: "New custom text", size: fontMinPt() + 'pt', weight: "font-medium", align: "center", style: "norm", fontFamily: state.fontFamily });
            state.elements.push({
                id: `text-${nextTextElementId++}`,
                type: 'text',
                index: state.textLines.length - 1,
                x: mx,
                y: Math.min(y, Math.max(4, h - fontPx * 1.6)),
                w: w - mx * 2,
                h: Math.max(fontPx * 1.5, h * 0.08),
                userSized: false
            });
            renderTextLinesInputs();
            updatePlaqueUI();
        }

        function removeTextLine(index) {
            const removed = state.elements.find(el => el.type === 'text' && el.index === index);
            if (removed && currentSelectedElementId === removed.id) currentSelectedElementId = null;
            state.textLines.splice(index, 1);
            state.elements = state.elements.filter(el => !(el.type === 'text' && el.index === index));
            state.elements.forEach(el => {
                if(el.type === 'text' && el.index > index) el.index--;
            });
            renderTextLinesInputs();
            updatePlaqueUI();
        }

        function moveTextLine(index, direction) {
            const newIndex = index + direction;
            if(newIndex >= 0 && newIndex < state.textLines.length) {
                const temp = state.textLines[index];
                state.textLines[index] = state.textLines[newIndex];
                state.textLines[newIndex] = temp;
                renderTextLinesInputs();
                updatePlaqueUI();
            }
        }

        function updateLineText(index, val) { 
            state.textLines[index].text = val;
            resetTextFit(index);
            updatePlaqueUI(); 
        }

        function updateLineSize(index, val) {
            state.textLines[index].size = val;
            resetTextFit(index);
            updatePlaqueUI();
        }

        function updateLineFont(index, val) {
            state.textLines[index].fontFamily = val;
            resetTextFit(index);
            updatePlaqueUI();
        }

        function updateLineAlign(index, align) {
            state.textLines[index].align = align;
            const el = state.elements.find(item => item.type === 'text' && item.index === index);
            if (el) {
                const { w } = plaqueSizePx();
                const margin = borderTextMargin();
                el.x = margin;
                el.w = Math.max(1, w - margin * 2);
            }
            resetTextFit(index);
            renderTextLinesInputs();
            updatePlaqueUI();
        }

        function updateLineStyle(index, style) {
            state.textLines[index].style = style;
            resetTextFit(index);
            renderTextLinesInputs();
            updatePlaqueUI();
        }

        // ===== Preview auto-fit + measuring rulers =====
        // The plaque model uses 36 pixels per inch. Scale the preview to fit
        // the available screen area while keeping small plaques readable.
        const PREVIEW_BASE_ZOOM = 2;          // Default zoom: 2x, or 72 screen pixels per inch.
        const PREVIEW_MIN_LONG_SIDE = 360;    // Preferred minimum long side in screen pixels.
        const PREVIEW_MAX_ZOOM = 12;
        // Mobile (<1024px, same breakpoint as Tailwind "lg") uses a compact layout, so it needs smaller reserves.
        const MOBILE_MQ = window.matchMedia('(max-width: 1023.98px)');
        const isMobileLayout = () => MOBILE_MQ.matches;
        const PV = () => {
            if (!isMobileLayout()) return { ruler: 56, top: 72, bottom: 96, side: 24 };
            const bar = document.getElementById('shapeEditBar');
            const editing = bar && !bar.classList.contains('hidden');   // hint bar sits at the bottom while editing the outline
            return { ruler: 38, top: 52, bottom: editing ? 84 : 8, side: 8 };
        };
        let userZoom = isMobileLayout() ? 1 : 1.5;   // User zoom multiplier applied after automatic fitting.
        let previewScale = 1;    // final scale = auto-fit * userZoom
        let panX = 0, panY = 0;  // Manual pan (screen px), used on touch screens after zooming in.

        function fitPreview() {
            const main = document.querySelector('main');
            const wrap = document.getElementById('previewWrapper');
            const plaque = document.getElementById('plaqueObject');
            if (!main || !wrap || !plaque) return;
            const R = PV();
            const mobile = isMobileLayout();
            const W = state.width * PX_PER_INCH;
            const H = state.height * PX_PER_INCH;
            const availW = Math.max(100, main.clientWidth - 2 * R.side - 2 * R.ruler);
            const availH = Math.max(80, main.clientHeight - R.top - R.bottom - 2 * R.ruler);
            const fit = Math.min(availW / W, availH / H);
            // Desktop keeps the "readable minimum" zoom. On mobile we simply fit the whole plaque on screen.
            const want = mobile ? fit : Math.min(PREVIEW_MAX_ZOOM, Math.max(PREVIEW_BASE_ZOOM, PREVIEW_MIN_LONG_SIDE / Math.max(W, H)));
            previewScale = Math.min(fit, want) * userZoom;
            const pad = R.ruler / previewScale;
            wrap.style.padding = pad + 'px';
            wrap.style.width = (W + 2 * pad) + 'px';
            wrap.style.height = (H + 2 * pad) + 'px';
            const px = mobile ? panX : 0, py = mobile ? panY : 0;
            wrap.style.transform = `translate(${px}px, ${(R.top - R.bottom) / 2 + py}px) scale(${previewScale})`;
            plaque.style.flexShrink = '0';
            wrap.style.setProperty('--inv', (1 / previewScale).toFixed(4));
            renderRulers(W, H, pad);
        }

        function renderRulers(W, H, pad) {
            const svg = document.getElementById('plaqueRulerSvg');
            if (!svg) return;
            const u = 1 / previewScale;                 // One screen pixel expressed in plaque units.
            svg.style.left = pad + 'px';
            svg.style.top = pad + 'px';
            svg.style.width = W + 'px';
            svg.style.height = H + 'px';
            svg.setAttribute('viewBox', `0 0 ${W} ${H}`);

            // Dimension lines with end caps and centered rounded labels.
            const col = '#cdbf9f', txt = '#3f3a2e', sw = 1.4 * u, cap = 6 * u, gap = 24 * u, fs = 12 * u;
            const line = (x1, y1, x2, y2) => `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="${col}" stroke-width="${sw}" stroke-linecap="butt"/>`;
            const pill = (cx, cy, t) => {
                const w = (t.length * 7.2 + 18) * u, h = 20 * u;
                return `<rect x="${cx - w / 2}" y="${cy - h / 2}" width="${w}" height="${h}" rx="${h / 2}" fill="#fff" stroke="${col}" stroke-width="${sw}"/>`
                     + `<text x="${cx}" y="${cy + fs * 0.36}" font-size="${fs}" text-anchor="middle" fill="${txt}" font-family="Montserrat, sans-serif" font-weight="500">${t}</text>`;
            };

            const wTxt = state.width + '"', hTxt = state.height + '"';
            const yTop = -gap, xRight = W + gap;
            let g = '';
            // Top: width
            g += line(0, yTop, W, yTop) + line(0, yTop - cap, 0, yTop + cap) + line(W, yTop - cap, W, yTop + cap) + pill(W / 2, yTop, wTxt);
            // Right: height
            g += line(xRight, 0, xRight, H) + line(xRight - cap, 0, xRight + cap, 0) + line(xRight - cap, H, xRight + cap, H) + pill(xRight, H / 2, hTxt);
            svg.innerHTML = g;
        }

        function zoomPreview(delta) {
            userZoom = Math.max(0.4, Math.min(isMobileLayout() ? 4 : 3, userZoom + delta));
            fitPreview();
            renderShapeEditOverlay();
        }
        function resetZoom() {
            userZoom = 1;
            panX = 0; panY = 0;
            fitPreview();
            renderShapeEditOverlay();
        }

        // Arch (Dome): outline traced from the reference artwork (coordinates are pixels of the source image)
        const ARCH_REF = {
            x0: 29, width: 1263.5, y0: 16.5, height: 1095, flatY: 291,
            // left half of the top profile: S-curve, shoulder/notch fillet, dome (cubic Béziers)
            segs: [
                [[128.45, 291], [241.55, 291], [241.3, 133], [445.62, 133]],
                [[445.62, 133], [450.17, 133], [454.27, 130.24], [455.98, 126.03]],
                [[455.98, 126.03], [475.6, 77.65], [508.08, 16.5], [660.75, 16.5]]
            ]
        };

        function segIntersect(p1, p2, p3, p4) {
            const d1x = p2[0] - p1[0], d1y = p2[1] - p1[1], d2x = p4[0] - p3[0], d2y = p4[1] - p3[1];
            const den = d1x * d2y - d1y * d2x;
            if (Math.abs(den) < 1e-12) return null;
            const t = ((p3[0] - p1[0]) * d2y - (p3[1] - p1[1]) * d2x) / den;
            const u = ((p3[0] - p1[0]) * d1y - (p3[1] - p1[1]) * d1x) / den;
            if (t > 1e-9 && t < 1 - 1e-9 && u > 1e-9 && u < 1 - 1e-9) return [p1[0] + t * d1x, p1[1] + t * d1y];
            return null;
        }

        // An inward offset larger than the local radius of curvature folds into a small loop.
        // Cutting the loop at its self-intersection gives the true offset outline (a clean corner, no stray spikes).
        function trimLoops(pts, maxSpan) {
            for (let i = 0; i < pts.length - 3; i++) {
                const jEnd = Math.min(pts.length - 2, i + maxSpan);
                for (let j = jEnd; j >= i + 2; j--) {
                    const X = segIntersect(pts[i], pts[i + 1], pts[j], pts[j + 1]);
                    if (X) { pts.splice(i + 1, j - i, X); break; }
                }
            }
            return pts;
        }

        // Builds the outline offset inward by `inset` px (inset = 0 gives the plaque edge itself).
        // Curved parts are offset along their true normals, so a border line stays parallel to the edge.
        function archPath(w, h, inset) {
            const ref = ARCH_REF;
            const sx = x => (x - ref.x0) / ref.width * w;
            const sy = y => (y - ref.y0) / ref.height * h;
            const Rc = Math.max(8, Math.min(24, Math.min(w, h) * 0.035)); // corner radius of the outer edge
            const Rin = Math.max(0, Rc - inset);                          // concentric inner corner radius
            const yF = sy(ref.flatY);                                     // height of the flat side tops
            const N = 64;
            const f = n => n.toFixed(2);

            const half = [];
            ref.segs.forEach((seg, si) => {
                const P = seg.map(([x, y]) => [sx(x), sy(y)]);
                for (let i = (si === 0 ? 0 : 1); i <= N; i++) {
                    const t = i / N, u = 1 - t;
                    const x = u*u*u*P[0][0] + 3*u*u*t*P[1][0] + 3*u*t*t*P[2][0] + t*t*t*P[3][0];
                    const y = u*u*u*P[0][1] + 3*u*u*t*P[1][1] + 3*u*t*t*P[2][1] + t*t*t*P[3][1];
                    const dx = 3 * (u*u*(P[1][0]-P[0][0]) + 2*u*t*(P[2][0]-P[1][0]) + t*t*(P[3][0]-P[2][0]));
                    const dy = 3 * (u*u*(P[1][1]-P[0][1]) + 2*u*t*(P[2][1]-P[1][1]) + t*t*(P[3][1]-P[2][1]));
                    const len = Math.hypot(dx, dy) || 1;
                    half.push([x - dy / len * inset, y + dx / len * inset]); // inward normal = (-ty, tx)
                }
            });
            const mirrored = half.slice().reverse().map(([x, y]) => [w - x, y]).slice(1);
            let top = half.concat(mirrored);
            if (inset > 0) top = trimLoops(top, 260);

            let d = `M ${f(inset)} ${f(h - inset - Rin)} L ${f(inset)} ${f(yF + inset + Rin)} `
                  + `A ${f(Rin)} ${f(Rin)} 0 0 1 ${f(inset + Rin)} ${f(yF + inset)} `;
            top.forEach(([x, y]) => { d += `L ${f(x)} ${f(y)} `; });
            d += `L ${f(w - inset - Rin)} ${f(yF + inset)} `
               + `A ${f(Rin)} ${f(Rin)} 0 0 1 ${f(w - inset)} ${f(yF + inset + Rin)} `
               + `L ${f(w - inset)} ${f(h - inset - Rin)} `
               + `A ${f(Rin)} ${f(Rin)} 0 0 1 ${f(w - inset - Rin)} ${f(h - inset)} `
               + `L ${f(inset + Rin)} ${f(h - inset)} `
               + `A ${f(Rin)} ${f(Rin)} 0 0 1 ${f(inset)} ${f(h - inset - Rin)} Z`;
            return d;
        }

        // Butterfly Corner Banner: traced from the reference artwork (units = source-image pixels,
        // origin = top-left of the butterfly's outer outline). `lines` = black linework, `sil` = outer silhouette.
        const BF_REF = {
            w: 434.3, h: 419.0, X0: 163.0, Y0: 144.7, topStart: 386.0, leftStart: 375.7, r: 8, sw: 9,
            lines: "M87.0 384.7L83.0 388.0L82.7 391.7L86.3 395.3L90.3 395.3L93.3 392.7L94.0 388.7L91.3 385.3ZM88.0 387.3L89.7 387.7L90.7 389.0L90.7 390.7L89.3 392.0L88.0 392.0L86.7 390.7L86.7 388.7ZM77.0 352.7L75.3 355.0L76.3 358.7L78.0 360.3L82.0 360.0L83.7 358.0L83.3 355.3L79.3 352.3ZM79.7 354.7L81.7 356.0L80.7 358.3L79.3 358.3L78.3 357.0ZM44.7 322.0L40.3 323.3L36.7 322.7L38.3 325.3L42.0 326.0L44.3 324.3ZM213.0 315.7L211.3 315.7L205.3 318.7L198.7 324.3L211.7 318.0ZM297.7 292.7L294.7 292.0L291.7 294.0L290.7 297.3L292.7 299.7L295.3 299.7L298.0 298.0L299.3 295.0ZM296.3 294.0L297.0 295.7L294.7 297.0L293.7 295.7L294.7 294.3ZM310.3 108.7L307.0 111.7L306.7 115.0L309.3 118.0L312.7 118.7L315.3 116.7L316.3 114.7L316.3 111.0L313.7 108.7ZM311.3 111.3L313.3 112.3L313.3 114.0L312.0 115.0L310.0 113.7L310.3 112.0ZM323.7 87.7L320.7 90.3L320.3 93.7L323.0 97.0L327.3 97.3L330.7 94.3L330.3 90.7L329.0 88.7L327.0 87.7ZM324.0 91.7L326.0 91.0L327.3 92.3L327.0 93.7L325.0 94.3L323.7 93.0ZM184.3 61.0L181.7 64.3L182.3 68.0L186.0 70.3L190.7 69.7L192.7 67.3L193.0 64.7L192.3 63.3L189.0 60.7ZM186.7 63.7L188.0 63.7L189.3 65.0L187.7 67.7L186.7 67.7L185.3 66.0ZM201.7 57.7L197.7 59.7L195.0 62.7L195.0 64.0L198.3 68.3L203.3 69.0L206.7 66.3L207.0 63.3L205.7 60.3ZM201.0 59.3L203.0 59.3L205.3 62.3L205.0 64.7L203.0 66.7L201.0 66.7L198.7 63.7L198.7 61.3ZM189.3 46.7L186.7 49.0L186.0 52.7L189.0 57.0L192.3 57.3L196.0 55.0L197.0 53.0L197.0 50.3L195.0 47.7L193.0 46.7ZM190.0 49.7L192.7 49.7L194.0 51.3L193.7 52.7L190.7 53.7L189.3 52.3ZM368.0 41.7L358.3 35.7L351.3 33.7L339.3 34.3L328.7 38.7L321.3 43.7L312.0 52.7L299.0 69.3L289.7 84.3L288.0 85.0L276.7 62.3L268.3 49.0L258.7 36.3L243.7 20.0L228.0 7.7L219.0 3.0L213.0 1.0L207.7 0.0L200.3 0.0L195.0 1.0L186.7 4.3L180.0 9.0L175.0 14.0L168.3 24.3L163.3 38.3L160.3 55.0L158.0 83.0L154.3 109.3L150.0 125.0L144.3 137.0L137.7 146.7L129.7 154.7L106.7 172.3L97.0 182.3L91.3 193.3L89.3 200.3L88.0 209.7L88.7 220.0L88.0 221.3L76.3 222.3L60.7 226.7L51.7 230.7L40.7 238.3L36.0 243.0L31.0 251.3L28.0 263.0L28.0 270.0L30.0 280.7L19.3 287.3L10.0 295.7L4.3 304.0L1.0 312.7L0.0 318.3L0.0 325.7L3.3 339.0L8.0 348.7L14.0 356.7L22.7 365.0L28.7 369.0L43.0 375.3L44.0 385.7L47.0 394.3L50.3 400.3L58.7 409.0L68.3 415.0L77.0 418.0L82.7 419.0L95.0 419.0L101.3 418.0L113.0 414.7L129.0 407.7L143.3 399.3L154.7 391.0L154.7 381.3L154.0 381.3L139.0 392.7L127.7 399.7L110.0 407.7L97.3 411.0L91.7 411.7L80.3 411.0L67.7 406.0L60.7 400.3L54.0 391.0L50.7 382.0L49.7 370.0L48.3 368.7L36.7 364.7L29.7 360.3L19.7 351.3L15.7 346.0L11.7 338.7L8.7 329.3L8.0 316.0L10.7 308.3L16.0 300.0L26.3 291.3L39.3 283.7L36.0 270.7L36.0 262.0L37.7 255.3L43.0 246.7L51.7 239.3L63.7 233.3L78.3 229.3L88.7 228.3L96.3 228.7L98.0 226.3L98.0 224.3L96.0 218.7L95.7 206.3L98.0 196.0L103.7 185.7L112.7 176.7L137.0 158.3L143.7 151.0L150.0 142.0L157.0 127.7L161.0 114.0L163.3 100.3L167.0 60.3L172.0 35.7L174.0 30.0L178.7 21.3L181.3 17.7L187.7 12.0L194.7 8.7L200.3 7.3L206.3 7.3L215.3 9.7L222.7 13.3L231.3 19.3L247.0 34.3L259.3 50.0L268.7 64.0L280.7 87.0L285.0 97.3L285.0 101.7L283.0 111.3L282.3 112.0L270.3 84.0L260.0 66.0L245.7 46.3L231.0 30.3L220.0 22.7L213.0 19.3L206.3 17.7L197.3 18.3L192.3 20.3L188.7 23.3L182.3 32.3L178.3 44.0L175.3 62.7L173.3 89.3L170.7 110.0L167.3 123.7L162.3 136.7L156.0 148.0L150.3 155.3L139.0 167.3L119.3 182.3L113.7 188.0L110.3 192.3L106.3 201.0L104.3 210.3L105.0 219.3L108.3 229.7L113.7 238.0L110.7 238.7L99.7 236.7L86.7 236.7L79.0 237.7L63.7 242.7L55.3 248.0L50.7 252.7L48.3 256.3L45.7 265.0L45.7 271.7L47.0 278.0L52.3 287.7L36.7 295.0L29.3 299.7L21.7 307.7L18.0 315.3L17.3 324.7L19.0 333.7L27.3 346.3L34.7 353.0L42.7 357.0L53.7 360.0L62.7 360.3L63.3 361.0L61.0 369.0L61.3 380.7L65.0 390.0L69.7 395.3L76.7 399.3L85.0 401.7L96.0 401.7L108.7 398.3L120.7 393.3L142.0 382.0L164.7 367.3L166.3 368.7L168.7 368.7L171.3 367.3L193.3 350.3L194.7 351.0L195.7 356.7L198.7 360.3L203.7 362.7L210.3 362.0L214.7 359.3L224.3 349.3L230.0 344.7L243.7 335.7L268.3 323.7L288.7 316.3L297.0 312.0L302.0 308.3L306.3 303.7L308.3 300.0L308.7 295.3L309.7 294.3L326.0 287.0L352.0 273.7L380.0 257.3L392.7 249.0L408.0 237.3L422.7 223.3L427.7 216.0L428.7 212.7L428.3 207.0L426.7 203.3L424.0 200.7L420.7 199.3L417.7 199.3L409.3 203.3L400.3 213.7L390.0 223.3L365.7 241.7L348.3 251.7L334.7 258.0L329.7 261.3L329.0 261.0L349.7 236.0L365.3 213.3L379.7 187.0L387.7 165.7L387.7 157.0L383.3 152.7L378.3 152.3L373.3 154.3L371.0 156.3L370.3 155.7L373.7 130.0L373.7 105.3L372.7 94.7L369.3 78.3L362.7 62.3L356.3 55.7L349.0 52.3L342.7 52.3L333.3 56.0L326.0 62.0L320.3 68.7L312.0 80.7L300.7 101.0L294.0 110.3L288.3 116.7L287.3 116.0L290.7 103.3L291.3 96.7L301.0 79.7L315.3 60.3L325.0 50.3L330.3 46.3L336.3 43.3L343.7 41.3L353.3 42.0L361.7 46.3L366.7 51.0L371.7 58.3L375.7 67.7L379.0 79.0L382.0 99.0L382.0 123.0L379.0 145.0L380.3 147.0L382.0 147.7L389.3 148.0L389.7 140.0L387.3 139.0L389.3 120.7L389.3 102.7L388.7 91.7L386.7 79.7L383.7 67.7L379.7 57.0L373.7 47.3ZM104.3 381.3L106.7 382.0L108.7 384.7L108.0 386.3L105.7 388.0L103.7 388.0L101.3 386.0L102.0 383.0ZM72.3 378.3L74.7 378.3L76.3 380.0L76.3 382.0L75.3 383.3L73.0 383.7L71.0 382.0L71.0 379.7ZM86.0 372.3L88.3 372.3L90.0 374.0L90.3 377.0L89.0 378.3L86.3 378.3L85.0 377.3L84.7 373.7ZM72.7 363.3L75.0 364.7L75.0 366.7L73.0 368.3L70.7 367.0L71.0 364.7ZM173.3 356.7L170.0 359.3L168.7 359.0L170.7 357.3ZM69.7 339.3L73.0 340.0L75.3 342.7L75.0 346.0L72.0 348.7L69.7 348.7L66.7 345.3L66.7 341.3ZM48.7 335.3L52.0 336.0L55.3 339.3L55.0 343.0L52.0 346.3L47.7 346.0L44.0 342.0L44.7 339.0ZM29.0 327.0L31.3 326.7L33.3 328.3L33.3 330.7L32.0 332.0L30.3 332.3L28.3 331.0L28.0 328.3ZM26.3 314.7L28.0 314.7L28.7 315.7L27.3 318.0L25.3 316.7L25.3 315.3ZM35.3 306.0L36.7 305.0L38.3 305.3L39.0 307.3L37.7 308.7L36.0 308.7L35.0 307.3ZM54.3 301.3L58.0 304.0L58.0 307.0L54.3 311.7L52.0 312.3L48.0 309.0L47.7 305.3L51.0 301.7ZM83.3 284.0L85.0 283.7L86.3 286.0L83.7 286.0ZM73.7 279.0L76.7 279.7L79.3 283.3L79.0 285.7L75.0 288.3L73.0 288.3L70.7 286.0L69.7 283.7L70.3 281.3ZM59.3 272.3L62.0 273.7L63.7 275.7L63.0 278.7L61.0 280.3L58.7 279.7L56.3 276.0L56.7 274.7ZM301.0 294.3L301.0 297.0L298.7 300.7L292.7 305.3L284.0 309.7L266.3 315.7L242.3 327.0L223.7 339.7L208.0 355.0L204.3 355.3L201.7 352.7L201.3 349.0L203.7 344.3L215.7 332.7L228.3 323.7L247.0 314.0L249.7 309.0L259.7 303.7L258.3 299.3L254.7 296.7L252.7 294.0L255.3 292.0L255.3 290.0L253.3 283.0L250.0 276.0L250.7 275.7L254.0 280.0L260.3 286.3L261.3 286.3L262.3 285.3L262.3 283.0L260.0 277.7L262.7 280.0L264.7 279.3L267.3 263.0L268.3 265.0L268.7 279.3L267.0 292.7L269.7 295.7L272.3 297.3L274.7 297.7L292.3 290.0L296.7 290.3ZM73.0 262.7L74.7 263.0L76.3 265.0L76.0 268.3L73.7 270.0L71.3 269.0L69.7 267.0L70.7 264.0ZM58.3 256.0L60.7 257.0L60.7 258.3L59.3 259.7L57.7 259.7L56.7 258.3ZM64.3 314.0L64.7 306.7L67.0 302.0L73.7 296.3L83.7 293.0L92.0 292.0L97.3 292.3L116.7 298.0L131.7 299.3L130.7 297.7L116.7 294.3L101.0 288.3L94.3 284.3L88.3 278.0L86.0 271.7L86.0 267.7L87.0 264.3L89.0 261.0L92.7 257.3L101.3 253.3L114.3 253.3L147.0 261.7L211.0 286.0L230.3 294.0L234.3 296.7L233.3 297.3L218.3 294.3L192.0 287.3L190.3 287.3L190.3 288.0L203.3 293.0L215.7 296.3L216.7 297.3L212.7 297.7L197.7 295.7L180.7 294.7L162.7 295.7L162.7 297.0L184.0 298.3L203.0 300.3L205.3 301.3L203.7 302.7L189.3 304.7L174.3 308.7L169.7 310.7L169.7 312.3L205.7 306.3L220.0 306.0L218.3 307.7L209.3 309.7L173.7 324.7L173.7 326.3L181.7 324.3L202.3 316.7L236.3 306.3L242.0 306.7L241.0 308.0L224.7 316.7L188.0 340.0L149.0 363.3L131.7 371.3L115.3 375.3L105.0 373.7L98.0 370.3L95.0 367.3L93.0 363.3L92.7 357.3L95.3 351.7L100.7 347.0L109.7 342.7L134.0 333.3L134.7 331.7L130.3 332.0L113.3 337.0L103.0 339.0L94.3 339.0L84.7 337.0L76.7 332.7L69.7 326.3L66.7 321.7ZM74.3 249.0L75.3 249.0L76.7 251.0L75.0 253.3L73.0 253.0L72.0 251.7L72.3 250.3ZM68.0 247.3L69.3 247.7L68.7 249.7L69.0 253.3L72.7 257.0L76.3 256.7L80.3 254.0L80.0 249.7L83.0 247.3L87.0 247.3L88.7 249.0L89.0 251.0L82.3 258.0L79.7 263.0L75.3 259.7L72.0 259.7L67.0 264.0L66.7 268.0L69.3 271.7L74.3 272.7L78.3 270.7L80.3 275.7L79.7 277.0L76.3 275.7L72.7 275.7L69.7 277.0L67.3 279.3L66.3 282.3L66.3 286.7L67.3 289.0L69.3 290.7L65.0 294.0L60.7 299.7L55.3 297.7L51.0 297.7L48.3 299.0L45.3 302.0L44.0 304.7L44.0 308.3L46.0 312.7L50.7 316.3L54.0 316.0L57.3 314.0L58.3 315.0L58.3 317.0L57.3 318.0L52.3 317.7L48.3 322.0L48.0 327.7L50.7 331.3L45.3 333.0L41.0 337.7L40.0 341.7L41.3 346.0L44.7 349.7L50.3 350.7L54.0 349.7L58.7 345.3L59.7 342.7L59.7 338.3L62.3 335.0L62.3 332.0L60.7 330.0L55.7 331.0L52.7 329.0L50.7 326.3L51.0 323.0L55.3 320.0L59.0 320.7L64.0 330.0L69.7 335.7L69.0 337.0L65.7 338.3L63.0 342.0L63.3 345.7L65.0 348.7L67.3 350.7L71.7 351.3L75.3 350.0L77.7 347.0L78.3 341.0L85.7 343.7L91.7 344.3L92.3 345.7L87.3 352.0L85.7 357.7L86.0 362.7L88.7 369.7L83.0 371.3L80.3 376.3L81.3 378.3L85.0 381.3L89.0 381.3L91.3 380.3L93.7 377.7L94.0 375.7L100.3 378.3L101.0 379.3L98.3 384.0L98.7 387.0L101.3 390.7L104.0 391.7L108.3 391.0L111.3 388.7L111.3 380.7L124.7 379.3L134.7 376.3L146.0 371.3L147.7 371.7L141.0 376.3L125.7 384.7L106.3 393.7L99.0 395.7L92.3 396.7L85.3 396.3L80.7 395.0L73.7 391.0L71.0 387.7L75.0 387.7L77.7 386.3L79.7 383.7L79.7 379.7L77.3 376.3L74.3 375.3L70.7 376.0L67.3 379.3L66.7 378.0L66.7 369.7L67.3 368.7L69.7 370.7L72.7 371.7L76.0 371.0L78.0 367.7L77.7 363.0L74.3 361.0L69.7 361.3L69.0 360.7L69.3 357.0L67.0 355.3L55.3 354.7L42.7 351.3L37.3 348.3L31.7 342.7L26.0 334.3L26.7 333.7L28.3 334.7L32.7 334.7L35.0 333.3L36.3 330.7L35.7 326.7L32.0 324.0L27.3 324.7L24.3 327.7L23.0 325.7L23.3 320.7L29.0 321.3L31.0 320.0L33.7 320.3L31.7 313.3L29.3 311.7L27.0 311.3L29.7 307.3L31.0 306.7L32.0 309.0L35.3 311.7L38.0 311.7L40.7 310.3L42.3 308.0L42.3 305.0L38.3 301.0L42.7 298.3L57.7 292.3L59.7 289.7L57.7 283.0L62.3 282.7L65.3 280.0L66.7 276.0L64.0 269.7L62.3 268.0L58.3 267.7L57.0 268.3L52.7 274.7L51.7 273.7L51.0 270.7L51.7 262.3L53.0 260.0L57.3 262.3L60.3 262.3L63.7 259.7L63.7 255.0L60.7 252.7L60.7 251.7L63.3 249.3ZM81.3 244.0L81.3 245.0L79.0 247.0L76.7 245.7L77.3 244.3ZM86.7 243.7L91.3 242.7L104.0 243.3L112.7 246.0L111.7 246.7L101.3 246.7L92.3 249.3L90.7 246.7ZM137.3 247.7L141.0 247.3L144.0 246.0L146.0 243.3L146.3 239.0L147.3 238.7L153.3 245.3L164.7 254.3L196.0 272.3L194.7 272.7L187.0 269.0L149.7 254.7L139.7 249.7ZM139.3 237.3L141.0 238.0L142.7 240.3L142.3 242.7L140.3 244.3L137.7 243.7L136.0 241.0L136.7 239.3ZM123.3 229.0L126.3 229.0L128.3 231.0L128.3 234.0L125.7 236.3L122.7 235.3L121.0 232.7L121.3 230.7ZM136.3 220.3L137.7 220.3L139.3 222.0L139.3 225.7L137.7 227.3L135.7 227.0L133.7 224.7L134.0 222.0ZM120.3 207.7L123.3 207.3L126.0 210.3L126.0 214.0L123.7 216.3L120.7 216.3L117.7 213.7L117.7 210.0ZM421.0 208.7L421.3 212.3L420.7 214.0L413.0 223.0L395.3 237.7L379.7 248.7L350.3 265.7L306.3 287.3L305.0 287.3L300.7 284.3L296.7 283.3L301.7 279.3L324.0 265.0L337.0 261.0L364.3 246.3L382.3 234.0L398.3 220.7L413.7 206.3L418.7 206.3ZM142.3 198.0L143.0 199.3L141.7 201.3L141.0 206.3L137.0 209.0L135.3 209.0L134.0 206.7L134.0 201.0L136.0 199.3L141.0 199.3ZM118.0 195.3L119.3 195.7L120.3 197.3L118.7 199.3L116.7 197.7ZM132.3 184.3L134.7 185.0L134.7 186.7L133.7 187.7L132.0 187.7L131.0 186.7ZM145.0 175.3L146.3 175.3L147.7 177.0L146.0 179.7L144.3 179.3L143.0 177.7ZM159.3 173.7L163.0 173.0L166.3 175.7L166.7 180.3L165.3 182.3L160.0 183.0L157.3 180.7L156.7 178.3ZM155.3 159.3L156.7 159.3L158.0 160.7L157.7 163.0L156.0 164.3L153.7 163.0L153.7 161.0ZM380.3 159.0L381.3 160.3L381.3 163.3L379.7 168.7L366.0 198.3L352.0 220.0L340.0 235.7L336.0 239.7L335.7 238.7L347.7 219.0L355.7 202.7L367.7 170.7L376.3 159.3L377.7 158.7ZM163.7 150.7L165.7 151.3L165.3 153.0L164.3 153.7L162.7 153.0ZM191.7 150.3L193.0 151.7L193.3 156.0L188.3 155.0ZM291.0 142.0L295.0 142.7L292.3 148.3L291.0 147.3L290.3 143.7ZM167.0 141.3L171.3 151.3L174.3 154.3L179.3 156.0L180.0 157.3L175.0 160.7L171.3 164.7L169.0 164.3L164.3 160.0L163.7 160.7L164.3 165.0L166.0 167.0L169.0 168.0L169.7 170.0L168.0 170.7L164.3 168.7L161.3 168.7L158.0 170.0L154.0 175.0L153.7 179.7L156.3 185.3L151.7 188.7L148.0 187.7L148.7 190.0L145.3 194.0L143.0 191.7L143.3 188.0L142.7 188.0L139.3 192.0L140.7 196.7L140.0 198.0L132.7 197.3L131.3 201.3L128.7 204.0L118.3 206.3L113.3 211.7L113.3 214.7L114.3 216.3L117.7 219.3L120.7 220.0L125.3 219.7L128.7 217.0L129.0 212.7L125.3 207.7L125.7 206.7L128.7 207.0L135.0 211.7L139.3 211.3L140.0 212.0L139.7 217.0L139.0 217.7L134.7 217.7L131.0 220.0L130.0 222.3L130.0 226.3L133.0 229.7L134.7 230.3L138.7 230.0L141.3 228.3L144.3 235.0L143.3 235.3L140.7 234.0L136.0 235.0L133.0 239.0L133.0 243.0L134.0 245.3L132.7 245.7L126.0 240.7L126.3 239.3L129.7 237.7L131.3 234.0L131.0 230.7L127.7 226.7L123.3 226.0L119.7 228.0L117.0 231.7L115.3 230.7L110.7 219.0L111.0 204.7L113.0 200.3L117.3 202.3L120.0 202.3L122.7 200.7L122.7 195.3L121.0 193.7L118.7 193.3L118.0 191.7L126.0 184.3L127.3 185.0L127.0 187.7L127.7 189.0L131.7 191.7L135.3 191.0L138.0 189.3L138.7 188.0L138.3 184.0L136.0 182.0L131.3 180.0L139.0 174.3L140.3 174.7L141.0 180.0L143.7 182.3L146.3 182.7L150.7 179.0L151.0 176.0L149.3 173.7L146.3 172.0L143.3 172.3L143.0 171.7L149.3 164.3L154.3 167.3L157.7 167.3L160.3 165.3L162.0 160.0L160.0 158.0L157.3 158.0L156.7 156.7L158.3 155.0L162.3 158.0L164.7 158.3L168.0 155.0L169.0 152.7L168.7 150.3L167.0 148.7L163.0 147.3L165.3 142.3ZM292.7 135.0L294.7 136.0L294.7 137.7L293.3 139.0L291.3 137.7ZM178.0 132.3L181.0 132.7L186.0 136.7L188.0 141.0L188.3 146.3L185.3 150.0L183.0 151.3L179.7 151.3L177.3 150.0L174.0 146.3L172.3 142.3L172.3 138.3L173.3 136.0ZM287.7 132.7L287.0 126.7L289.3 126.0L290.0 124.7L291.0 125.0L291.3 126.7L293.7 129.0L297.0 130.7L299.3 130.3L304.3 126.7L305.7 126.7L299.3 136.7L295.0 131.7L292.0 131.7L289.0 133.7ZM178.3 118.3L180.3 119.3L179.0 121.7L177.0 120.3ZM193.3 105.0L196.3 107.3L196.7 108.7L193.7 116.0L192.3 117.0L190.3 117.0L187.3 115.0L186.3 113.0L186.3 110.0L189.0 106.0ZM178.7 104.3L180.0 105.3L179.3 107.7L177.7 107.3L177.7 105.3ZM324.3 101.3L326.3 101.3L329.0 103.7L328.7 107.7L325.3 110.3L322.7 109.7L321.0 107.0L321.7 103.7ZM312.3 100.0L314.0 101.3L313.0 103.0L312.0 103.0L311.0 101.7ZM185.7 96.0L188.0 95.7L188.7 96.3L188.0 97.3L186.7 97.3ZM198.0 94.0L200.3 94.0L202.7 96.3L202.3 99.7L200.0 101.7L196.7 100.7L195.3 98.3L195.7 96.0ZM346.0 91.0L350.0 95.0L352.7 104.3L354.0 115.0L354.0 131.3L351.0 158.7L345.7 185.0L339.0 207.0L333.0 221.7L327.0 233.7L310.7 258.3L304.7 265.7L297.3 272.7L296.7 272.0L302.0 264.7L310.0 251.7L317.7 233.0L316.0 234.0L305.0 251.7L304.7 250.0L311.3 235.0L315.7 222.7L321.7 200.0L320.0 200.3L306.0 235.0L300.0 246.7L299.3 245.3L301.3 233.3L303.7 209.3L302.3 209.0L300.3 211.7L299.3 210.0L298.3 188.3L295.3 169.7L294.7 160.0L298.7 149.3L307.7 136.0L316.0 126.7L318.3 125.3L321.0 125.3L324.7 129.3L326.7 136.0L326.7 148.0L325.7 155.7L323.0 165.3L323.0 167.0L324.3 167.0L327.7 160.3L331.7 145.7L334.7 119.7L338.7 99.0L342.0 93.0L344.0 91.3ZM329.3 79.3L331.7 80.7L331.7 82.3L330.3 83.7L329.3 83.7L328.0 82.0ZM204.0 76.7L207.7 77.7L210.3 81.3L210.3 84.0L209.3 85.7L205.0 88.3L202.7 87.7L199.3 83.7L200.0 80.0ZM186.3 74.7L190.3 75.3L192.0 77.7L191.7 80.0L188.0 83.3L185.7 83.0L183.3 80.3L183.3 77.3ZM343.7 66.7L347.3 66.7L350.7 69.7L352.0 73.7L352.0 75.7L350.3 79.0L346.3 81.7L342.3 81.3L340.0 79.3L338.3 76.3L338.7 72.0L340.3 69.3ZM348.0 57.7L352.7 59.7L358.0 65.3L362.0 73.3L365.0 82.3L368.0 101.0L368.7 121.3L368.0 134.3L366.0 148.7L361.0 170.0L349.0 202.0L345.0 209.7L344.7 207.7L350.3 190.0L354.7 171.0L359.7 132.7L359.7 112.0L357.7 99.7L354.7 91.3L352.7 88.3L349.0 85.3L349.3 84.3L352.0 83.3L354.0 81.3L356.3 75.7L355.7 69.3L352.3 64.0L347.0 61.7L342.0 61.7L337.0 65.0L334.0 70.0L333.7 77.0L328.3 76.0L326.3 76.7L324.3 79.3L324.7 83.3L327.3 86.3L331.0 86.7L333.3 85.3L334.7 83.3L335.0 79.7L341.3 85.0L334.3 92.7L332.0 100.7L330.7 102.3L327.7 99.7L325.3 99.0L321.7 100.7L319.3 104.0L318.7 109.0L321.0 112.0L323.0 113.0L326.7 113.0L329.7 112.0L328.3 123.3L327.3 123.3L322.7 119.0L316.0 118.7L311.7 121.0L307.0 125.0L304.7 125.0L301.0 121.3L301.0 119.0L305.7 116.7L305.3 115.0L303.3 113.7L300.3 114.3L298.0 117.0L297.7 121.3L299.3 125.3L298.7 127.7L297.3 128.0L296.0 127.0L297.0 123.7L292.0 123.3L291.7 122.3L298.3 114.0L306.7 101.3L309.7 104.7L311.7 105.7L314.0 105.3L317.0 103.3L317.3 100.0L314.7 96.7L310.0 96.7L309.7 95.7L316.7 84.0L326.7 70.0L333.0 63.7L339.0 59.7L344.3 57.7ZM220.0 57.3L223.0 57.0L227.0 58.3L231.3 61.3L236.7 66.7L246.3 79.3L256.0 94.3L267.7 116.3L272.7 128.0L280.7 150.3L285.7 172.0L289.3 203.0L289.7 237.7L287.7 251.7L284.7 265.0L279.0 280.7L274.3 288.0L273.3 287.7L273.3 283.7L277.3 245.7L277.7 217.0L276.0 218.0L273.7 242.7L271.7 252.7L270.7 249.7L270.0 234.0L267.3 207.3L262.0 182.7L260.7 183.0L262.7 198.3L265.3 242.0L264.7 262.7L263.3 269.7L261.7 268.3L253.3 238.0L247.3 220.7L241.3 207.0L240.0 206.3L242.0 217.0L253.7 256.7L256.7 270.7L256.7 276.7L243.0 258.7L227.3 234.7L210.7 213.0L209.3 213.0L209.7 214.7L237.7 259.7L250.0 283.3L249.7 285.0L244.7 281.7L198.0 237.3L195.7 235.3L194.3 235.3L202.3 246.0L242.7 287.0L242.7 288.3L226.7 281.0L221.0 277.3L192.3 263.0L179.0 255.7L165.0 246.7L160.0 242.7L151.7 233.3L147.7 225.7L146.3 220.7L146.0 211.7L148.0 204.7L151.7 198.0L158.3 191.7L163.7 189.7L169.0 190.3L178.0 199.3L179.3 199.3L174.7 186.3L174.0 175.0L176.7 168.3L182.3 163.3L186.3 161.7L189.3 161.7L195.0 164.3L200.3 170.3L210.0 186.0L211.3 186.0L209.3 179.3L199.3 155.3L196.3 138.7L198.0 123.0L202.0 112.0L206.3 106.3L211.3 103.3L216.3 103.0L222.0 106.0L225.7 109.7L233.7 123.7L243.7 150.0L245.0 150.0L242.3 135.7L237.3 119.7L216.0 70.3L215.7 62.3L217.3 59.3ZM208.7 32.0L212.0 32.0L215.0 33.3L218.7 37.0L220.3 41.0L220.3 45.3L218.7 49.0L212.0 53.3L207.7 52.7L204.3 50.7L202.0 47.3L201.0 43.0L201.3 39.3L203.0 36.0ZM192.0 30.0L194.3 29.0L195.7 30.7L193.3 32.3ZM197.0 24.0L199.3 23.0L204.0 22.7L215.0 26.3L228.0 35.3L241.0 49.3L253.3 66.3L268.0 91.3L277.7 116.0L281.7 130.7L281.3 132.7L279.7 130.7L271.3 110.3L262.3 93.3L252.3 77.0L243.0 64.3L234.3 56.0L229.3 52.7L221.7 50.0L224.3 43.0L223.0 36.3L219.0 30.7L215.3 28.7L212.0 28.0L206.7 28.3L202.3 30.3L198.0 35.0L196.7 39.7L197.3 46.7L200.7 52.0L204.7 55.3L210.7 56.3L209.3 61.3L209.3 68.0L211.7 77.7L211.0 78.0L205.7 73.7L202.7 73.7L200.0 75.0L197.0 78.0L196.0 80.3L196.0 84.7L198.7 90.0L201.0 91.0L206.3 91.3L210.7 89.0L213.0 82.0L218.7 90.7L221.7 98.0L221.0 98.7L218.7 97.3L213.0 97.0L206.3 99.3L204.0 94.0L197.3 91.7L193.7 92.3L191.3 96.0L189.0 92.0L185.7 92.7L184.3 94.0L184.7 98.3L188.0 100.0L191.0 98.0L193.7 102.7L193.0 103.3L188.3 103.3L185.3 106.0L182.7 111.0L184.0 116.7L187.7 120.0L191.7 120.0L192.3 120.7L191.0 131.0L189.7 132.0L183.0 127.3L176.0 127.7L173.3 129.0L171.7 128.3L173.3 123.0L176.7 125.3L179.7 125.7L182.0 124.7L184.0 121.3L182.7 116.0L180.0 114.7L176.3 114.7L175.7 113.7L177.3 110.3L181.3 109.0L183.0 106.7L182.3 104.0L180.7 102.3L178.7 102.0L178.0 100.7L179.0 99.0L181.7 98.7L181.7 97.0L179.0 96.3L178.3 95.3L179.3 82.7L180.3 82.3L184.0 86.0L189.0 86.7L192.0 84.7L195.0 79.7L194.3 75.0L191.0 72.7L186.0 72.7L180.7 77.0L179.7 75.3L183.0 47.7L186.0 38.0L189.0 33.0L191.3 35.0L196.0 35.0L198.3 33.0L199.3 29.0L196.3 25.0Z",
            sil: "M373.7 47.3L379.7 57.0L383.7 67.7L386.7 79.7L388.7 91.7L389.3 102.7L389.3 120.7L388.0 137.0L389.7 140.0L389.7 147.7L386.7 152.3L386.7 155.0L388.0 158.7L388.0 163.7L382.7 180.0L375.7 195.0L366.3 211.7L351.0 234.0L349.7 237.0L350.0 240.7L351.3 243.0L354.0 245.0L357.3 245.7L361.0 244.7L385.3 227.3L400.3 213.7L409.3 203.3L415.3 200.0L420.7 199.3L423.0 200.0L425.7 202.0L430.0 209.0L434.3 210.7L430.0 212.0L422.7 223.3L410.3 235.3L395.0 247.3L380.0 257.3L356.3 271.3L326.0 287.0L313.7 292.3L309.7 296.0L307.7 301.7L305.3 305.0L295.3 313.0L288.7 316.3L268.3 323.7L243.7 335.7L230.0 344.7L224.3 349.3L214.7 359.3L210.3 362.0L207.7 362.7L202.3 362.3L198.7 360.3L193.7 355.3L190.0 354.7L186.3 355.7L168.7 368.7L166.0 372.3L165.7 375.3L160.0 375.3L156.3 377.7L154.7 381.0L154.3 391.3L143.3 399.3L129.0 407.7L109.0 416.0L95.0 419.0L82.7 419.0L75.7 417.7L65.7 413.7L58.7 409.0L53.3 404.0L48.3 397.0L45.0 389.3L43.0 378.7L41.3 375.3L38.0 373.0L28.7 369.0L22.7 365.0L14.0 356.7L8.0 348.7L3.3 339.0L0.0 325.7L0.0 318.3L1.0 312.7L4.3 304.0L10.0 295.7L15.0 290.7L25.7 283.3L28.0 280.7L29.0 278.3L28.0 263.0L31.0 251.3L36.0 243.0L44.0 235.7L56.7 228.3L67.7 224.3L82.0 221.7L85.3 220.0L88.0 215.7L88.3 206.0L90.3 196.3L94.0 187.3L97.0 182.3L106.7 172.3L129.7 154.7L137.7 146.7L144.3 137.0L150.0 125.0L154.3 109.3L158.0 83.0L160.3 55.0L163.3 38.3L168.3 24.3L175.0 14.0L180.0 9.0L186.7 4.3L195.0 1.0L200.3 0.0L207.7 0.0L213.0 1.0L225.7 6.3L240.7 17.3L254.3 31.0L268.3 49.0L283.7 75.3L286.3 77.3L289.3 78.0L293.0 77.0L295.3 75.0L308.0 57.3L319.0 45.7L325.3 40.7L330.7 37.7L339.3 34.3L351.3 33.7L358.3 35.7L368.0 41.7Z"
        };
        // Butterfly scale: it takes up to ~58% of the plaque height / 40% of its width
        function bfScale(w, h) { return Math.min(0.58 * h / BF_REF.h, 0.40 * w / BF_REF.w); }
        function bfPad() { return state.borderThickness / 2 + 3; }
        // inset 0  -> closed outer outline (rectangle + butterfly silhouette, same winding so they union) for the clip-path
        // inset >0 -> open frame line that starts at the butterfly outline and runs right / down / back to the butterfly
        function butterflyPath(w, h, inset) {
            const R = BF_REF, u = bfScale(w, h), f = n => n.toFixed(2);
            const rc = Math.max(2, R.r * u);
            if (inset === 0) {
                const pad = bfPad(), L = R.X0 * u - pad, T = R.Y0 * u - pad, r = rc + pad;
                // start the corner inside the butterfly body so the rectangle's top-left corner never pokes out
                const Lx = R.X0 * u + 0.45 * (R.topStart - R.X0) * u, Ty = R.Y0 * u + 0.45 * (R.leftStart - R.Y0) * u;
                const rect = `M ${f(Lx)} ${f(T)} L ${f(w - r)} ${f(T)} A ${f(r)} ${f(r)} 0 0 1 ${f(w)} ${f(T + r)} `
                           + `L ${f(w)} ${f(h - r)} A ${f(r)} ${f(r)} 0 0 1 ${f(w - r)} ${f(h)} `
                           + `L ${f(L + r)} ${f(h)} A ${f(r)} ${f(r)} 0 0 1 ${f(L)} ${f(h - r)} L ${f(L)} ${f(Ty)} Z `;
                return rect + R.sil.replace(/(-?\d+\.?\d*) (-?\d+\.?\d*)/g, (m, x, y) => f(x * u) + ' ' + f(y * u));
            }
            const d = inset - bfPad();
            const x0 = R.X0 * u + d, y0 = R.Y0 * u + d, x1 = w - inset, y1 = h - inset;
            const r = Math.max(1.5, rc - Math.max(0, d) * 0.5);
            return `M ${f(R.topStart * u + d)} ${f(y0)} L ${f(x1 - r)} ${f(y0)} A ${f(r)} ${f(r)} 0 0 1 ${f(x1)} ${f(y0 + r)} `
                 + `L ${f(x1)} ${f(y1 - r)} A ${f(r)} ${f(r)} 0 0 1 ${f(x1 - r)} ${f(y1)} `
                 + `L ${f(x0 + r)} ${f(y1)} A ${f(r)} ${f(r)} 0 0 1 ${f(x0)} ${f(y1 - r)} L ${f(x0)} ${f(R.leftStart * u + d)}`;
        }
        function renderButterflyIcon() {
            const el = document.getElementById('bfIcon');
            if (!el) return;
            const s = 24 / BF_REF.h;
            el.innerHTML = `<path d="M13 8.5 H37 Q39 8.5 39 10.5 V25 Q39 27 37 27 H5.5 Q3.5 27 3.5 25 V16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/>`
                         + `<g transform="translate(2 1) scale(${s.toFixed(4)})"><path d="${BF_REF.lines}" fill="currentColor" fill-rule="evenodd"/></g>`;
        }

        // ===================== LIVE SHAPE EDITOR =====================
        // The plaque outline becomes a list of nodes (normalised 0..1, so they follow width/height changes).
        // smooth nodes are joined with Catmull-Rom curves, sharp nodes with straight corners.
        const shapeEdit = { active: false, sel: -1, drag: -1 };
        const $id = id => document.getElementById(id);

        function customPathD(P, smooth) {
            const n = P.length, f = v => v.toFixed(2);
            let d = `M ${f(P[0][0])} ${f(P[0][1])} `;
            for (let i = 0; i < n; i++) {
                const p0 = P[(i - 1 + n) % n], p1 = P[i], p2 = P[(i + 1) % n], p3 = P[(i + 2) % n];
                const s1 = smooth[i], s2 = smooth[(i + 1) % n];
                if (!s1 && !s2) { d += `L ${f(p2[0])} ${f(p2[1])} `; continue; }
                const c1 = s1 ? [p1[0] + (p2[0] - p0[0]) / 6, p1[1] + (p2[1] - p0[1]) / 6] : p1;
                const c2 = s2 ? [p2[0] - (p3[0] - p1[0]) / 6, p2[1] - (p3[1] - p1[1]) / 6] : p2;
                d += `C ${f(c1[0])} ${f(c1[1])} ${f(c2[0])} ${f(c2[1])} ${f(p2[0])} ${f(p2[1])} `;
            }
            return d + 'Z';
        }
        function customPts(w, h) { return state.customNodes.map(n => [n.x * w, n.y * h]); }
        // inward offset of the node polygon (used for the border lines inside the plaque edge)
        function offsetPts(P, inset) {
            const n = P.length;
            let a = 0;
            for (let i = 0; i < n; i++) { const q = P[(i + 1) % n]; a += P[i][0] * q[1] - q[0] * P[i][1]; }
            const sg = a >= 0 ? 1 : -1;
            const nrm = (p, q) => {
                const dx = q[0] - p[0], dy = q[1] - p[1], l = Math.hypot(dx, dy) || 1;
                return sg > 0 ? [-dy / l, dx / l] : [dy / l, -dx / l];
            };
            return P.map((p, i) => {
                const n1 = nrm(P[(i - 1 + n) % n], p), n2 = nrm(p, P[(i + 1) % n]);
                let bx = n1[0] + n2[0], by = n1[1] + n2[1];
                const bl = Math.hypot(bx, by);
                if (bl < 1e-6) return [p[0] + n1[0] * inset, p[1] + n1[1] * inset];
                bx /= bl; by /= bl;
                const k = Math.min(2.5, 1 / Math.max(0.4, bx * n1[0] + by * n1[1]));
                return [p[0] + bx * inset * k, p[1] + by * inset * k];
            });
        }
        function customOutlineD(w, h, inset) {
            let P = customPts(w, h);
            if (inset > 0) P = offsetPts(P, inset);
            return customPathD(P, state.customNodes.map(n => n.s));
        }

        function rdp(pts, eps) {
            if (pts.length < 3) return pts;
            const a = pts[0], b = pts[pts.length - 1];
            const dx = b[0] - a[0], dy = b[1] - a[1], L = Math.hypot(dx, dy) || 1;
            let md = 0, mi = 0;
            for (let i = 1; i < pts.length - 1; i++) {
                const d = Math.abs(dy * pts[i][0] - dx * pts[i][1] + b[0] * a[1] - b[1] * a[0]) / L;
                if (d > md) { md = d; mi = i; }
            }
            if (md <= eps) return [a, b];
            return rdp(pts.slice(0, mi + 1), eps).slice(0, -1).concat(rdp(pts.slice(mi), eps));
        }
        // turn the current preset outline into editable nodes
        function nodesFromShape(shapeId, w, h) {
            const d = getShapePathD(w, h, shapeId, 0).split(/(?=M)/)[0];
            let pts;
            if (!/[ACQSc]/.test(d)) {                       // straight-edged preset: use the exact corners
                const nums = d.match(/-?\d+\.?\d*/g).map(Number);
                pts = [];
                for (let i = 0; i < nums.length; i += 2) pts.push([nums[i], nums[i + 1]]);
                return pts.map(p => ({ x: p[0] / w, y: p[1] / h, s: false }));
            }
            const NS = 'http://www.w3.org/2000/svg';
            const svg = document.createElementNS(NS, 'svg'), path = document.createElementNS(NS, 'path');
            svg.setAttribute('width', 0); svg.setAttribute('height', 0); svg.style.position = 'absolute';
            path.setAttribute('d', d); svg.appendChild(path); document.body.appendChild(svg);
            const L = path.getTotalLength(), N = 400, raw = [];
            for (let i = 0; i < N; i++) { const q = path.getPointAtLength(L * i / N); raw.push([q.x, q.y]); }
            document.body.removeChild(svg);
            let far = 0, fd = 0;
            raw.forEach((p, i) => { const dd = Math.hypot(p[0] - raw[0][0], p[1] - raw[0][1]); if (dd > fd) { fd = dd; far = i; } });
            let eps = 0.8, out;
            do {
                const A = rdp(raw.slice(0, far + 1), eps), B = rdp(raw.slice(far).concat([raw[0]]), eps);
                out = A.slice(0, -1).concat(B.slice(0, -1));
                eps *= 1.35;
            } while (out.length > 44);
            return out.map((p, i) => {
                const a = out[(i - 1 + out.length) % out.length], b = out[(i + 1) % out.length];
                const a1 = Math.atan2(p[1] - a[1], p[0] - a[0]), a2 = Math.atan2(b[1] - p[1], b[0] - p[0]);
                let t = Math.abs(a2 - a1); if (t > Math.PI) t = 2 * Math.PI - t;
                return { x: p[0] / w, y: p[1] / h, s: t < 0.66 };   // < ~38 degrees turn = smooth
            });
        }

        function startShapeEdit() {
            const w = state.width * 36, h = state.height * 36;
            if (state.shape !== 'custom') {
                state.baseShape = state.shape;
                state.customNodes = nodesFromShape(state.shape, w, h);
                state.shape = 'custom';
                document.querySelectorAll('.shape-btn').forEach(btn => {
                    btn.className = "shape-btn p-2.5 rounded-xl border border-slate-200 bg-slate-50 text-slate-600 flex flex-col items-center space-y-1.5 hover:border-slate-300 transition shadow-sm";
                });
            }
            shapeEdit.active = true; shapeEdit.sel = -1; shapeEdit.drag = -1;
            syncShapeEditUI();
            updatePlaqueUI();
        }
        function stopShapeEdit() {
            shapeEdit.active = false; shapeEdit.sel = -1; shapeEdit.drag = -1;
            syncShapeEditUI();
            updatePlaqueUI();
        }
        function toggleShapeEdit() { shapeEdit.active ? stopShapeEdit() : startShapeEdit(); }
        function resetCustomShape() {
            const w = state.width * 36, h = state.height * 36;
            const base = (state.baseShape && state.baseShape !== 'custom') ? state.baseShape : 'rect-sharp';
            state.customNodes = nodesFromShape(base, w, h);
            shapeEdit.sel = -1;
            updatePlaqueUI();
        }
        function syncShapeEditUI() {
            $id('shapeEditBar').classList.toggle('hidden', !shapeEdit.active);
            const b = $id('editShapeBtn');
            b.className = shapeEdit.active
                ? "px-3 h-8 rounded-lg bg-amber-500 text-white text-xs font-medium transition flex items-center space-x-1.5"
                : "px-3 h-8 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-medium transition flex items-center space-x-1.5";
        }

        function segMid(P, sm, i) {
            const n = P.length, p0 = P[(i - 1 + n) % n], p1 = P[i], p2 = P[(i + 1) % n], p3 = P[(i + 2) % n];
            const s1 = sm[i], s2 = sm[(i + 1) % n];
            if (!s1 && !s2) return [(p1[0] + p2[0]) / 2, (p1[1] + p2[1]) / 2];
            const c1 = s1 ? [p1[0] + (p2[0] - p0[0]) / 6, p1[1] + (p2[1] - p0[1]) / 6] : p1;
            const c2 = s2 ? [p2[0] - (p3[0] - p1[0]) / 6, p2[1] - (p3[1] - p1[1]) / 6] : p2;
            return [(p1[0] + 3 * c1[0] + 3 * c2[0] + p2[0]) / 8, (p1[1] + 3 * c1[1] + 3 * c2[1] + p2[1]) / 8];
        }

        function renderShapeEditOverlay() {
            const ov = $id('shapeEditOverlay');
            if (!shapeEdit.active || state.shape !== 'custom') { ov.classList.add('hidden'); return; }
            const plaque = $id('plaqueObject'), w = state.width * 36, h = state.height * 36;
            ov.classList.remove('hidden');
            ov.style.left = plaque.offsetLeft + 'px'; ov.style.top = plaque.offsetTop + 'px';
            ov.style.width = w + 'px'; ov.style.height = h + 'px';
            ov.setAttribute('viewBox', `0 0 ${w} ${h}`);
            const z = previewScale, r = 6 / z, P = customPts(w, h), sm = state.customNodes.map(n => n.s);
            let g = `<path d="${customOutlineD(w, h, 0)}" fill="none" stroke="#0d9488" stroke-width="${1.5 / z}" stroke-dasharray="${6 / z} ${4 / z}"/>`;
            P.forEach((_, i) => {
                const m = segMid(P, sm, i);
                g += `<g data-kind="mid" data-i="${i}" style="pointer-events:all;cursor:copy"><circle cx="${m[0]}" cy="${m[1]}" r="${r * 1.15}" fill="#fff" fill-opacity=".85" stroke="#0d9488" stroke-width="${1 / z}"/>`
                   + `<path d="M${m[0] - r * .55} ${m[1]}H${m[0] + r * .55}M${m[0]} ${m[1] - r * .55}V${m[1] + r * .55}" stroke="#0d9488" stroke-width="${1.4 / z}"/></g>`;
            });
            P.forEach((p, i) => {
                const fill = i === shapeEdit.sel ? '#0d9488' : '#fff', st = `fill="${fill}" stroke="#0d9488" stroke-width="${2 / z}"`;
                g += `<g data-kind="node" data-i="${i}" style="pointer-events:all;cursor:grab">`
                   + (sm[i] ? `<circle cx="${p[0]}" cy="${p[1]}" r="${r}" ${st}/>`
                            : `<rect x="${p[0] - r}" y="${p[1] - r}" width="${r * 2}" height="${r * 2}" ${st}/>`) + `</g>`;
            });
            ov.innerHTML = g;
        }

        function shapeEditPoint(e) {
            const rect = $id('plaqueObject').getBoundingClientRect(), w = state.width * 36, h = state.height * 36;
            const sc = rect.width / w || 1;
            return [Math.min(w, Math.max(0, (e.clientX - rect.left) / sc)), Math.min(h, Math.max(0, (e.clientY - rect.top) / sc))];
        }
        function removeCustomNode(i) {
            if (state.customNodes.length <= 3 || i < 0) return;
            state.customNodes.splice(i, 1);
            shapeEdit.sel = -1; shapeEdit.drag = -1;
            updatePlaqueUI();
        }
        (function initShapeEditEvents() {
            const ov = $id('shapeEditOverlay');
            ov.addEventListener('contextmenu', e => e.preventDefault());
            ov.addEventListener('pointerdown', e => {
                const t = e.target.closest('[data-kind]');
                if (!t) return;
                e.preventDefault(); e.stopPropagation();
                let i = +t.dataset.i;
                if (t.dataset.kind === 'mid') {
                    const w = state.width * 36, h = state.height * 36, P = customPts(w, h), sm = state.customNodes.map(n => n.s);
                    const m = segMid(P, sm, i);
                    state.customNodes.splice(i + 1, 0, { x: m[0] / w, y: m[1] / h, s: sm[i] || sm[(i + 1) % sm.length] });
                    i = i + 1;
                } else if (e.button === 2 || e.altKey) { removeCustomNode(i); return; }
                else {
                    // double-click / double-tap on a node: toggle smooth <-> sharp (the overlay is re-rendered on every
                    // pointerdown, so the browser's own dblclick event never fires; detect it manually)
                    const now = performance.now();
                    if (shapeEdit.lastI === i && now - shapeEdit.lastT < 350) {
                        state.customNodes[i].s = !state.customNodes[i].s;
                        shapeEdit.lastT = 0; shapeEdit.sel = i; shapeEdit.drag = -1;
                        updatePlaqueUI();
                        return;
                    }
                    shapeEdit.lastI = i; shapeEdit.lastT = now;
                }
                shapeEdit.sel = i; shapeEdit.drag = i;
                try { ov.setPointerCapture(e.pointerId); } catch (_) {}
                // Touch: press and hold a point (without moving) to delete it.
                if (e.pointerType === 'touch' && t.dataset.kind === 'node') {
                    clearTimeout(shapeEdit.holdT);
                    shapeEdit.holdX = e.clientX; shapeEdit.holdY = e.clientY;
                    shapeEdit.holdT = setTimeout(() => {
                        if (shapeEdit.drag === i) { shapeEdit.drag = -1; removeCustomNode(i); if (navigator.vibrate) navigator.vibrate(15); }
                    }, 650);
                }
                updatePlaqueUI();
            });
            ov.addEventListener('pointermove', e => {
                if (shapeEdit.drag < 0) return;
                if (shapeEdit.holdT && Math.hypot(e.clientX - shapeEdit.holdX, e.clientY - shapeEdit.holdY) > 8) { clearTimeout(shapeEdit.holdT); shapeEdit.holdT = 0; }
                const w = state.width * 36, h = state.height * 36, p = shapeEditPoint(e), n = state.customNodes[shapeEdit.drag];
                if (!n) return;
                n.x = p[0] / w; n.y = p[1] / h;
                updatePlaqueUI();
            });
            const end = () => { clearTimeout(shapeEdit.holdT); shapeEdit.drag = -1; };
            ov.addEventListener('pointerup', end); ov.addEventListener('pointercancel', end);
            document.addEventListener('keydown', e => {
                if (!shapeEdit.active) return;
                if (/INPUT|SELECT|TEXTAREA/.test((document.activeElement || {}).tagName || '')) return;
                if (e.key === 'Escape') stopShapeEdit();
                else if ((e.key === 'Delete' || e.key === 'Backspace') && shapeEdit.sel >= 0) { e.preventDefault(); removeCustomNode(shapeEdit.sel); }
            });
            window.addEventListener('resize', () => { fitPreview(); renderShapeEditOverlay(); });
        })();


        // Arched Plaque (traced from the reference): vertical sides, flat bottom, two shallow arcs meeting in a slight peak.
        // inset 0 = exact outline (quadratic curves); inset > 0 = true inward offset as a polyline.
        function gableArchPath(w, h, inset) {
            // Arched Plaque (house / gable shape): vertical sides, flat bottom, two STRAIGHT sloped roof lines meeting at a peak.
            const f = n => n.toFixed(2);
            const sh = 0.2 * h, mx = w / 2;                       // sh = height of the shoulders (where the roof starts)
            if (inset === 0) {
                return `M 0 ${f(h)} L 0 ${f(sh)} L ${f(mx)} 0 L ${f(w)} ${f(sh)} L ${f(w)} ${f(h)} Z`;
            }
            // concentric (mitred) inset of the outline, so the border keeps an even gap on the sloped edges
            const L = Math.hypot(mx, sh);
            const ax = inset * sh / L, ay = sh + inset * mx / L;  // roof line shifted inward along its normal
            const ys = ay - ((inset - ax) / mx) * sh;             // where it meets the side line x = inset
            const yp = inset * L / mx;                            // where the two roof lines meet (centre)
            return `M ${f(inset)} ${f(h - inset)} L ${f(inset)} ${f(ys)} L ${f(mx)} ${f(yp)} L ${f(w - inset)} ${f(ys)} L ${f(w - inset)} ${f(h - inset)} Z`;
        }
        // Mathematical shape generator for SVG Path (Ensures exact geometrical forms)
        function getShapePathD(w, h, shape, inset = 0) {
            if (shape === 'custom') {
                return customOutlineD(w, h, inset);
            }
            if (shape === 'gable-arch') {
                return gableArchPath(w, h, inset);
            }
            if (shape === 'rect-butterfly') {
                return butterflyPath(w, h, inset);
            }
            if (shape === 'arch') {
                // Arch (Dome): custom profile traced from the reference artwork
                return archPath(w, h, inset);
            }
            else if (shape === 'historical-marker') {
                // Historical Marker: Side shoulders leading to a smooth central crest peak
                const shoulderY = h * 0.22 + inset;
                return `M ${inset} ${h - inset} 
                        L ${inset} ${shoulderY} 
                        Q ${w * 0.22} ${shoulderY * 0.2 + inset}, ${w * 0.5} ${inset} 
                        Q ${w * 0.78} ${shoulderY * 0.2 + inset}, ${w - inset} ${shoulderY} 
                        L ${w - inset} ${h - inset} Z`;
            }
            else if (shape === 'tabbed-arch') {
                // Tabbed Arch: border path is a true concentric inset of the outer outline
                const tabH = h * 0.22;
                const r = Math.min(w * 0.16, tabH);   // dome radius (never rises above plaque top)
                const rr = Math.max(2, r - inset);     // inset dome radius, same centre as outer dome
                const cx = w / 2;
                const yS = tabH + inset;               // inset shoulder line
                return `M ${inset} ${h - inset}
                        L ${inset} ${yS}
                        L ${cx - rr} ${yS}
                        L ${cx - rr} ${tabH}
                        A ${rr} ${rr} 0 0 1 ${cx + rr} ${tabH}
                        L ${cx + rr} ${yS}
                        L ${w - inset} ${yS}
                        L ${w - inset} ${h - inset} Z`;
            }
            else if (shape === 'bell-top') {
                // Bell-Top / Scalloped Arch Crest Outline
                const crestH = h * 0.3;
                return `M ${inset} ${h - inset}
                        L ${inset} ${crestH + inset * 0.5}
                        C ${inset} ${crestH * 0.5}, ${w * 0.25} ${inset}, ${w * 0.5} ${inset}
                        C ${w * 0.75} ${inset}, ${w - inset} ${crestH * 0.5}, ${w - inset} ${crestH + inset * 0.5}
                        L ${w - inset} ${h - inset} Z`;
            }
            else if (shape === 'notched-corner') {
                // Notched Corners: True 90-degree straight step cuts
                const notch = Math.max(16, 28 - inset * 0.35);
                return `M ${inset + notch} ${inset} 
                        L ${w - inset - notch} ${inset} 
                        L ${w - inset - notch} ${inset + notch} 
                        L ${w - inset} ${inset + notch} 
                        L ${w - inset} ${h - inset - notch} 
                        L ${w - inset - notch} ${h - inset - notch} 
                        L ${w - inset - notch} ${h - inset} 
                        L ${inset + notch} ${h - inset} 
                        L ${inset + notch} ${h - inset - notch} 
                        L ${inset} ${h - inset - notch} 
                        L ${inset} ${inset + notch} 
                        L ${inset + notch} ${inset + notch} Z`;
            }
            else if (shape === 'scalloped-corner') {
                // Scalloped Corners: Inward curved concave arcs
                const r = Math.max(16, 30 - inset * 0.35);
                return `M ${inset + r} ${inset} 
                        L ${w - inset - r} ${inset} 
                        A ${r} ${r} 0 0 0 ${w - inset} ${inset + r} 
                        L ${w - inset} ${h - inset - r} 
                        A ${r} ${r} 0 0 0 ${w - inset - r} ${h - inset} 
                        L ${inset + r} ${h - inset} 
                        A ${r} ${r} 0 0 0 ${inset} ${h - inset - r} 
                        L ${inset} ${inset + r} 
                        A ${r} ${r} 0 0 0 ${inset + r} ${inset} Z`;
            }
            else if (shape === 'chamfered') {
                const c = Math.max(16, 28 - inset * 0.35);
                return `M ${inset + c} ${inset} 
                        L ${w - inset - c} ${inset} 
                        L ${w - inset} ${inset + c} 
                        L ${w - inset} ${h - inset - c} 
                        L ${w - inset - c} ${h - inset} 
                        L ${inset + c} ${h - inset} 
                        L ${inset} ${h - inset - c} 
                        L ${inset} ${inset + c} Z`;
            }
            else if (shape === 'rounded-rect') {
                const rx = 24;
                return `M ${inset + rx} ${inset} 
                        L ${w - inset - rx} ${inset} 
                        A ${rx} ${rx} 0 0 1 ${w - inset} ${inset + rx} 
                        L ${w - inset} ${h - inset - rx} 
                        A ${rx} ${rx} 0 0 1 ${w - inset - rx} ${h - inset} 
                        L ${inset + rx} ${h - inset} 
                        A ${rx} ${rx} 0 0 1 ${inset} ${h - inset - rx} 
                        L ${inset} ${inset + rx} 
                        A ${rx} ${rx} 0 0 1 ${inset + rx} ${inset} Z`;
            }
            else if (shape === 'circle' || shape === 'oval-landscape' || shape === 'oval-rose') {
                const cx = w / 2;
                const cy = h / 2;
                const rx = (w / 2) - inset;
                const ry = (h / 2) - inset;
                return `M ${cx - rx} ${cy} 
                        A ${rx} ${ry} 0 1 0 ${cx + rx} ${cy} 
                        A ${rx} ${ry} 0 1 0 ${cx - rx} ${cy} Z`;
            }
            else {
                // Sharp rectangle
                return `M ${inset} ${inset} 
                        L ${w - inset} ${inset} 
                        L ${w - inset} ${h - inset} 
                        L ${inset} ${h - inset} Z`;
            }
        }

        /* 4 screw centres [TL, TR, BL, BR] that sit inside the real outline of ANY shape (rect, gable, arch, circle, custom ...) */
        function fastenerPositions(w, h, shape, count) {
            const OFFSET = 20, CLEAR = 12;                 // 20px from the edges (same as the old rectangle), 12px clear space around the screw
            let path = null;
            try { path = new Path2D(getShapePathD(w, h, shape, 0)); } catch (e) { path = null; }
            const ctx = document.createElement('canvas').getContext('2d');
            const inside = (x, y) => path ? ctx.isPointInPath(path, x, y) : (x >= 0 && x <= w && y >= 0 && y <= h);
            const clear = (x, y) => {
                if (!inside(x, y)) return false;
                for (let a = 0; a < 16; a++) {
                    const t = a * Math.PI / 8;
                    if (!inside(x + CLEAR * Math.cos(t), y + CLEAR * Math.sin(t))) return false;
                }
                return true;
            };
            const place = (cx, cy) => {
                const dx = cx === 0 ? 1 : -1, dy = cy === 0 ? 1 : -1;
                // 1) keep the screw near the side edge and slide it along the side until it is inside the shape (gable, notched, chamfered ...)
                const x = cx + dx * OFFSET;
                for (let y = cy + dy * OFFSET; Math.abs(y - cy) <= h * 0.25; y += dy) {   // only accept small slides, otherwise use the diagonal
                    if (clear(x, y)) return [x, y];
                }
                // 2) slide along the diagonal towards the centre (circle, oval, butterfly ...)
                for (let t = 0; t <= 1; t += 0.005) {
                    const px = cx + (w / 2 - cx) * t, py = cy + (h / 2 - cy) * t;
                    if (clear(px, py)) return [px, py];
                }
                return [cx + dx * OFFSET, cy + dy * OFFSET];
            };
            if (count === 2) {
                // 2 screws: centred on the two short ends (wide plaque -> left & right, tall plaque -> top & bottom)
                const horizontal = w >= h;
                const mid = (cx, cy) => {
                    const dx = cx === 0 ? 1 : cx === w ? -1 : 0, dy = cy === 0 ? 1 : cy === h ? -1 : 0;
                    let x = horizontal ? cx + dx * OFFSET : w / 2;
                    let y = horizontal ? h / 2 : cy + dy * OFFSET;
                    for (let i = 0; i < Math.max(w, h) / 2; i++) {          // slide inwards until fully inside the outline (e.g. below a gable peak)
                        if (clear(x, y)) return [x, y];
                        if (horizontal) x += dx; else y += dy;
                    }
                    return [horizontal ? cx + dx * OFFSET : w / 2, horizontal ? h / 2 : cy + dy * OFFSET];
                };
                return horizontal ? [mid(0, h / 2), mid(w, h / 2)] : [mid(w / 2, 0), mid(w / 2, h)];
            }
            return [place(0, 0), place(w, 0), place(0, h), place(w, h)];
        }

        /* returns clear(x, y): true when a screw centred at x,y (plus `clearR` px around it) lies fully inside the plaque outline */
        function fastenerClearTester(w, h, shape, clearR) {
            let path = null;
            try { path = new Path2D(getShapePathD(w, h, shape, 0)); } catch (e) { path = null; }
            const ctx = document.createElement('canvas').getContext('2d');
            const inside = (x, y) => path ? ctx.isPointInPath(path, x, y) : (x >= 0 && x <= w && y >= 0 && y <= h);
            return (x, y) => {
                if (!inside(x, y)) return false;
                for (let a = 0; a < 16; a++) {
                    const t = a * Math.PI / 8;
                    if (!inside(x + clearR * Math.cos(t), y + clearR * Math.sin(t))) return false;
                }
                return true;
            };
        }

        const FASTENER_IDS = ['fastenerTopLeft', 'fastenerTopRight', 'fastenerBottomLeft', 'fastenerBottomRight'];
        function initFastenerDrag() {
            FASTENER_IDS.forEach((id, idx) => {
                const el = document.getElementById(id);
                if (!el || el.dataset.dragReady) return;
                el.dataset.dragReady = '1';
                let drag = null;
                el.addEventListener('pointerdown', e => {
                    if (state.mounting !== 'screws') return;
                    e.preventDefault();
                    e.stopPropagation();
                    const { w, h } = plaqueSizePx();
                    drag = { test: fastenerClearTester(w, h, state.shape, 8), w, h };
                    el.setPointerCapture(e.pointerId);
                    el.classList.add('dragging');
                });
                el.addEventListener('pointermove', e => {
                    if (!drag) return;
                    const rect = document.getElementById('plaqueObject').getBoundingClientRect();   // includes the zoom scale
                    const nx = (e.clientX - rect.left) / rect.width * drag.w;
                    const ny = (e.clientY - rect.top) / rect.height * drag.h;
                    const cx = parseFloat(el.style.left) || nx, cy = parseFloat(el.style.top) || ny;
                    let p = null;
                    if (drag.test(nx, ny)) p = [nx, ny];
                    else if (drag.test(nx, cy)) p = [nx, cy];      // slide along the edge instead of getting stuck
                    else if (drag.test(cx, ny)) p = [cx, ny];
                    if (!p) return;
                    el.style.left = p[0] + 'px';
                    el.style.top = p[1] + 'px';
                    state.screwCustom = state.screwCustom || [];
                    state.screwCustom[idx] = [p[0] / drag.w, p[1] / drag.h];   // stored as fractions so it follows size changes
                });
                const end = () => {
                    if (!drag) return;
                    drag = null;
                    el.classList.remove('dragging');
                    renderMountingOptions();     // shows the "Reset positions" link
                };
                el.addEventListener('pointerup', end);
                el.addEventListener('pointercancel', end);
                el.addEventListener('click', e => e.stopPropagation());
            });
        }
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFastenerDrag);
        else initFastenerDrag();

        /* ---------- curved text: every letter is placed and rotated along a circular arc ---------- */
        let _curveCtx = null;
        function buildCurvedText(textDiv, text, curve, fontPx, fontFamily, fontWeight, italic) {
            const str = String(text || '');                       // keep the case exactly as typed (small + capital letters)
            if (!_curveCtx) _curveCtx = document.createElement('canvas').getContext('2d');
            const ctx = _curveCtx;
            ctx.font = `${italic ? 'italic ' : ''}${fontWeight} ${fontPx}px ${fontFamily}`;
            const chars = Array.from(str);
            const pre = [0];                                    // width of every prefix -> kerning aware letter positions
            let acc = '';
            chars.forEach(ch => { acc += ch; pre.push(ctx.measureText(acc).width); });
            const total = pre[chars.length] || 0;
            textDiv.style.whiteSpace = 'nowrap';
            textDiv.textContent = '';
            if (!total) { textDiv.style.width = Math.ceil(fontPx) + 'px'; textDiv.style.height = Math.ceil(fontPx) + 'px'; return; }
            const m = ctx.measureText('Hg');
            const base = (m.fontBoundingBoxAscent && m.fontBoundingBoxDescent)
                ? (fontPx - (m.fontBoundingBoxAscent + m.fontBoundingBoxDescent)) / 2 + m.fontBoundingBoxAscent
                : fontPx * 0.84;                                // baseline position inside a line-height:1 box
            const up = curve > 0;                               // + = arch (centre higher), - = smile (centre lower)
            const theta = Math.abs(curve) / 100 * Math.PI;      // 100% = the text wraps a half circle
            const R = total / theta;
            const glyphs = [];
            let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
            chars.forEach((ch, i) => {
                if (!ch.trim()) return;
                const w = pre[i + 1] - pre[i];
                const phi = (pre[i] + w / 2 - total / 2) / R;
                const px = R * Math.sin(phi);
                const py = up ? -R * Math.cos(phi) : R * Math.cos(phi);
                const rot = up ? phi : -phi;
                const c = Math.cos(rot), sn = Math.sin(rot);
                [[-w / 2, -base], [w / 2, -base], [-w / 2, fontPx - base], [w / 2, fontPx - base]].forEach(([x, y]) => {
                    const X = px + x * c - y * sn, Y = py + x * sn + y * c;
                    minX = Math.min(minX, X); maxX = Math.max(maxX, X);
                    minY = Math.min(minY, Y); maxY = Math.max(maxY, Y);
                });
                glyphs.push({ ch, w, px, py, rot });
            });
            glyphs.forEach(g => {
                const span = document.createElement('span');
                span.textContent = g.ch;
                span.style.cssText = `position:absolute;white-space:pre;line-height:1;left:${(g.px - minX - g.w / 2).toFixed(2)}px;top:${(g.py - minY - base).toFixed(2)}px;`
                    + `transform-origin:${(g.w / 2).toFixed(2)}px ${base.toFixed(2)}px;transform:rotate(${g.rot.toFixed(4)}rad);`;
                textDiv.appendChild(span);
            });
            textDiv.style.width = Math.ceil(maxX - minX) + 'px';
            textDiv.style.height = Math.ceil(maxY - minY) + 'px';
        }

        /* ---------- edit the text directly on the plaque (double-click / double-tap) ---------- */
        let inlineEditor = null;
        let lastTap = { id: null, t: 0, x: 0, y: 0 };

        function closeInlineTextEditor() {
            if (!inlineEditor) return;
            document.removeEventListener('pointerdown', inlineEditor.outside, true);
            window.removeEventListener('resize', inlineEditor.place);
            inlineEditor.box.remove();
            inlineEditor = null;
        }

        function openInlineTextEditor(elId) {
            closeInlineTextEditor();
            const el = state.elements.find(x => x.id === elId);
            if (!el || el.type !== 'text' || !state.textLines[el.index]) return;
            const index = el.index;
            const line = state.textLines[index];
            currentSelectedElementId = elId;
            updatePlaqueUI();

            const box = document.createElement('div');
            box.id = 'inlineTextEditor';
            box.style.cssText = 'position:fixed;z-index:9999;display:flex;align-items:center;gap:10px;flex-wrap:wrap;max-width:min(560px,calc(100vw - 16px));background:#fff;border:1px solid #0d9488;border-radius:14px;padding:8px 10px;box-shadow:0 12px 32px rgba(0,0,0,.28);font:12px/1.2 system-ui,sans-serif;color:#232323;';
            box.innerHTML = '<input type="text" aria-label="Edit plaque text" style="flex:1 1 200px;min-width:160px;border:1px solid #d5d5d5;border-radius:8px;padding:7px 10px;font-size:16px;outline:none;">'
                + '<label style="display:flex;align-items:center;gap:6px;white-space:nowrap;color:#606060;">Curve <input type="range" min="-100" max="100" step="1" style="width:110px;accent-color:#b73548;"></label>'
                + '<button type="button" style="background:#232323;color:#fff;border:0;border-radius:8px;padding:7px 14px;font-weight:600;cursor:pointer;">Done</button>';
            document.body.appendChild(box);
            const input = box.querySelector('input[type=text]');
            const range = box.querySelector('input[type=range]');
            const done = box.querySelector('button');
            input.value = line.text;
            range.value = line.curve || 0;

            const place = () => {
                const dom = document.querySelector('.plaque-element[data-id="' + elId + '"]');
                if (!dom) return;
                const r = dom.getBoundingClientRect();
                const bw = box.offsetWidth, bh = box.offsetHeight;
                let left = r.left + r.width / 2 - bw / 2;
                let top = r.top - bh - 12;
                if (top < 8) top = r.bottom + 12;
                left = Math.max(8, Math.min(left, window.innerWidth - bw - 8));
                top = Math.max(8, Math.min(top, window.innerHeight - bh - 8));
                box.style.left = left + 'px';
                box.style.top = top + 'px';
            };
            const sync = () => {                      // keep the editor in step with the sidebar
                const l = state.textLines[index];
                if (!l) return;
                if (range.value !== String(l.curve || 0)) range.value = l.curve || 0;
                place();
            };
            const outside = e => { if (!box.contains(e.target)) closeInlineTextEditor(); };

            input.addEventListener('input', () => {
                updateLineText(index, input.value);
                const side = document.querySelectorAll('#textLinesContainer input[type="text"]')[index];
                if (side) side.value = input.value;
                place();
            });
            range.addEventListener('input', () => updateLineCurve(index, range.value, true));
            box.addEventListener('keydown', e => {
                e.stopPropagation();
                if (e.key === 'Enter' || e.key === 'Escape') { e.preventDefault(); closeInlineTextEditor(); }
            });
            done.addEventListener('click', closeInlineTextEditor);

            inlineEditor = { box, index, place, sync, outside };
            window.addEventListener('resize', place);
            place();
            setTimeout(() => {
                if (!inlineEditor || inlineEditor.box !== box) return;
                document.addEventListener('pointerdown', outside, true);
                input.focus();
                input.select();
            }, 0);
        }

        // letters are measured with the real font, so re-draw once web fonts have finished loading
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { try { updatePlaqueUI(); } catch (e) {} });

        function updatePlaqueUI() {
            const plaque = document.getElementById('plaqueObject');
            plaque.className = `relative transition-all duration-300 finish-surface ${state.surfaceMode === 'color' ? 'color-surface' : state.finish} material-${state.material} select-none shadow-2xl`;
            const surfaceMetal = getSurfaceMetal();
            ['ink', 'highlight', 'edge'].forEach(key => plaque.style.setProperty('--finish-' + key, surfaceMetal[key]));
            plaque.style.setProperty('--custom-background', state.color);
            renderSurfaceControls();
            renderDesignDepth();
            plaque.style.transition = shapeEdit.active ? 'none' : '';

            const pxWidth = state.width * PX_PER_INCH;
            const pxHeight = state.height * PX_PER_INCH;
            plaque.style.width = pxWidth + 'px';
            plaque.style.height = pxHeight + 'px';
            fitPreview();

            const outerPathD = getShapePathD(pxWidth, pxHeight, state.shape, 0);
            document.getElementById('plaqueClipPathShape').setAttribute('d', outerPathD);
            plaque.style.clipPath = 'url(#plaqueClipPath)';
            plaque.style.borderRadius = '0px';

            renderSvgBorder(pxWidth, pxHeight, state.shape);
            renderShapeEditOverlay();

            const canvasContainer = document.getElementById('plaqueCanvasContent');
            canvasContainer.innerHTML = '';

            state.elements.forEach(el => {
                const isSelected = currentSelectedElementId === el.id;
                const wrapper = document.createElement('div');
                wrapper.className = `plaque-element ${isSelected ? 'selected-box' : ''}`;
                wrapper.style.left = el.x + 'px';
                wrapper.style.top = el.y + 'px';
                wrapper.style.width = el.w + 'px';
                wrapper.style.height = el.h + 'px';
                wrapper.dataset.id = el.id;

                let innerHtml = '';
                if(el.type === 'emblem') {
                    if(el.image) {
                        innerHtml = `<div class="w-full h-full flex items-center justify-center pointer-events-none"><img src="${escapeHtmlAttribute(el.image)}" alt="${escapeHtmlAttribute(el.label)}" class="w-full h-full object-contain rounded border border-white/20" style="filter:${logoDepthFilter()}"></div>`;
                    } else if(el.html) {
                        const emblemFilter = logoDepthFilter();
                        innerHtml = `<div class="w-full h-full flex items-center justify-center text-3xl pointer-events-none" style="filter:${emblemFilter}">${el.html}</div>`;
                    }
                } else if(el.type === 'text' && state.textLines[el.index]) {
                    const line = state.textLines[el.index];
                    // Keep preview lettering flat for both engraving relief options.
                    // Text style: Norm = regular (default), B = bold, I = italic. Only one is active at a time.
                    const isBold = line.style === 'bold';
                    const isItalic = line.style === 'italic';
                    const desiredPx = plaqueFontPx(line.size);
                    const textDiv = document.createElement('div');
                    textDiv.className = 'plaque-text';
                    textDiv.style.fontFamily = line.fontFamily || state.fontFamily;
                    textDiv.style.fontWeight = isBold ? '700' : '400';
                    textDiv.style.fontStyle = isItalic ? 'italic' : 'normal';
                    textDiv.style.fontSize = desiredPx + 'px';
                    if (line.curve) buildCurvedText(textDiv, line.text, line.curve, desiredPx, line.fontFamily || state.fontFamily, textDiv.style.fontWeight, isItalic);
                    else textDiv.textContent = line.text || '';
                    wrapper.appendChild(textDiv);
                    innerHtml = null;
                }

                if (innerHtml) wrapper.innerHTML = innerHtml;

                canvasContainer.appendChild(wrapper);
                if (el.type === 'text' && state.textLines[el.index]) {
                    layoutTextElement(wrapper, el, state.textLines[el.index]);
                }

                if(isSelected) {
                    ['tl', 't', 'tr', 'l', 'r', 'bl', 'b', 'br'].forEach(pos => {
                        const handle = document.createElement('div');
                        handle.className = `resize-handle handle-${pos}`;
                        handle.dataset.handle = pos;
                        wrapper.appendChild(handle);
                    });
                }
            });

            renderLogoLists();
            updateTextFitWarning();

            // Corner Rosette Screws (Visible): shown on EVERY shape until "Blind Threaded Studs (Hidden)" is chosen.
            const showFasteners = state.mounting === 'screws';
            const fastenerAuto = showFasteners ? fastenerPositions(pxWidth, pxHeight, state.shape, state.screwCount === 2 ? 2 : 4) : null;
            const fastenerTest = showFasteners ? fastenerClearTester(pxWidth, pxHeight, state.shape, 8) : null;
            // positions the customer dragged to win over the automatic ones (as long as they still fit inside the shape)
            const fastenerPos = showFasteners ? fastenerAuto.map((auto, i) => {
                const c = (state.screwCustom || [])[i];
                if (c) { const x = c[0] * pxWidth, y = c[1] * pxHeight; if (fastenerTest(x, y)) return [x, y]; }
                return auto;
            }) : null;
            ['fastenerTopLeft', 'fastenerTopRight', 'fastenerBottomLeft', 'fastenerBottomRight'].forEach((id, i) => {
                const el = document.getElementById(id);
                if (!el) return;
                if (showFasteners && fastenerPos[i]) {
                    const [fx, fy] = fastenerPos[i];
                    el.style.left = fx + 'px';
                    el.style.top = fy + 'px';
                    el.style.right = 'auto';
                    el.style.bottom = 'auto';
                    el.style.transform = 'translate(-50%, -50%)';
                    el.classList.add('fastener-drag');
                    el.classList.remove('hidden');
                } else {
                    el.classList.add('hidden');
                }
            });

            const sqInches = state.width * state.height;
            const totalPrice = getPriceBreakdown().total;

            document.getElementById('headerPrice').innerText = '$' + totalPrice.toFixed(2);
            document.getElementById('dimRatioDisplay').innerText = `${state.width}" × ${state.height}"`;
            document.getElementById('footerFinishName').innerText = materials.find(material => material.id === state.material).name + ' · ' + surfaceName();
            document.getElementById('footerBorderName').innerText = borderLabel();
            document.getElementById('footerDimensions').innerText = `${state.width}" × ${state.height}"`;
            syncTextSizeSelects();
        }

        function updateTextFitWarning() {
            const { w, h } = plaqueSizePx();
            const path = document.getElementById('plaqueClipPathShape');
            const affected = state.elements.filter(el => {
                if (el.type !== 'text' || !state.textLines[el.index].text.trim()) return false;
                if (el.x < 0 || el.y < 0 || el.x + el.w > w + 0.5 || el.y + el.h > h + 0.5) return true;
                if (typeof path.isPointInFill !== 'function') return false;
                for (let row = 0; row <= 4; row++) for (let col = 0; col <= 4; col++) {
                    if (!path.isPointInFill(new DOMPoint(el.x + el.w * col / 4, el.y + el.h * row / 4))) return true;
                }
                return false;
            });
            const warning = document.getElementById('textFitWarning');
            warning.classList.toggle('hidden', !affected.length);
            warning.textContent = affected.length ? 'Text may extend beyond the plaque outline on line(s) ' + affected.map(el => el.index + 1).join(', ') + '. Move the text inward, shorten it, reduce its size, or choose a larger plaque.' : '';
            return affected.length === 0;
        }

        function constrainElementPosition(el) {
            const { w, h } = plaqueSizePx();
            // Oversized elements stay anchored inside the canvas and can still be selected.
            el.x = Math.min(Math.max(0, el.x), Math.max(0, w - el.w));
            el.y = Math.min(Math.max(0, el.y), Math.max(0, h - el.h));
        }

        function handlePlaqueBackgroundClick(event) {
            if (ignoreCanvasClick) { ignoreCanvasClick = false; return; }
            if(event.target.id === 'plaqueObject' || event.target.id === 'plaqueCanvasContent' || event.target.id === 'plaqueBorderSvg') {
                currentSelectedElementId = null;
                updatePlaqueUI();
            }
        }

        let isDragging = false;
        let isResizing = false;
        let activeHandle = null;
        let activeElementId = null;
        let activePointerId = null;
        let ignoreCanvasClick = false;
        let startX = 0, startY = 0, startLeft = 0, startTop = 0, startWidth = 0, startHeight = 0;

        document.addEventListener('pointerdown', function(e) {
            if (!e.isPrimary || e.button !== 0 || activePointerId !== null) return;
            ignoreCanvasClick = false;
            if (shapeEdit.active) return;   // text/emblem dragging is paused while editing the outline
            const handle = e.target.closest('.resize-handle');
            const element = e.target.closest('.plaque-element');
            if (!handle && element) {
                const tid = element.dataset.id, now = performance.now();
                const isDouble = lastTap.id === tid && now - lastTap.t < 420 && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 10;
                lastTap = { id: tid, t: now, x: e.clientX, y: e.clientY };
                const tel = state.elements.find(x => x.id === tid);
                if (isDouble && tel && tel.type === 'text') {
                    lastTap = { id: null, t: 0, x: 0, y: 0 };
                    e.preventDefault();
                    e.stopPropagation();
                    openInlineTextEditor(tid);
                    return;
                }
            }

            if (handle || element) {
                activePointerId = e.pointerId;
                ignoreCanvasClick = true;
                document.getElementById('plaqueCanvasContent').setPointerCapture(e.pointerId);
            }

            if(handle) {
                isResizing = true;
                activeHandle = handle.dataset.handle;
                const parentEl = handle.closest('.plaque-element');
                activeElementId = parentEl.dataset.id;
                startX = e.clientX;
                startY = e.clientY;
                const found = state.elements.find(el => el.id === activeElementId);
                startLeft = found.x;
                startTop = found.y;
                startWidth = found.w;
                startHeight = found.h;
                e.stopPropagation();
                e.preventDefault();
            } else if(element) {
                isDragging = true;
                activeElementId = element.dataset.id;
                currentSelectedElementId = activeElementId;
                startX = e.clientX;
                startY = e.clientY;
                const found = state.elements.find(el => el.id === activeElementId);
                startLeft = found.x;
                startTop = found.y;
                updatePlaqueUI();
                e.stopPropagation();
                e.preventDefault();
            }
        });

        document.addEventListener('pointermove', function(e) {
            if (e.pointerId !== activePointerId) return;
            if(!activeElementId) return;
            const found = state.elements.find(el => el.id === activeElementId);
            if(!found) return;

            const dx = (e.clientX - startX) / (previewScale || 1);   // Convert screen movement to plaque coordinates.
            const dy = (e.clientY - startY) / (previewScale || 1);

            const textMin = found.type === 'text' ? textMinBox(found) : null;
            const minW = textMin ? textMin.w : 40;
            const minH = textMin ? textMin.h : 20;

            if(isDragging) {
                found.x = startLeft + dx;
                found.y = startTop + dy;
                constrainElementPosition(found);

                const domEl = document.querySelector(`[data-id="${activeElementId}"]`);
                if(domEl) {
                    domEl.style.left = found.x + 'px';
                    domEl.style.top = found.y + 'px';
                }
            } else if(isResizing) {
                if(activeHandle === 'br') {
                    found.w = Math.max(minW, startWidth + dx);
                    found.h = Math.max(minH, startHeight + dy);
                } else if(activeHandle === 'bl') {
                    const newW = Math.max(minW, startWidth - dx);
                    found.w = newW;
                    found.x = startLeft + (startWidth - newW);
                    found.h = Math.max(minH, startHeight + dy);
                } else if(activeHandle === 'tr') {
                    found.w = Math.max(minW, startWidth + dx);
                    const newH = Math.max(minH, startHeight - dy);
                    found.h = newH;
                    found.y = startTop + (startHeight - newH);
                } else if(activeHandle === 'tl') {
                    const newW = Math.max(minW, startWidth - dx);
                    const newH = Math.max(minH, startHeight - dy);
                    found.w = newW;
                    found.h = newH;
                    found.x = startLeft + (startWidth - newW);
                    found.y = startTop + (startHeight - newH);
                } else if(activeHandle === 'r') {
                    found.w = Math.max(minW, startWidth + dx);
                } else if(activeHandle === 'l') {
                    const newW = Math.max(minW, startWidth - dx);
                    found.w = newW;
                    found.x = startLeft + (startWidth - newW);
                } else if(activeHandle === 'b') {
                    found.h = Math.max(minH, startHeight + dy);
                } else if(activeHandle === 't') {
                    const newH = Math.max(minH, startHeight - dy);
                    found.h = newH;
                    found.y = startTop + (startHeight - newH);
                }

                constrainElementPosition(found);
                const domEl = document.querySelector(`[data-id="${activeElementId}"]`);
                if(domEl) {
                    domEl.style.left = found.x + 'px';
                    domEl.style.top = found.y + 'px';
                    domEl.style.width = found.w + 'px';
                    domEl.style.height = found.h + 'px';
                    stretchTextDom(domEl, found);
                    if (found.type === 'text') syncTextSizeSelects();
                }
            }
        });

        function endElementInteraction(e) {
            if (e && e.pointerId !== activePointerId) return;
            const pointerId = activePointerId;
            activePointerId = null;
            if (isResizing && activeElementId) {
                const found = state.elements.find(el => el.id === activeElementId);
                if (found && found.type === 'text') found.userSized = true;
            }
            if(isDragging || isResizing) {
                updatePlaqueUI();
            }
            isDragging = false;
            isResizing = false;
            activeHandle = null;
            activeElementId = null;
            const canvas = document.getElementById('plaqueCanvasContent');
            if (pointerId !== null && canvas.hasPointerCapture(pointerId)) canvas.releasePointerCapture(pointerId);
        }
        document.addEventListener('pointerup', endElementInteraction);
        document.addEventListener('pointercancel', endElementInteraction);
        document.getElementById('plaqueCanvasContent').addEventListener('lostpointercapture', endElementInteraction);
        window.addEventListener('blur', () => endElementInteraction());

        // Rose garlands for the "Rose Border Oval": the left garland is traced from the reference artwork
        // (coordinates are pixels of the source image); the right garland is its mirror image.
        const ROSE_REF = {
            ox: 16, oy: 6, ow: 1462, oh: 1030,        // oval box in the source image
            bx0: 31, bx1: 500, by0: 112, by1: 944,    // garland bounding box
            d: "M466 944 467 944 475 942 485 938 497 936 500 934 488 914 484 906 484 904 476 888 468 880 456 874 447 874 435 880 423 890 411 882 406 877 406 874 408 872 412 872 421 878 428 878 432 876 440 866 444 857 444 854 444 853 444 839 442 838 434 842 423 842 416 846 410 851 408 858 408 862 408 863 406 866 404 866 402 855 398 845 403 844 409 848 411 848 412 846 412 843 404 834 395 828 383 824 376 818 368 814 363 816 350 826 346 824 334 809 334 808 335 808 344 812 358 812 365 810 383 802 386 802 395 798 396 797 396 795 386 783 374 764 366 756 360 754 353 752 346 752 345 752 337 754 328 758 322 764 318 772 316 774 314 774 316 766 316 760 318 758 324 758 331 754 340 744 344 739 346 730 346 714 344 707 338 695 326 684 328 677 326 664 324 658 314 649 314 637 312 630 308 622 300 614 292 612 282 612 271 620 266 614 258 608 255 608 245 608 254 595 254 587 258 581 260 578 262 573 240 572 230 574 222 582 220 586 220 591 218 592 218 597 220 598 213 606 210 602 210 599 210 598 208 598 210 609 208 612 204 621 198 622 197 622 191 622 190 614 184 607 198 595 202 588 206 582 208 566 216 554 222 550 222 547 219 546 205 546 204 544 195 544 194 544 184 544 175 546 172 546 174 542 174 539 177 536 181 538 188 542 197 542 202 538 206 534 214 542 222 546 225 546 226 546 241 546 242 546 245 546 256 540 258 540 265 536 284 522 294 512 290 508 281 502 270 492 255 482 241 478 231 480 227 482 226 480 230 474 230 466 239 464 248 458 254 448 254 440 264 431 268 423 268 416 266 409 266 404 268 399 268 386 264 379 265 378 267 380 277 384 292 384 302 380 325 368 331 366 337 366 338 364 338 360 324 343 306 328 300 324 290 322 272 323 274 321 279 316 286 316 291 318 296 318 304 314 314 305 314 303 314 294 325 288 328 283 332 273 330 272 330 268 338 261 342 255 344 249 344 237 340 226 330 217 330 214 330 205 328 200 333 198 334 200 336 207 338 212 342 216 346 218 352 218 360 216 366 216 368 214 368 203 366 202 366 196 359 188 354 184 344 184 334 192 332 189 341 180 349 178 357 182 366 190 375 192 379 192 380 185 386 174 388 168 386 166 383 166 377 170 370 170 374 168 378 165 390 148 390 139 388 133 388 126 392 118 389 116 384 116 379 112 377 114 375 112 368 113 374 114 379 116 382 120 386 121 386 124 384 125 386 144 378 154 370 154 364 152 360 148 356 142 356 133 367 124 373 122 378 122 374 118 369 118 362 124 362 127 357 132 355 132 356 123 361 116 366 114 364 114 358 116 356 112 354 112 348 117 342 133 340 142 340 143 340 153 342 157 342 161 340 162 340 169 332 178 330 178 330 176 326 174 326 175 328 181 320 188 315 184 314 182 315 180 319 178 324 172 328 163 328 152 324 139 324 130 322 128 318 128 311 134 300 145 294 154 294 156 292 158 292 161 292 169 296 176 298 179 298 180 293 180 292 182 283 172 278 170 270 170 266 172 253 172 252 174 249 174 241 178 236 182 230 180 219 180 217 178 204 190 204 191 202 196 202 198 196 205 194 209 194 213 192 214 186 214 180 218 174 224 170 229 168 236 168 245 170 248 176 258 176 264 178 270 186 276 194 280 188 284 180 292 178 296 180 308 175 312 168 319 166 326 166 332 164 334 162 334 160 333 156 324 168 310 176 295 178 282 176 278 174 268 168 260 164 255 160 248 160 242 157 240 155 240 136 257 128 269 122 281 120 290 120 291 120 300 122 307 126 314 133 322 139 324 148 326 150 328 150 332 148 332 145 330 131 330 122 334 114 341 108 349 104 358 104 366 93 366 87 370 85 370 78 374 74 379 68 388 66 395 66 396 66 405 72 416 72 421 70 425 70 432 68 433 70 440 72 447 76 451 83 458 88 460 88 463 88 473 88 474 88 477 94 487 93 488 87 484 77 484 76 482 64 484 52 488 50 490 41 494 33 496 30 499 34 504 40 514 42 524 42 528 48 540 54 549 62 558 72 562 80 562 93 558 101 552 109 550 114 558 116 567 120 572 119 574 114 569 114 566 110 564 107 564 108 560 104 558 102 558 100 561 96 566 96 569 99 572 103 570 106 570 114 577 120 587 122 601 122 601 118 595 110 588 104 584 101 584 94 582 90 582 87 580 80 578 74 574 67 568 65 568 64 570 64 577 62 578 64 581 64 593 64 594 64 596 64 620 64 621 64 625 70 637 74 643 85 654 95 658 105 658 108 662 111 666 117 668 124 670 138 664 145 668 156 675 156 678 156 679 154 688 152 686 145 682 132 682 131 682 124 684 108 692 105 692 104 692 93 692 92 694 92 697 106 722 112 732 112 734 116 742 125 750 131 754 140 758 148 758 160 752 169 744 172 746 172 748 162 755 162 759 160 761 160 764 161 766 164 762 166 760 164 766 160 768 158 771 160 796 161 798 175 792 180 790 185 784 193 788 198 794 198 799 202 811 202 815 200 820 202 834 204 842 209 846 212 845 212 843 216 835 230 825 232 821 234 811 236 810 242 812 240 821 240 836 240 837 242 844 248 856 262 868 268 872 288 886 311 906 313 906 316 904 314 901 314 882 318 868 322 862 322 854 324 849 324 843 326 842 326 827 324 826 324 821 322 814 318 807 319 806 324 810 330 819 332 826 334 835 334 836 334 849 332 854 328 866 328 882 334 896 344 908 352 912 354 911 354 907 348 898 344 887 342 879 342 878 342 862 346 880 350 886 356 894 360 898 370 902 380 902 381 900 390 901 386 909 384 920 388 930 398 942 401 944 404 940 406 935 412 925 416 916 416 906 412 901 412 898 410 892 410 890 411 890 420 896 420 898 420 910 420 911 420 914 426 927 430 932 438 938 445 942 452 944Z M350 132 350 122 351 122 352 127Z M370 152 374 152 376 148 376 140 376 139 376 136 379 134 380 134 382 134 379 124 372 126 368 130 366 137 366 148Z M372 148 370 144 368 137 370 133 375 130 376 131 376 133 374 137 374 145Z M302 176 298 167 298 164 296 163 298 162 298 159 300 157 300 155 302 153 302 152 306 147 317 136 318 144 324 156 324 164 322 167 315 176 313 176 312 176 314 171 314 168 310 171 310 158 314 150 313 146 308 154 307 150 304 152 306 160 304 161 304 170 302 168 300 166 300 171 302 173Z M374 162 368 166 361 166 354 162 352 162 348 157 346 151 346 145 348 141 351 138 351 142 353 140 354 141 358 152 360 154 366 157 366 158 364 158 359 156 358 156 362 160 366 160 376 158 376 159Z M343 168 344 160 345 160 346 161 346 163Z M356 169 350 170 350 168 352 166Z M382 173 376 183 376 186 367 184 358 176 354 175 359 174 364 178 367 178 367 176 376 176 381 172Z M259 326 252 324 248 321 246 315 244 310 242 308 237 308 231 310 224 308 212 302 208 297 204 286 204 277 200 274 191 272 187 270 184 267 182 263 182 250 178 246 176 242 178 233 184 224 188 220 192 220 192 224 190 225 190 232 192 233 192 245 194 251 200 260 205 266 208 264 208 263 200 250 198 241 194 232 194 227 194 226 194 224 194 218 198 210 204 205 208 194 213 190 222 186 232 186 232 188 226 196 226 199 222 207 222 214 222 215 221 220 220 206 222 202 222 200 220 204 218 211 218 226 220 228 222 219 224 219 224 225 222 228 222 237 220 238 222 243 222 249 224 253 224 254 220 248 219 236 218 248 224 259 226 261 225 262 220 256 216 245 216 237 218 231 217 228 214 235 214 248 218 259 222 265 228 272 230 272 234 272 234 268 241 272 234 260 230 246 226 235 228 227 230 224 228 211 232 202 232 193 234 188 242 178 252 174 262 174 265 176 270 176 271 178 278 176 284 180 288 184 292 184 293 184 307 184 313 186 318 192 318 194 324 201 324 208 326 209 326 217 324 219 332 227 336 233 340 242 340 246 336 254 326 264 324 277 320 284 312 288 305 290 294 290 293 290 285 288 282 286 280 288 280 289 286 294 294 297 288 298 281 294 280 294 284 298 288 300 296 300 293 302 285 302 285 304 294 304 301 302 306 296 309 296 310 299 308 301 300 310 295 312 291 312 281 308 276 310 272 314 266 323 263 326 260 326Z M306 274 315 266 320 261 322 257 321 250 314 262 312 264 305 272 300 274 294 275 300 268 304 268 307 266 311 260 312 262 314 260 318 251 324 243 326 236 326 232 324 230 322 232 320 229 318 228 320 233 320 237 318 242 310 250 301 252 300 254 301 256 305 256 306 258 303 260 296 264 289 264 277 260 269 260 261 256 254 252 248 243 248 233 248 232 249 226 254 230 256 235 261 240 276 248 280 252 289 256 290 254 286 249 286 247 288 246 289 244 293 244 299 242 306 238 310 234 310 236 300 247 301 248 309 242 314 235 314 222 312 217 312 207 308 199 296 188 293 188 296 195 296 197 294 200 289 196 287 196 281 192 274 192 269 194 264 199 262 203 260 204 256 207 257 208 262 205 262 207 258 215 259 218 264 212 266 213 266 219 270 224 270 233 276 240 275 242 273 242 267 238 260 231 255 222 253 224 250 222 248 216 248 212 250 206 252 203 254 196 261 190 268 190 274 184 280 183 278 182 273 182 272 182 260 184 258 186 257 186 256 184 242 192 236 200 232 207 232 212 232 213 234 248 236 248 236 240 236 239 236 229 236 229 238 232 240 232 240 225 242 221 242 218 244 214 246 219 246 225 244 231 244 242 244 243 244 246 250 253 257 260 270 266 262 266 258 265 263 268 276 268 279 268 282 269 277 270 276 270 268 270 267 272 264 272 263 274 272 274 273 272 279 274 280 272 284 272 285 272 289 272 292 270 295 270 296 271 294 274 286 280 287 280 292 278 296 278 299 276Z M246 193 251 188 255 186 256 187 247 194Z M362 210 358 210 351 214 345 212 342 208 338 200 340 198 346 200 350 206 350 202 356 206 356 204 352 200 344 194 342 194 342 193 344 190 349 188 354 190 360 197 362 205 362 206Z M237 222 236 218 236 217 236 212 238 209 238 207 242 202 247 196 250 196 250 196 247 198 242 204 238 212Z M304 232 296 236 279 238 280 236 286 234 282 232 278 234 272 227 272 226 273 226 278 229 278 226 274 222 274 219 279 214 285 218 288 218 290 218 289 216 282 215 284 214 289 214 294 218 296 225 294 227 292 229 293 230 297 230 300 226 302 221 302 218 300 213 293 206 283 204 276 208 276 209 278 210 272 216 271 220 268 217 270 204 274 200 278 198 286 198 291 202 296 200 301 202 310 212 310 217 306 224 308 228Z M280 247 285 244 286 246 283 248Z M153 320 152 317 152 313 150 307 150 293 160 283 164 277 166 269 164 269 164 272 154 284 151 286 150 285 150 277 160 263 160 262 158 262 153 266 152 266 153 254 150 260 148 271 147 274 146 273 144 269 142 263 141 262 140 264 142 273 146 279 145 286 142 286 138 281 134 273 132 272 136 265 148 252 155 246 156 248 160 259 166 267 168 268 168 272 170 275 172 282 172 290 166 301Z M148 320 147 320 144 320 135 314 130 310 126 300 124 292 128 278 132 272 134 281 144 291 146 306 145 306 138 299 129 284 128 291 132 298 141 306 145 308 146 309 148 315 150 319Z M286 281 269 280 268 280 256 280 271 284 280 284Z M193 298 192 295 196 290 196 285 199 282 200 295 199 296 196 296Z M205 316 202 314 190 314 186 311 182 305 182 297 186 289 191 286 192 286 192 287 190 292 190 296 188 297 190 306 194 312 196 312 199 312 199 310 196 310 194 307 192 302 196 298 201 298 206 303 206 305 202 308 202 311 206 314Z M146 317 143 312 131 304 130 305 138 314 143 318Z M211 314 210 314 208 312 210 308 212 309 212 313Z M178 327 180 322 184 316 188 320 202 320 202 321 200 322 190 322 190 324 192 326 200 326 209 322 213 320 214 319 216 312 222 314 226 315 226 317 220 324 217 330 214 330 213 328 200 330 192 334 190 334 184 330 179 328Z M225 334 224 332 224 328 230 320 235 316 236 317Z M235 346 230 336 238 321 240 317 243 316 246 322 248 326 244 329 244 332 240 335 240 341Z M237 352 236 348 240 344 242 341 245 342 248 340 248 327 250 326 255 330 259 330 260 331 256 335 250 346 246 350Z M250 351 258 342 260 338 267 332 273 328 285 326 286 328 293 328 298 331 285 338 275 348 267 348 264 348 264 346 278 331 278 330 265 338 258 348 252 352Z M153 504 148 502 144 498 142 494 133 486 130 486 129 486 124 486 119 488 113 488 105 486 98 480 94 470 94 455 86 450 80 444 76 435 76 426 78 420 78 415 74 404 74 394 78 385 88 376 95 372 103 372 104 370 104 366 108 354 112 348 120 342 127 338 132 338 133 338 141 338 149 340 156 340 158 342 169 334 177 332 186 338 198 350 200 353 202 359 203 360 209 362 214 368 216 373 216 382 216 383 214 390 210 397 204 402 192 408 177 410 176 407 181 400 188 398 191 398 198 394 202 389 202 386 202 390 200 396 196 400 196 402 198 402 204 395 206 391 208 387 210 378 206 371 204 368 208 377 207 382 206 379 206 376 200 367 198 363 193 358 189 356 186 350 179 346 171 346 170 346 164 346 160 349 161 350 166 348 168 348 162 352 159 352 156 356 153 356 152 355 152 352 156 342 145 356 138 358 132 363 124 377 124 380 124 390 128 400 128 402 124 397 122 387 122 383 122 382 122 377 126 370 126 368 134 360 134 358 132 358 126 365 126 369 120 378 120 381 120 382 120 392 124 400 128 405 128 413 134 426 141 432 156 442 160 442 160 440 155 438 144 427 138 418 134 406 134 410 136 417 142 428 140 427 134 420 132 412 133 400 138 404 138 409 140 415 149 424 157 428 160 428 164 430 168 430 176 433 166 432 158 430 155 430 149 426 151 430 164 436 174 438 175 438 183 440 184 438 189 438 202 434 212 422 216 422 225 416 226 423 222 433 216 443 208 450 200 452 180 452 176 454 178 456 188 458 199 458 209 454 215 450 222 443 226 437 226 435 232 424 232 427 224 445 225 446 230 441 234 431 244 406 244 401 244 400 244 396 240 407 240 410 235 420 234 418 238 411 240 404 240 399 242 389 242 379 238 373 239 372 245 372 252 376 258 382 260 388 262 394 258 404 258 409 262 416 262 422 260 426 254 432 248 436 246 442 246 446 242 452 234 458 224 462 224 468 220 480 208 492 198 496 192 496 185 492 174 492 174 489 180 477 180 474 174 479 170 486 170 488 168 491 166 498 163 502 159 504Z M248 355 253 354 260 354 261 352 263 354 268 352 273 352 285 368 284 364 282 362 282 358 278 353 290 352 294 361 301 368 304 370 304 368 294 355 295 354 299 354 305 356 306 356 309 356 310 356 322 358 308 352 298 350 298 349 300 348 310 344 312 343 310 342 308 342 302 342 293 346 291 348 282 348 282 346 288 340 292 338 299 332 301 332 315 344 330 361 326 362 318 364 312 368 307 374 302 376 296 376 295 376 292 376 289 378 280 378 276 375 265 360 260 357 268 366 273 374 270 374 262 370 254 359Z M212 420 206 419 214 410 218 403 224 387 222 378 222 377 222 374 224 381 224 389 224 390 222 397 218 407 218 408 226 394 226 381 222 371 221 370 220 372 218 367 212 362 208 360 208 357 210 356 212 356 215 358 216 357 206 348 206 350 208 353 207 354 203 346 196 342 192 340 192 339 194 338 202 338 208 340 209 338 217 338 222 340 228 346 232 351 232 359 230 365 234 370 238 380 238 390 236 396 230 406 219 416Z M202 423 200 426 194 428 182 428 175 426 167 422 155 420 149 416 144 409 142 404 142 401 136 396 132 385 132 376 134 369 138 365 148 358 154 358 160 360 164 356 175 352 180 352 186 354 190 358 198 373 198 377 196 384 196 387 191 392 185 396 177 396 176 396 172 396 172 393 168 388 168 385 166 381 166 377 168 375 172 372 178 372 184 375 182 379 177 380 175 384 183 382 184 380 186 379 188 384 184 388 180 388 180 390 186 390 190 386 192 383 190 377 190 370 188 366 184 362 180 360 170 360 168 360 167 362 172 362 174 364 172 366 167 366 165 366 160 373 160 377 161 380 166 378 164 385 162 388 164 389 164 392 166 396 166 398 158 394 154 391 152 387 152 381 158 373 156 370 158 363 157 362 146 373 142 383 142 387 150 402 156 408 166 414 174 420 176 419 172 416 173 414 187 414 188 414 192 414 198 412 198 412 192 416 186 417 190 418 191 416 194 416 200 414 204 410 200 410 200 410 204 408 206 408 211 404 212 406 210 409 202 421Z M252 369 244 366 239 366 238 361 246 358Z M184 371 178 368 181 368 184 370Z M149 394 148 393 146 387 146 381 148 374 152 370 152 372 150 375 148 380 148 389 150 393Z M172 456 173 454 162 446 152 446 151 444 132 446 128 444 120 435 114 424 114 421 112 420 112 412 114 411 114 403 108 395 104 387 102 374 100 379 98 387 96 388 96 396 98 397 98 404 100 406 100 396 100 393 102 393 100 422 102 428 108 439 114 444 114 444 106 430 108 424 110 433 114 439 126 450 129 454 136 456 145 458 146 458 165 458Z M178 402 174 405 172 411 168 414 161 408 154 402 154 399 156 398 163 402 169 402 170 402 171 402Z M105 426 104 422 104 411 106 404 106 409 104 416 104 419 106 420Z M178 437 179 436 187 436 192 434 194 434 189 436 184 436 183 438Z M164 455 139 456 132 454 132 452 142 452 143 452 153 452 158 454 164 454Z M227 540 215 534 207 526 203 522 200 522 202 520 202 517 208 505 210 504 208 508 208 510 214 502 222 495 224 491 224 490 224 488 234 484 242 484 252 488 245 490 236 498 231 508 221 510 220 509 224 503 234 488 234 486 222 499 218 507 218 510 216 512 204 519 205 520 220 514 223 514 228 512 233 512 240 521 246 528 256 533 255 534 244 540 241 540 240 540Z M110 543 109 544 104 537 106 530 106 523 108 522 106 510 104 508 104 518 104 520 104 521 104 532 102 534 96 529 98 515 96 514 96 510 94 503 90 494 90 496 90 497 92 510 94 511 94 522 94 525 93 526 87 522 86 520 86 513 84 512 84 508 82 502 75 490 74 492 74 495 76 497 82 511 82 516 82 517 81 518 73 514 72 513 70 508 66 501 62 496 54 492 62 488 69 486 81 486 82 486 85 486 96 492 100 497 112 518 112 521 112 522 112 538Z M236 506 238 501 247 492 251 490 252 488 255 490 262 495 258 496 252 498 248 502 245 506Z M110 548 98 548 81 556 74 556 61 550 52 542 46 529 44 522 42 509 38 500 41 498 43 498 52 492 54 492 64 506 66 510 45 502 46 504 58 511 57 512 53 514 52 515 55 516 56 514 65 514 70 517 70 518 56 528 51 530 51 532 56 532 63 528 74 520 76 520 84 524 84 525 75 532 64 540 59 542 58 544 62 544 73 538 88 526 95 532 110 546Z M120 554 118 552 114 547 114 544 118 535 118 523 118 522 118 518 112 506 108 500 102 493 102 492 108 494 120 494 121 494 129 492 136 499 130 514 130 518 122 544Z M259 532 248 526 238 513 238 511 242 510 247 510 254 518 263 522 264 522 261 520 254 512 254 510 272 509 264 508 264 506 266 504 266 504 263 504 258 506 250 505 250 504 257 498 262 496 276 508 284 512 272 522 270 520 268 522 268 524 268 525Z M179 514 176 511 174 507 174 504 172 503 173 500 176 500 179 502 186 503Z M176 524 174 523 174 521 172 519 172 517 166 506 169 502 174 518 176 521Z M187 526 186 518 192 512 190 504 202 502 198 512 198 518 191 524Z M136 622 130 606 128 593 126 588 124 555 126 554 126 546 126 545 126 540 128 535 128 530 132 519 136 512 138 505 140 504 142 507 136 518 134 527 134 530 130 537 130 553 128 559 128 578 128 579 128 586 130 587 128 590 130 595 130 599 132 600 132 604 132 605 134 616 136 620Z M142 624 140 618 140 615 138 611 138 608 134 599 134 595 134 594 132 578 132 577 132 562 138 550 141 546 146 542 148 542 150 540 155 538 156 548 158 543 158 539 156 535 154 534 146 534 139 536 137 538 136 536 140 529 140 526 146 510 158 510 164 506 166 508 168 521 174 535 170 544 163 550 156 554 150 560 144 568 144 570 142 573 140 580 140 593 144 607 148 611 148 614 144 621 144 623Z M182 524 182 518 184 514 186 512 184 518 184 523Z M204 530 202 532 196 536 191 536 182 530 180 528 180 526 186 530 189 530 196 526 201 524 204 528Z M152 610 156 602 171 602 178 600 178 598 158 599 164 592 182 590 183 588 175 588 174 588 166 587 174 578 181 578 190 576 191 574 180 573 187 566 193 566 194 565 190 564 196 558 206 553 203 552 190 558 183 564 182 562 188 551 187 550 180 559 178 563 178 567 172 576 170 576 170 565 172 558 171 554 170 556 166 565 166 570 166 571 166 582 155 598 154 595 154 580 154 579 154 573 156 565 155 564 152 570 152 578 150 579 150 592 152 598 154 599 152 606 151 608 148 602 146 596 144 586 146 585 146 576 152 565 161 556 166 554 168 552 175 550 190 550 191 548 202 550 203 550 211 550 212 552 208 556 204 564 202 570 202 576 200 581 198 582 196 588 189 594 184 596 182 597 184 600 178 606 169 608 156 608Z M110 566 104 566 106 564Z M224 600 229 594 240 594 239 592 234 592 234 590 252 578 250 578 243 580 240 580 232 586 231 582 228 585 226 592 224 594 224 589 224 586 232 576 235 574 243 574 244 576 250 576 254 577 246 597 242 600 237 602 234 602 233 602 228 602Z M121 646 117 646 105 652 97 652 89 650 88 648 90 646 95 646 105 642 108 639 107 638 97 642 92 642 91 642 88 642 83 642 81 642 76 638 70 627 70 622 68 619 68 613 66 612 66 606 68 605 68 599 68 598 68 578 70 578 78 582 81 582 86 584 92 584 93 586 103 586 112 593 114 597 116 605 118 606 120 609 122 616 124 628 122 629 122 638 120 643Z M119 644 120 642 116 637 116 631 116 630 116 616 114 624 114 625 114 634 112 634 106 627 108 622 108 614 108 613 108 607 110 606 110 604 108 604 106 602 106 596 104 596 104 606 104 607 104 622 102 624 96 618 96 594 94 587 92 587 92 590 94 591 94 607 92 608 92 611 91 612 86 606 86 603 86 592 84 586 82 586 82 598 72 584 76 594 80 601 77 602 73 600 72 600 76 604 81 604 88 613 88 615 79 614 69 610 68 612 72 616 78 618 88 618 91 618 100 626 99 628 96 628 91 630 79 630 75 628 74 628 77 632 83 634 90 634 101 630 103 630 108 636Z M232 607 232 608 229 610 220 609 224 604 227 604Z M148 639 148 636 148 627 153 614 155 612 170 612 181 608 182 609 186 616 186 619 182 618 180 618 180 624 182 626 181 628 173 620 170 620 162 620 152 629 150 635 150 639Z M209 806 206 801 206 793 204 789 198 784 193 782 186 774 186 766 188 759 189 758 196 760 206 761 203 762 194 762 199 764 213 760 229 760 240 756 242 755 237 754 235 756 234 754 231 754 230 752 220 752 224 752 225 750 231 750 237 752 238 752 243 752 249 750 252 746 240 746 230 742 214 744 206 740 200 733 198 726 198 720 198 719 198 704 200 703 194 692 192 684 192 683 192 674 196 663 203 656 208 652 213 652 215 654 218 654 216 657 208 665 206 669 204 676 204 687 208 697 218 708 216 709 216 714 218 718 226 726 230 727 220 716 218 713 218 712 225 718 229 722 234 726 245 724 252 728 265 732 275 730 282 723 286 717 286 713 296 702 302 691 302 686 304 689 302 696 300 700 296 708 298 707 306 695 306 692 308 685 308 670 306 669 306 671 306 684 305 688 304 682 306 679 304 678 304 673 300 663 296 658 290 655 290 646 286 638 282 632 275 626 274 626 280 633 282 639 282 647 281 648 278 642 269 634 265 632 261 630 252 632 244 638 241 638 240 638 228 638 221 640 216 646 214 650 212 649 212 647 214 646 214 642 216 637 215 636 212 640 210 646 206 646 199 650 192 658 192 660 188 669 186 675 186 693 184 694 184 697 186 698 186 704 192 717 191 718 186 709 186 706 184 702 183 684 182 687 182 702 182 703 184 713 188 720 194 725 192 731 194 738 202 746 206 750 208 750 220 756 234 756 231 758 211 758 208 760 210 756 208 752 206 754 193 754 185 750 180 745 176 738 176 725 178 721 174 718 170 716 164 707 164 704 160 695 160 691 160 690 160 685 164 673 170 666 176 662 176 658 174 653 176 643 178 637 183 632 188 630 202 626 210 626 221 630 235 618 243 612 254 612 257 614 265 618 270 624 276 622 280 620 285 620 286 620 295 620 299 622 306 631 308 637 308 651 318 662 322 668 322 675 322 676 322 681 318 690 314 696 308 702 300 708 300 721 294 732 292 738 290 744 283 750 272 756 260 756 249 750 248 753 254 758 262 760 271 760 281 758 286 764 290 766 300 767 299 768 293 768 289 766 288 767 292 770 302 770 311 762 312 765 310 768 303 776 286 784 278 784 272 782 268 782 266 785 260 796 258 800 251 804 243 806 229 802 228 802 223 802 214 806Z M214 621 216 618 222 614 234 614 221 624Z M145 628 144 623 147 618 148 620Z M144 656 133 650 126 643 126 633 128 632 128 618 132 629 136 639 136 641Z M165 664 162 660 156 651 154 645 154 639 158 632 160 628 165 624 169 624 172 626 178 630 174 635 170 643 170 656 172 657 172 660Z M268 636 267 636 264 634 252 635 254 632 262 632Z M265 680 264 680 264 677 266 670 266 657 264 653 258 648 256 648 253 646 248 646 251 642 259 640 266 642 272 647 274 654 274 670 272 674Z M274 718 264 722 252 722 243 716 242 712 240 716 231 714 223 708 218 704 216 700 217 692 226 702 234 708 238 707 235 706 230 699 230 696 220 685 218 682 216 675 216 670 216 669 216 668 216 662 218 657 220 653 227 646 229 646 232 644 238 644 242 646 244 648 243 650 239 650 235 652 235 652 240 653 232 660 230 660 226 666 226 671 227 672 228 666 228 666 228 676 232 682 236 690 236 692 240 697 240 700 243 700 245 702 251 704 257 704 258 704 262 704 268 702 272 698 272 700 265 712 268 712 276 705 284 694 288 688 288 677 282 661 278 659 276 652 277 650 281 650 288 654 294 662 298 670 298 680 296 686 290 696 290 698 284 709Z M130 660 127 662 121 662 115 660 110 656 115 654 119 650 121 650 130 657Z M267 694 260 698 251 698 246 696 242 692 238 685 238 683 234 677 234 669 236 663 242 656 244 654 255 654 260 659 260 660 258 662 249 662 245 664 240 668 240 674 246 680 252 684 258 683 255 688 252 688 242 688 245 690 248 692 258 690 263 686 268 682 270 682 272 680 274 676 276 677 274 686 272 691Z M156 669 154 670 148 666 146 664 141 662 140 661 143 660Z M282 674 280 674 280 672 278 669 279 660 282 670Z M210 694 208 689 206 686 206 675 210 666 211 664 212 667 208 673 208 686 210 685Z M255 680 250 678 246 674 244 673 244 671 246 668 254 664 256 668 259 666 262 670 262 674Z M98 699 100 698 106 698 115 694 121 690 132 686 145 688 154 692 156 695 156 704 156 704 155 702 154 706 158 712 158 722 162 727 159 728 154 725 152 710 148 705 148 703 142 692 141 692 140 694 146 709 148 717 148 718 148 722 146 720 138 716 138 712 134 701 127 692 126 696 132 704 134 711 133 714 124 707 122 704 117 696 116 697 120 704 119 706 109 702 106 702 117 708 122 712 121 714 118 714 114 716 110 716 110 716 120 716 121 716 128 714 138 720 138 721 134 724 122 728 117 728 115 728 114 730 110 726 102 704Z M296 760 294 758 300 752 304 739 306 726 308 721 308 712 310 714 308 731 308 732 309 732 312 724 312 717 312 716 314 707 315 708 316 706 318 701 320 698 320 691 322 688 324 688 336 703 340 712 340 715 340 716 340 729 338 738 327 750 320 752 313 752 303 758Z M191 706 188 700 188 694 192 705Z M240 737 237 732 231 728 225 726 220 722 214 714 212 711 210 710 210 713 212 717 221 728Z M169 734 164 730 160 716 160 715 160 712 166 720 172 723 172 727Z M240 723 236 724 230 720 231 720 236 722 240 722Z M262 729 272 726 282 720 276 726 269 730Z M168 737 157 748 155 748 152 748 160 742 159 742 152 746 149 750 144 750 132 746 124 742 118 735 114 730 128 730 137 726 142 722 147 724 154 729 153 730 151 730 144 736 130 742 130 743 132 744 144 740 156 732 159 732Z M203 750 204 750 194 742 190 734 190 732 189 732 188 737 192 742 197 748Z M283 758 284 756 288 754 294 747 300 736 300 740 300 741 300 744 296 751 286 758Z M164 790 164 783 164 782 164 777 166 776 166 769 172 756 176 752 178 752 183 756 184 758 178 770 174 775Z M388 795 376 798 362 806 359 806 358 808 349 806 340 795 339 794 340 798 344 804 342 804 340 804 336 799 334 794 328 786 326 787 326 792 320 780 316 778 319 778 328 766 328 768 324 773 325 774 328 774 334 768 343 762 345 758 347 758 354 758 361 762 362 763 359 764 358 762 348 766 342 770 336 776 334 776 326 776 322 777 337 778 353 784 356 787 358 790 367 800 368 799 362 792 361 788 364 788 371 790 382 793 372 786 373 784 375 784 375 784 367 784 364 782 358 782 358 780 365 776 374 774 380 784Z M332 764 334 762 340 758 344 759 341 760 334 764Z M342 777 342 776 349 770 363 764 365 764 372 771 371 774 370 772 369 774 363 774 355 776 352 780Z M168 787 180 776 182 777 182 781 176 786 170 788Z M322 792 313 786 310 782 318 782 320 783Z M307 894 289 876 262 858 252 848 248 839 246 832 246 821 248 814 249 812 251 812 259 808 260 808 256 812 256 814 260 808 260 807 264 802 264 799 267 798 268 806 260 823 256 833 260 847 261 850 260 835 264 826 266 821 270 814 270 805 272 804 280 817 280 820 276 823 270 840 270 852 271 854 272 853 274 840 280 823 282 822 286 832 286 836 284 839 280 851 280 861 282 860 284 850 288 841 290 840 294 851 294 861 294 862 296 858 298 860 304 879 304 879 302 864 303 864 308 868 309 868 310 867 300 855 294 840 297 840 300 842 302 842 313 850 314 848 307 840 299 836 292 834 286 823 293 822 307 826 312 830 314 829 309 824 299 820 296 820 291 818 285 818 282 813 282 811 296 810 297 812 306 812 308 812 308 811 298 806 279 806 274 800 275 798 277 800 286 800 290 798 286 796 281 796 280 796 272 796 268 793 270 788 279 792 289 790 290 790 298 792 305 796 312 804 318 816 318 823 320 824 320 837 320 838 320 841 320 842 318 853 314 864 314 866 310 871 310 874 308 878Z M318 795 316 796 312 792 314 792Z M209 836 208 835 208 832 204 823 206 813 214 813 210 820 212 820 212 819 220 812 224 810 228 810 228 814 224 823 214 830Z M404 900 390 896 385 896 384 896 371 896 370 894 369 896 366 894 364 894 354 886 350 877 348 871 348 854 346 853 348 836 346 836 344 852 342 849 342 837 338 830 339 826 340 829 345 832 344 829 344 828 350 828 364 820 366 820 376 826 386 833 390 840 396 850 400 862 400 871 402 877 402 893 404 894Z M399 896 400 893 394 884 382 870 387 870 397 874 400 874 396 870 388 866 375 864 372 860 370 859 371 858 394 858 392 856 384 852 367 854 360 846 368 846 369 844 385 844 387 846 388 843 381 840 358 842 356 840 352 836 353 834 357 834 358 836 367 834 373 832 375 832 376 830 368 830 367 830 360 830 359 832 347 832 348 834 354 843 370 864 370 877 372 884 374 884 374 868 382 879 384 887 386 888 387 884Z M402 841 396 840 392 835 394 834Z M416 872 414 869 414 868 418 868 422 870 428 869 427 868 420 866 420 865 422 862 427 860 434 853 434 850 433 850 421 858 420 856 422 855 420 854 416 860 414 858 412 862 412 855 414 852 421 846 438 846 439 844 440 851 436 860 434 868 429 872 424 874Z M362 888 362 873 362 872 361 854 360 859 360 865 358 866 358 875 360 876 360 882Z M336 884 334 881 332 874 332 873 332 862 335 856 336 857 336 858Z M492 932 487 932 468 940 454 938 442 934 434 926 432 919 428 915 426 906 424 898 426 898 436 904 438 904 440 906 450 910 453 914 455 914 461 916 466 920 467 924 467 920 486 928 486 928 478 922 468 916 468 915 471 914 475 914 476 912 479 912 479 912 477 910 461 912 454 908 454 907 468 900 471 900 471 898 467 898 458 900 451 904 446 904 442 902 449 896 450 894 440 900 437 900 428 894 429 892 434 892 442 887 437 888 433 892 432 891 439 886 446 882 456 882 462 886 474 896 478 903 484 915 486 920 492 930Z M400 934 398 930 390 922 390 920 388 917 388 913 390 907 396 900 398 901 398 920 400 924 402 920 402 914 402 913 402 904 404 902 407 904 410 908 410 916 408 919 402 928Z"
        };
        let ROSE_PTS = null;

        function roseGarlandSvg(w, h, pad, color) {
            const R = ROSE_REF;
            if (!ROSE_PTS) ROSE_PTS = R.d.match(/\d+/g).map(Number);
            const bw = w - 2 * pad, bh = h - 2 * pad;     // free area inside the border lines
            if (bw <= 0 || bh <= 0) return '';
            const gcx = (R.bx0 + R.bx1) / 2, gcy = (R.by0 + R.by1) / 2;
            // keep the garland where it sits inside the reference oval, but never stretch the roses
            const cx = pad + (gcx - R.ox) / R.ow * bw;
            const cy = pad + (gcy - R.oy) / R.oh * bh;
            let s = Math.min(bw / R.ow, bh / R.oh);
            const fits = k => {
                for (let i = 0; i < ROSE_PTS.length; i += 2) {
                    const ex = (cx + (ROSE_PTS[i] - gcx) * k - w / 2) / (bw / 2);
                    const ey = (cy + (ROSE_PTS[i + 1] - gcy) * k - h / 2) / (bh / 2);
                    if (ex * ex + ey * ey > 0.97) return false;
                }
                return true;
            };
            while (s > 0.02 && !fits(s)) s *= 0.97;
            const left = `translate(${cx - s * gcx} ${cy - s * gcy}) scale(${s})`;
            const right = `translate(${w - cx + s * gcx} ${cy - s * gcy}) scale(${-s} ${s})`;
            return `<defs><path id="roseGarlandPath" d="${R.d}"/></defs>`
                 + `<g fill="${color}" fill-rule="evenodd">`
                 + `<use href="#roseGarlandPath" transform="${left}"/>`
                 + `<use href="#roseGarlandPath" transform="${right}"/></g>`;
        }

        function squareOutsideRoundedInsidePath(w, h, thickness) {
            const rim = 3;
            const band = Math.min(Math.max(1, thickness), Math.min(w, h) / 2 - rim - 1);
            const i = rim + band, x = w - i, y = h - i;
            const radius = Math.max(0, Math.min(24, band, (x - i) / 2, (y - i) / 2));
            const outer = `M ${rim} ${rim} H ${w-rim} V ${h-rim} H ${rim} Z`;
            const inner = `M ${i+radius} ${i} H ${x-radius} A ${radius} ${radius} 0 0 1 ${x} ${i+radius} V ${y-radius} A ${radius} ${radius} 0 0 1 ${x-radius} ${y} H ${i+radius} A ${radius} ${radius} 0 0 1 ${i} ${y-radius} V ${i+radius} A ${radius} ${radius} 0 0 1 ${i+radius} ${i} Z`;
            return outer + ' ' + inner;
        }

        function renderSvgBorder(w, h, shape) {
            const svg = document.getElementById('plaqueBorderSvg');
            svg.setAttribute('viewBox', `0 0 ${w} ${h}`);

            // 'No Border': draw no frame lines or decorative border artwork at all
            if (state.borderStyle === 'none') {
                svg.innerHTML = '';
                return;
            }

            const t = Math.max(MIN_BORDER_PX, state.borderThickness);
            const innerW = Math.max(MIN_BORDER_PX, state.innerBorderThickness);   // inner line of Double / Wide Inset (min 16 pt)
            const finish = getSurfaceMetal();
            const strokeColor = 'url(#finishBorderMetal)';
            const metalDefinition = `<defs><linearGradient id="finishBorderMetal" x1="0" y1="0" x2="0.85" y2="1"><stop offset="0" stop-color="${finish.highlight}"/><stop offset=".32" stop-color="${finish.ink}"/><stop offset=".62" stop-color="${finish.highlight}"/><stop offset="1" stop-color="${finish.edge}"/></linearGradient></defs>`;
            if (state.borderStyle === 'square-rounded') {
                svg.innerHTML = metalDefinition + `<path d="${squareOutsideRoundedInsidePath(w, h, t)}" fill="${strokeColor}" fill-rule="evenodd"/>`;
                return;
            }
            let content = '';
            let inset = t / 2 + 3;
            const isBf = shape === 'rect-butterfly';
            const bfU = isBf ? bfScale(w, h) : 1;
            // for the butterfly shape the frame line weight follows the traced linework (slider default (16 pt) = original weight)
            const sw0 = isBf ? Math.max(1.5, BF_REF.sw * bfU * t / MIN_BORDER_PX) : Math.max(2, t / 2);
            const swSq = isBf ? sw0 : Math.max(3, t / 2);
            const swSolid = isBf ? sw0 * 1.8 : t;
            const cap = isBf ? 'round' : 'butt';
            // Stroke joins must not round off square corners as thickness increases.
            // Curves remain defined by the shape path itself.
            const join = shape === 'rounded-rect' || isBf ? 'round' : 'miter';
            // Thin fixed margin outside the border line: the border band's OUTER edge always sits RIM px from the plaque edge,
            // so a thicker border grows inward instead of pushing the black rim outwards.
            const RIM = 3;
            if (!isBf) {
                if (state.borderStyle === 'solid') inset = RIM + swSolid / 2;
                else if (state.borderStyle === 'square') inset = RIM + swSq / 2;
                else if (state.borderStyle !== 'outline') inset = RIM + sw0 / 2;
            }

            const path1 = getShapePathD(w, h, shape, inset);

            if (state.borderStyle === 'outline' && !isBf) {
                // thin dark hairline on the outer edge, white gap, then the plaque body inside (like the reference)
                const gap = Math.max(4, t * 0.6);
                const outer0 = getShapePathD(w, h, shape, 0), innerP = getShapePathD(w, h, shape, gap);
                const hair = getShapePathD(w, h, shape, 0.8);
                content = `<path d="${outer0} ${innerP}" fill="${strokeColor}" fill-rule="evenodd"/>`
                        + `<path d="${hair}" fill="none" stroke="#141414" stroke-width="1.0" stroke-linejoin="${join}" stroke-miterlimit="4"/>`;
            } else if (state.borderStyle === 'bar') {
                const path2 = getShapePathD(w, h, shape, inset + sw0 / 2 + 6 + innerW / 2);
                content = `
                    <path d="${path1}" fill="none" stroke="${strokeColor}" stroke-width="${sw0}" stroke-linecap="${cap}" stroke-linejoin="${join}" stroke-miterlimit="4"/>
                    <path d="${path2}" fill="none" stroke="${strokeColor}" stroke-width="${innerW}" stroke-linejoin="${join}" stroke-miterlimit="4"/>
                `;
            } else if (state.borderStyle === 'solid') {
                content = `<path d="${path1}" fill="none" stroke="${strokeColor}" stroke-width="${swSolid}" stroke-linecap="${cap}" stroke-linejoin="${join}" stroke-miterlimit="4"/>`;
            } else if (state.borderStyle === 'square') {
                const path2 = getShapePathD(w, h, shape, inset + swSq / 2 + 7 + innerW / 2);
                const dashLen = Math.max(10, innerW * 1.5), dashGap = Math.max(6, innerW * 0.9);
                content = `
                    <path d="${path1}" fill="none" stroke="${strokeColor}" stroke-width="${swSq}" stroke-linecap="${cap}" stroke-linejoin="${join}" stroke-miterlimit="4"/>
                    <path d="${path2}" fill="none" stroke="${strokeColor}" stroke-width="${innerW}" stroke-dasharray="${dashLen} ${dashGap}" stroke-linecap="butt" stroke-linejoin="${join}" stroke-miterlimit="4"/>
                `;
            } else if (state.borderStyle === 'notch') {
                content = `<path d="${path1}" fill="none" stroke="${strokeColor}" stroke-width="${sw0}" stroke-linecap="${cap}" stroke-dasharray="10 6" stroke-linejoin="${join}" stroke-miterlimit="4"/>`;
            } else {
                content = `<path d="${path1}" fill="none" stroke="${strokeColor}" stroke-width="${sw0}" stroke-linecap="${cap}" stroke-linejoin="${join}" stroke-miterlimit="4"/>`;
            }

            // Rose Border Oval: traced rose garlands, kept clear of the border lines
            if (shape === 'oval-rose') {
                const sw = Math.max(2, t / 2);
                let innerEdge = inset + sw / 2;
                if (state.borderStyle === 'bar') innerEdge = inset + sw0 / 2 + 6 + innerW;
                else if (state.borderStyle === 'square') innerEdge = inset + swSq / 2 + 7 + innerW;
                else if (state.borderStyle === 'solid') innerEdge = inset + t / 2;
                else if (state.borderStyle === 'outline') innerEdge = Math.max(4, t * 0.6);
                content += roseGarlandSvg(w, h, innerEdge + 6, strokeColor);
            }

            // Butterfly Corner Banner: traced butterfly linework, scaled with the plaque
            if (isBf) {
                content += `<g transform="scale(${bfU})"><path d="${BF_REF.lines}" fill="${strokeColor}" fill-rule="evenodd"/></g>`;
            }
            svg.innerHTML = metalDefinition + content;
        }

        function openExportModal() {
            if (!updateTextFitWarning()) {
                showNotification('Please adjust the text highlighted in the fit warning before reviewing your design.');
                return;
            }
            const sqInches = state.width * state.height;
            const totalPrice = getPriceBreakdown().total;

            document.getElementById('modalDim').innerText = `${state.width}" × ${state.height}"`;
            document.getElementById('modalMaterial').innerText = materials.find(material => material.id === state.material).name;
            document.getElementById('modalFinish').innerText = surfaceName();
            document.getElementById('modalSurfaceLabel').innerText = state.surfaceMode === 'color' ? 'Color:' : 'Finish:';
            document.getElementById('modalBasePrice').innerText = '$' + getPriceBreakdown().base.toFixed(2);
            document.getElementById('modalColorCharge').innerText = '$' + getPriceBreakdown().colorCharge.toFixed(2) + ' USD';
            document.getElementById('modalBorder').innerText = borderLabel();
            const logos = state.elements.filter(el => el.type === 'emblem');
            document.getElementById('modalEmblem').innerText = logos.length ? logos.length + ' logo(s): ' + logos.map(el => el.label).join(', ') : 'NONE';
            document.getElementById('modalReliefStyle').innerText = state.relief === 'raised' ? 'Raised Cast Relief' : 'Deep Laser Etched';
            document.getElementById('modalDesignDepth').innerText = state.designDepth.toUpperCase();
            document.getElementById('modalMounting').innerText = mountingLabel();
            document.getElementById('modalPrice').innerText = '$' + totalPrice.toFixed(2);
            refreshPriceDisplays();

            document.getElementById('exportModal').classList.remove('hidden');
            capturePlaqueDesignPreview();
        }

        function closeExportModal() {
            document.getElementById('exportModal').classList.add('hidden');
            closeDesignPreview();
        }

        let plaquePreviewUrl = '';

        function hidePlaqueEditorChrome(hide) {
            const plaque = document.getElementById('plaqueObject');
            if (!plaque) return;
            plaque.querySelectorAll('.resize-handle').forEach(el => {
                el.style.visibility = hide ? 'hidden' : '';
            });
            plaque.querySelectorAll('.selected-box').forEach(el => {
                if (hide) {
                    el.dataset.prevBoxShadow = el.style.boxShadow || '';
                    el.dataset.prevOutline = el.style.outline || '';
                    el.style.boxShadow = 'none';
                    el.style.outline = 'none';
                } else {
                    el.style.boxShadow = el.dataset.prevBoxShadow || '';
                    el.style.outline = el.dataset.prevOutline || '';
                }
            });
        }

        function applyPlaquePreviewUrl(url) {
            if (plaquePreviewUrl && plaquePreviewUrl.startsWith('blob:')) URL.revokeObjectURL(plaquePreviewUrl);
            plaquePreviewUrl = url;
            const thumb = document.getElementById('reviewDesignThumb');
            const full = document.getElementById('designPreviewImage');
            const stage = document.getElementById('designPreviewStage');
            if (thumb) thumb.src = url;
            if (full) {
                full.src = url;
                full.style.display = 'block';
            }
            if (stage) {
                stage.style.display = 'none';
                stage.innerHTML = '';
            }
        }

        function buildPlaqueClone() {
            const source = document.getElementById('plaqueObject');
            if (!source) return null;
            const clone = source.cloneNode(true);
            clone.removeAttribute('id');
            // keep ids inside <svg> (border gradient url(#finishBorderMetal) etc. must still resolve)
            clone.querySelectorAll('[id]').forEach(el => {
                if (!el.closest('svg') && el.tagName.toLowerCase() !== 'svg') el.removeAttribute('id');
            });
            clone.querySelectorAll('.resize-handle').forEach(el => el.remove());
            clone.querySelectorAll('.selected-box').forEach(el => {
                el.classList.remove('selected-box');
                el.style.boxShadow = 'none';
                el.style.outline = 'none';
            });
            clone.style.pointerEvents = 'none';
            clone.style.transition = 'none';
            clone.style.margin = '0';
            clone.style.transform = 'none';
            return clone;
        }

        /* Exact live copy of the designer plaque, scaled to fit the given box. */
        function mountPlaqueClone(container, maxW, maxH, allowUpscale) {
            const source = document.getElementById('plaqueObject');
            const clone = buildPlaqueClone();
            if (!source || !clone || !container) return false;
            const w = source.offsetWidth;
            const h = source.offsetHeight;
            const scale = Math.min(maxW / w, maxH / h, allowUpscale ? 3 : 1);
            clone.style.position = 'absolute';
            clone.style.left = '0';
            clone.style.top = '0';
            clone.style.width = w + 'px';
            clone.style.height = h + 'px';
            clone.style.transformOrigin = 'top left';
            clone.style.transform = 'scale(' + scale + ')';
            const holder = document.createElement('div');
            holder.style.position = 'relative';
            holder.style.flex = '0 0 auto';
            holder.style.width = (w * scale) + 'px';
            holder.style.height = (h * scale) + 'px';
            holder.appendChild(clone);
            container.innerHTML = '';
            container.appendChild(holder);
            return true;
        }

        function showLivePlaqueClone() {
            const stage = document.getElementById('designPreviewStage');
            const img = document.getElementById('designPreviewImage');
            if (!stage) return;
            if (img) { img.style.display = 'none'; img.removeAttribute('src'); }
            stage.style.display = 'flex';
            const maxW = Math.min(760, window.innerWidth - 80);
            const maxH = Math.min(window.innerHeight * 0.55, 500);
            mountPlaqueClone(stage, maxW, maxH, true);
            // review-card thumbnail: same live clone instead of a (wrongly rendered) screenshot
            const thumb = document.getElementById('reviewDesignThumb');
            if (thumb && thumb.parentElement) {
                let box = thumb.parentElement.querySelector('.thumb-live');
                if (!box) {
                    box = document.createElement('div');
                    box.className = 'thumb-live';
                    box.style.cssText = 'width:100%;height:100%;display:flex;align-items:center;justify-content:center;overflow:hidden;';
                    thumb.style.display = 'none';
                    thumb.parentElement.appendChild(box);
                }
                const r = thumb.parentElement.getBoundingClientRect();
                mountPlaqueClone(box, Math.max(40, r.width || 120), Math.max(30, r.height || 80), false);
            }
        }

        function capturePlaqueDesignPreview() {
            if (!document.getElementById('plaqueObject')) return;
            showLivePlaqueClone();
        }

        function openDesignPreview() {
            const dialog = document.getElementById('designPreviewDialog');
            showLivePlaqueClone();   // always rebuild so the preview matches the latest edits
            if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
        }

        function closeDesignPreview() {
            const dialog = document.getElementById('designPreviewDialog');
            if (dialog && dialog.open) dialog.close();
        }

        /* =====================================================================
   PORTHO PLAQUE DESIGNER  ->  SHOPIFY  (Option B: add to cart & pay)
   ===================================================================== */

const PLAQUE_CFG = window.PLAQUE_CONFIG || {};
const SHOPIFY_CONFIG = {
    // Values come from templates/page.plaque-designer.liquid (edit them there).
    VARIANT_2D:    Number(PLAQUE_CFG.variant2d)    || 0,   // "Custom Plaque 2D - per sq inch"  $5.00
    VARIANT_3D:    Number(PLAQUE_CFG.variant3d)    || 0,   // "Custom Plaque 3D - per sq inch"  $8.00
    VARIANT_COLOR: Number(PLAQUE_CFG.variantColor) || 0,   // "Custom Colour Charge"            $39.00

    // Cloudinary UNSIGNED upload preset (optional - for design files / logos)
    CLOUDINARY_CLOUD:  PLAQUE_CFG.cloudinaryCloud  || '',
    CLOUDINARY_PRESET: PLAQUE_CFG.cloudinaryPreset || '',

    CART_ADD_URL:     PLAQUE_CFG.cartAddUrl   || '/cart/add.js',
    CART_READ_URL:    PLAQUE_CFG.cartReadUrl   || '/cart.js',
    CART_UPDATE_URL:  PLAQUE_CFG.cartUpdateUrl || '/cart/update.js',
    CLEAR_CART_FIRST: !!PLAQUE_CFG.clearCart,
    AFTER_ADD_URL:    PLAQUE_CFG.afterAddUrl  || '/checkout'   // go straight to the checkout / payment page
};

/* ---------- helpers ---------- */
function newDesignId() {
    return 'PD-' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 5).toUpperCase();
}

/* Convert a data: URL string into a real Blob so every upload is sent the same way. */
function dataUrlToBlob(dataUrl) {
    const match = /^data:([^;,]*)(;base64)?,(.*)$/s.exec(dataUrl);
    if (!match) throw new Error('Invalid image data.');
    const mime = match[1] || 'application/octet-stream';
    const raw = match[2] ? atob(match[3]) : decodeURIComponent(match[3]);
    const bytes = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i);
    return new Blob([bytes], { type: mime });
}

const CLOUDINARY_MAX_BYTES = 15 * 1024 * 1024;               // 15 MB per file
const CLOUDINARY_ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/gif', 'image/svg+xml', 'application/pdf', 'application/json'];

async function cloudinaryUpload(file, kind /* 'image' | 'raw' */, filename) {
    const { CLOUDINARY_CLOUD: cloud, CLOUDINARY_PRESET: preset } = SHOPIFY_CONFIG;
    if (!cloud || !preset) return null;                       // storage is not set -> skip
    if (typeof file === 'string') file = dataUrlToBlob(file);  // logos are stored as data: URLs
    // Client-side guard (the real limits must also be set on the Cloudinary preset itself).
    if (file.size > CLOUDINARY_MAX_BYTES) throw new Error('A design file is too large to upload (max 15 MB).');
    if (file.type && !CLOUDINARY_ALLOWED_TYPES.includes(file.type)) throw new Error('This file type cannot be uploaded: ' + file.type);
    const fd = new FormData();
    if (filename) fd.append('file', file, filename); else fd.append('file', file);
    fd.append('upload_preset', preset);
    fd.append('folder', 'plaque-designs');
    fd.append('tags', 'plaque-designer');
    // Try twice: one short network hiccup should not lose the customer's design.
    let lastError;
    for (let attempt = 1; attempt <= 2; attempt++) {
        try {
            const res = await fetch(`https://api.cloudinary.com/v1_1/${cloud}/${kind}/upload`, { method: 'POST', body: fd });
            if (!res.ok) throw new Error('Upload failed: ' + res.status);
            const data = await res.json();
            if (!data.secure_url) throw new Error('Upload failed: no file URL returned.');
            return data.secure_url;
        } catch (err) {
            lastError = err;
            if (attempt < 2) await new Promise(resolve => setTimeout(resolve, 800));
        }
    }
    throw lastError;
}

/* Complete snapshot of the design; replaces uploaded logos (base64) with URLs */
async function buildDesignSnapshot(designId) {
    const snap = JSON.parse(JSON.stringify(state));            // deep copy
    snap.designId = designId;
    snap.savedAt = new Date().toISOString();
    state.elements.filter(el => el.type === 'text').forEach(el => {
        if (snap.textLines[el.index]) {
            snap.textLines[el.index].effectivePt = effectiveTextPt(el);
            snap.textLines[el.index].widthStretchPct = textStretchPct(el);
        }
    });
    // Saare logo ek saath upload hote hain (pehle ek-ek karke hote the).
    const logoUploads = snap.elements.filter(el => el.image && String(el.image).startsWith('data:')).map(async el => {
        const url = await cloudinaryUpload(el.image, 'image');
        if (url) el.image = url;
    });
    if (snap.customImage && String(snap.customImage).startsWith('data:')) {
        logoUploads.push((async () => {
            const url = await cloudinaryUpload(snap.customImage, 'image');
            if (url) snap.customImage = url;
        })());
    }
    await Promise.all(logoUploads);
    return snap;
}

/* Export the actual design with Canvas/SVG primitives, never an off-screen HTML screenshot. */
function capturePlaqueExport() {
    const plaque = document.getElementById('plaqueObject');
    if (!plaque) throw new Error('Plaque preview is unavailable.');
    const {w, h} = plaqueSizePx();
    const bounds = plaque.getBoundingClientRect();
    const screenScale = bounds.width / w || 1;
    const surface = getComputedStyle(plaque);
    const palette = {};
    ['light', 'base', 'dark', 'ink', 'patch-1', 'patch-2', 'grain'].forEach(key => {
        palette[key] = surface.getPropertyValue('--finish-' + key).trim();
    });
    const fontOf = style => `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
    const items = state.elements.map(element => {
        const item = {...element};
        const wrapper = plaque.querySelector(`[data-id="${element.id}"]`);
        if (!wrapper) throw new Error('A design element could not be captured.');
        if (element.type === 'text') {
            const text = wrapper.querySelector('.plaque-text');
            const style = getComputedStyle(text);
            item.font = fontOf(style);
            item.fontPx = parseFloat(style.fontSize);
            item.sx = element.w / element.naturalW || 1;
            item.sy = element.h / element.naturalH || 1;
            item.glyphs = [...text.querySelectorAll('span')].map(span => {
                const origin = span.style.transformOrigin.split(' ').map(parseFloat);
                return {text: span.textContent, left: parseFloat(span.style.left), top: parseFloat(span.style.top),
                    angle: parseFloat((span.style.transform.match(/rotate\(([^)]+)rad\)/) || [0, 0])[1]),
                    ox: origin[0] || 0, oy: origin[1] || 0};
            });
            item.runs = [];
            if (!item.glyphs.length && text.firstChild) {
                // Use browser-measured line positions, including wrapping, alignment and resizing.
                const node = text.firstChild;
                const range = document.createRange();
                let offset = 0;
                for (const character of Array.from(node.textContent)) {
                    range.setStart(node, offset);
                    offset += character.length;
                    range.setEnd(node, offset);
                    const rect = range.getBoundingClientRect();
                    if (!rect.width || !rect.height || character === '\n') continue;
                    const x = (rect.left - bounds.left) / screenScale;
                    const y = (rect.top - bounds.top) / screenScale;
                    const right = (rect.right - bounds.left) / screenScale;
                    let run = item.runs[item.runs.length - 1];
                    if (!run || Math.abs(run.y - y) > 0.75) {
                        run = {text: '', x, y, right};
                        item.runs.push(run);
                    }
                    run.text += style.textTransform === 'uppercase' ? character.toUpperCase() : character;
                    run.right = Math.max(run.right, right);
                }
            }
        } else if (!item.image) {
            const svg = wrapper.querySelector('svg');
            const icon = wrapper.querySelector('i');
            if (svg) {
                const copy = svg.cloneNode(true);
                copy.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                copy.setAttribute('width', item.w);
                copy.setAttribute('height', item.h);
                copy.setAttribute('color', palette.ink);
                item.svg = new XMLSerializer().serializeToString(copy).replace(/currentColor/g, palette.ink);
            } else if (icon) {
                const style = getComputedStyle(icon, '::before');
                let glyph = style.content;
                try { glyph = JSON.parse(glyph); } catch (_) { glyph = glyph.replace(/^['"]|['"]$/g, ''); }
                item.icon = {text: glyph, font: fontOf(style)};
            }
        }
        return item;
    });
    const screws = [...plaque.querySelectorAll('.fastener-drag')].filter(el => getComputedStyle(el).display !== 'none').map(el => {
        const rect = el.getBoundingClientRect(), style = getComputedStyle(el);
        return {x: (rect.left + rect.width / 2 - bounds.left) / screenScale,
            y: (rect.top + rect.height / 2 - bounds.top) / screenScale,
            radius: rect.width / screenScale / 2, fill: style.backgroundColor, stroke: style.borderTopColor};
    });
    return {w, h, shape: getShapePathD(w, h, state.shape, 0), color: state.color,
        surfaceMode: state.surfaceMode, palette, items, screws, logoFilter: logoDepthFilter(),
        border: document.getElementById('plaqueBorderSvg').innerHTML};
}

function loadPlaqueExportImage(source) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        const timer = setTimeout(() => { image.src = ''; reject(new Error('A design image took too long to load.')); }, 20000);
        image.onload = () => { clearTimeout(timer); resolve(image); };
        image.onerror = () => { clearTimeout(timer); reject(new Error('A logo or border image could not be rendered.')); };
        if (/^https?:/i.test(source)) image.crossOrigin = 'anonymous';
        image.src = source;
    });
}

function plaqueExportSvg(markup, w, h) {
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">${markup}</svg>`);
}

async function renderPlaqueExportCanvas(design, maxDim = 2200) {
    const {w, h, palette} = design;
    const scale = Math.min(3, maxDim / Math.max(w, h));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(w * scale));
    canvas.height = Math.max(1, Math.round(h * scale));
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('This browser cannot render the design image.');
    ctx.scale(scale, scale);
    ctx.save();
    ctx.clip(new Path2D(design.shape));
    if (design.surfaceMode === 'color') {
        ctx.fillStyle = design.color;
        ctx.fillRect(0, 0, w, h);
    } else {
        const angle = 128 * Math.PI / 180;
        const dx = Math.sin(angle), dy = -Math.cos(angle);
        const length = Math.abs(w * dx) + Math.abs(h * dy);
        const gradient = ctx.createLinearGradient(w/2-dx*length/2, h/2-dy*length/2, w/2+dx*length/2, h/2+dy*length/2);
        [[0,'light'], [.45,'base'], [.76,'light'], [1,'dark']].forEach(([at,key]) => gradient.addColorStop(at, palette[key] || '#252821'));
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, w, h);
        [[.35,.83,.37,'patch-2'], [.65,.2,.46,'patch-2'], [.78,.67,.30,'patch-1'], [.22,.30,.38,'patch-1']].forEach(([x,y,r,key]) => {
            ctx.save(); ctx.translate(x*w,y*h); ctx.scale(w,h);
            const patch = ctx.createRadialGradient(0,0,0,0,0,r);
            patch.addColorStop(0,palette[key] || 'transparent'); patch.addColorStop(1,'transparent');
            ctx.fillStyle = patch; ctx.fillRect(-1,-1,2,2); ctx.restore();
        });
        // Deterministic fine grain, clipped to the same outline as the editor.
        const tile = document.createElement('canvas'); tile.width = tile.height = 96;
        const tc = tile.getContext('2d'), pixels = tc.createImageData(96,96);
        let seed = 23;
        for (let i=0; i<pixels.data.length; i+=4) {
            seed = (Math.imul(seed,1664525)+1013904223) >>> 0;
            const shade = seed >>> 24;
            pixels.data[i] = pixels.data[i+1] = pixels.data[i+2] = shade; pixels.data[i+3] = 255;
        }
        tc.putImageData(pixels,0,0);
        ctx.save(); ctx.globalCompositeOperation = 'soft-light'; ctx.globalAlpha = parseFloat(palette.grain) || .18;
        ctx.fillStyle = ctx.createPattern(tile,'repeat'); ctx.fillRect(0,0,w,h); ctx.restore();
    }
    // Saari logo/border images pehle ek saath load hoti hain (pehle ek-ek karke, line se).
    const sourceOf = item => item.image || (item.svg ? 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(item.svg) : null);
    const borderSource = design.border.trim() ? plaqueExportSvg(design.border, w, h) : null;
    const sources = [...new Set([...design.items.map(sourceOf), borderSource].filter(Boolean))];
    const loadedImages = new Map(await Promise.all(sources.map(async src => [src, await loadPlaqueExportImage(src)])));
    for (const item of design.items) {
        ctx.save();
        ctx.fillStyle = palette.ink || '#dfcf8d';
        if (item.type === 'text') {
            ctx.font = item.font;
            ctx.textBaseline = 'alphabetic';
            const metrics = ctx.measureText('Hg');
            const ascent = metrics.fontBoundingBoxAscent || metrics.actualBoundingBoxAscent || item.fontPx * .8;
            const descent = metrics.fontBoundingBoxDescent || metrics.actualBoundingBoxDescent || item.fontPx * .2;
            if (item.glyphs.length) {
                const baseline = (item.fontPx - ascent - descent) / 2 + ascent;
                ctx.translate(item.x,item.y); ctx.scale(item.sx,item.sy);
                for (const glyph of item.glyphs) {
                    ctx.save(); ctx.translate(glyph.left+glyph.ox,glyph.top+glyph.oy); ctx.rotate(glyph.angle);
                    ctx.fillText(glyph.text,-glyph.ox,baseline-glyph.oy); ctx.restore();
                }
            } else {
                for (const run of item.runs) {
                    const textWidth = ctx.measureText(run.text).width;
                    if (!textWidth) continue;
                    ctx.save(); ctx.translate(run.x,run.y); ctx.scale((run.right-run.x)/textWidth,item.sy);
                    ctx.fillText(run.text,0,ascent); ctx.restore();
                }
            }
        } else {
            ctx.filter = design.logoFilter || 'none';
            if (item.image || item.svg) {
                const image = loadedImages.get(sourceOf(item));
                const ratio = Math.min(item.w/image.naturalWidth, item.h/image.naturalHeight);
                const iw = image.naturalWidth*ratio, ih = image.naturalHeight*ratio;
                ctx.drawImage(image,item.x+(item.w-iw)/2,item.y+(item.h-ih)/2,iw,ih);
            } else if (item.icon) {
                ctx.font = item.icon.font; ctx.textAlign='center'; ctx.textBaseline='middle';
                ctx.fillText(item.icon.text,item.x+item.w/2,item.y+item.h/2);
            }
        }
        ctx.restore();
    }
    if (borderSource) ctx.drawImage(loadedImages.get(borderSource),0,0,w,h);
    for (const screw of design.screws) {
        ctx.beginPath(); ctx.arc(screw.x,screw.y,screw.radius,0,Math.PI*2);
        ctx.fillStyle=screw.fill; ctx.fill(); ctx.strokeStyle=screw.stroke; ctx.lineWidth=1; ctx.stroke();
    }
    ctx.restore();
    // Never silently package an entirely transparent preview as a successful PDF.
    // (48x48 chhota copy check hota hai; poore bade canvas ko pixel-by-pixel padhna slow tha.)
    const probe = document.createElement('canvas'); probe.width = probe.height = 48;
    const probeCtx = probe.getContext('2d');
    probeCtx.drawImage(canvas,0,0,48,48);
    const pixels = probeCtx.getImageData(0,0,48,48).data;
    let visible = false;
    for (let i=3; i<pixels.length; i+=4) { if (pixels[i]) { visible=true; break; } }
    if (!visible) throw new Error('The plaque preview is blank. Please retry the download.');
    return canvas;
}

async function renderPreviewPng(snapshot = null, opts = {}) {
    if (document.fonts && document.fonts.ready) await document.fonts.ready;
    const canvas = await renderPlaqueExportCanvas(snapshot || capturePlaqueExport(), opts.maxDim);
    // opts.type = 'image/webp' => bahut chhoti file (browser support na kare to apne aap PNG ban jati hai).
    const png = await new Promise(resolve => canvas.toBlob(resolve, opts.type || 'image/png', opts.quality));
    if (!png) throw new Error('Could not create the plaque preview.');
    return png;
}

/* Human-readable details visible to the team in the order */
function buildReadableProperties(designId) {
    const price = getPriceBreakdown();
    const props = {
        'Design ID': designId,
        'Plaque Size': `${state.width}" x ${state.height}"`,
        'Shape': state.shape,
        'Material': (materials.find(m => m.id === state.material) || {}).name || state.material,
        [state.surfaceMode === 'color' ? 'Colour' : 'Finish']: surfaceName(),
        'Border': borderLabel(),
        'Relief': state.relief === 'raised' ? 'Raised Cast Relief' : 'Deep Laser Etched',
        'Design Depth': state.designDepth.toUpperCase(),
        'Mounting': mountingLabel(),
        'Logos': state.elements.filter(e => e.type === 'emblem').map(e => e.label).join(', ') || 'None'
    };
    state.textLines.forEach((l, i) => {
        const textEl = state.elements.find(e => e.type === 'text' && e.index === i);
        const shownSize = textEl ? effectiveTextPt(textEl) + 'pt' : l.size;
        const stretch = textEl ? textStretchPct(textEl) : 100;
        props['Text Line ' + (i + 1)] = `${l.text} | ${shownSize}${Math.abs(stretch - 100) >= 5 ? ' (width ' + stretch + '%)' : ''} | ${l.fontFamily.replace(/['"]/g, '')} | ${l.align}` + (l.curve ? ` | curve ${l.curve > 0 ? 'arch' : 'smile'} ${Math.abs(l.curve)}%` : '');
    });
    props['_Price Check'] = '$' + price.total.toFixed(2);       // whole order (all plaques)       // Starting with "_" = hidden from the customer, visible in admin
    return props;
}

/* Download a local review sheet; no Shopify or upload configuration required. */
function wrapDownloadText(ctx, value, maxWidth) {
    const lines = [];
    for (const paragraph of String(value).split(/\r?\n/)) {
        let line = '';
        for (const word of paragraph.split(/\s+/)) {
            const candidate = line ? line + ' ' + word : word;
            if (ctx.measureText(candidate).width <= maxWidth) { line = candidate; continue; }
            if (line) lines.push(line);
            line = '';
            for (const character of Array.from(word)) {
                if (line && ctx.measureText(line + character).width > maxWidth) {
                    lines.push(line);
                    line = '';
                }
                line += character;
            }
        }
        lines.push(line);
    }
    return lines;
}

/* A4 PDF pages with safe breaks between detail rows/text lines. */
/* A tightly cropped PDF containing only the plaque artwork. */
async function createDesignOnlyPdf(snapshot) {
    const png = await renderPreviewPng(snapshot);
    const pdf = await PDFLib.PDFDocument.create();
    pdf.setTitle('PorthoMall Plaque Design');
    pdf.setCreator('PorthoMall Plaque Designer');
    const image = await pdf.embedPng(new Uint8Array(await png.arrayBuffer()));
    const width = snapshot.w * 72 / PX_PER_INCH;
    const height = snapshot.h * 72 / PX_PER_INCH;
    const page = pdf.addPage([width, height]);
    page.drawImage(image, {x: 0, y: 0, width, height});
    return new Blob([await pdf.save()], {type: 'application/pdf'});
}

async function downloadDesignOnly() {
    const button = document.getElementById('downloadDesignOnlyBtn');
    const status = document.getElementById('downloadDesignOnlyStatus');
    if (button.disabled) return;
    if (!updateTextFitWarning()) {
        status.textContent = 'Please adjust the text fit before downloading.';
        return;
    }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.style.opacity = '0.55';
    status.textContent = 'Preparing your design-only PDF...';
    let url = null;
    try {
        if (document.fonts && document.fonts.ready) await document.fonts.ready;
        const snapshot = capturePlaqueExport();
        const file = await createDesignOnlyPdf(snapshot);
        url = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'PorthoMall-Design-Only-' + newDesignId() + '.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        status.textContent = 'Your design-only PDF download has started.';
    } catch (error) {
        console.error('Design-only download failed', error);
        status.textContent = 'Download failed: ' + error.message;
    } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.style.opacity = '';
        if (url) { const downloadUrl = url; setTimeout(() => URL.revokeObjectURL(downloadUrl), 60000); }
    }
}

async function createDesignPdf(canvas, pageBreaks, rowBreaks) {
    const pdf = await PDFLib.PDFDocument.create();
    pdf.setTitle('PorthoMall Plaque Design & Details');
    pdf.setCreator('PorthoMall Plaque Designer');
    const pageWidth = 595.28, pageHeight = 841.89;
    const pixelWidth = canvas.width;
    const pixelHeight = Math.round(pixelWidth * pageHeight / pageWidth);
    const margin = 70, footerHeight = 65;
    let offset = 0;
    const slices = [];
    while (offset < canvas.height) {
        const top = offset === 0 ? 0 : margin;
        const limit = Math.min(canvas.height, offset + pixelHeight - top - footerHeight);
        let end = limit;
        if (limit < canvas.height) {
            const completeRows = rowBreaks.filter(point => point > offset && point <= limit);
            const candidates = completeRows.length ? completeRows : pageBreaks.filter(point => point > offset && point <= limit);
            if (candidates.length) end = candidates[candidates.length - 1];
        }
        if (end <= offset) throw new Error('Could not paginate the design details.');
        slices.push({offset, end, top});
        offset = end;
    }
    for (let i = 0; i < slices.length; i++) {
        const {offset, end, top} = slices[i];
        const sheet = document.createElement('canvas');
        sheet.width = pixelWidth;
        sheet.height = pixelHeight;
        const context = sheet.getContext('2d');
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, pixelWidth, pixelHeight);
        context.drawImage(canvas, 0, offset, pixelWidth, end - offset, 0, top, pixelWidth, end - offset);
        context.fillStyle = '#606060';
        context.font = '18px Arial, sans-serif';
        context.textAlign = 'right';
        context.fillText('Page ' + (i + 1) + ' of ' + slices.length, pixelWidth - margin, pixelHeight - 28);
        const image = await pdf.embedJpg(sheet.toDataURL('image/jpeg', 0.95));
        const page = pdf.addPage([pageWidth, pageHeight]);
        page.drawImage(image, {x: 0, y: 0, width: pageWidth, height: pageHeight});
        sheet.width = sheet.height = 1;
    }
    return new Blob([await pdf.save()], {type: 'application/pdf'});
}

/* Review properties = readable details + price rows (same data as the "Download PDF" sheet). */
function buildReviewProperties(designId) {
    const properties = buildReadableProperties(designId);
    const price = getPriceBreakdown();
    delete properties['_Price Check'];
    properties['Plaques Ordered Quantity'] = String(price.qty);
    properties['Price Per Plaque'] = '$' + (price.perPlaque + price.colorChargeEach).toFixed(2) + ' USD';
    properties['Base Price'] = '$' + price.base.toFixed(2) + ' USD';
    properties['Custom Color Charge'] = '$' + price.colorCharge.toFixed(2) + ' USD';
    properties['Estimated Total'] = '$' + price.total.toFixed(2) + ' USD';
    state.textLines.forEach((line, index) => {
        properties['Text Line ' + (index + 1)] += ' | style: ' + (line.style === 'norm' ? 'normal' : line.style);
    });
    return properties;
}

/* Builds the review PDF (preview + details) and returns it as a Blob. Used by Download PDF and by Add to Cart. */
async function buildReviewPdf(designId, properties, savedAt, snapshot, previewBlob = null) {
    let previewUrl = null;
    try {
        const png = previewBlob || await renderPreviewPng(snapshot);   // cart flow me wahi preview dobara use hota hai
        if (!png || !png.size) throw new Error('The plaque image could not be rendered. Please try again.');
        previewUrl = URL.createObjectURL(png);
        const preview = new Image();
        await new Promise((resolve, reject) => {
            preview.onload = resolve;
            preview.onerror = () => reject(new Error('The plaque image could not be opened.'));
            preview.src = previewUrl;
        });
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('Image download is not supported in this browser.');
        const width = 1400, margin = 70, valueX = 390, rowLineHeight = 32;
        ctx.font = '22px Arial, sans-serif';
        const rows = Object.entries(properties).map(([label, value]) => ({
            label, lines: wrapDownloadText(ctx, value, width - valueX - margin)
        }));
        const detailsHeight = rows.reduce((sum, row) => sum + Math.max(1, row.lines.length) * rowLineHeight + 24, 0);
        // Fit everything on ONE A4 page when possible: shrink the preview image height to whatever space is left.
        // (A4 page in canvas pixels = width x 841.89/595.28; 65 px is reserved for the "Page 1 of 1" footer.)
        const pagePixelHeight = Math.round(width * 841.89 / 595.28);
        const previewTop = 160, previewPadding = 60, gapBeforeDetails = 65, bottomSpace = 70;
        const spaceForImage = pagePixelHeight - 65 - previewTop - previewPadding - gapBeforeDetails - detailsHeight - bottomSpace - 30;
        const maxImageH = Math.max(220, Math.min(650, spaceForImage));   // never smaller than 220 px; long details continue on page 2
        const previewScale = Math.min((width - margin * 2 - 60) / preview.naturalWidth, maxImageH / preview.naturalHeight);
        const imageW = Math.round(preview.naturalWidth * previewScale);
        const imageH = Math.round(preview.naturalHeight * previewScale);
        const previewHeight = imageH + previewPadding;
        const detailsTop = previewTop + previewHeight + gapBeforeDetails;
        const height = detailsTop + detailsHeight + bottomSpace;
        if (height > 16000) throw new Error('There is too much text for one image. Shorten the text and try again.');
        canvas.width = width;
        canvas.height = height;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, width, height);
        ctx.fillStyle = '#232323';
        ctx.font = 'bold 38px Arial, sans-serif';
        ctx.fillText('PorthoMall | Your Plaque Design', margin, 75);
        ctx.font = '20px Arial, sans-serif';
        ctx.fillStyle = '#606060';
        ctx.fillText('Saved ' + savedAt, margin, 115);
        ctx.fillStyle = '#f4f5f7';
        ctx.fillRect(margin, previewTop, width - margin * 2, previewHeight);
        ctx.drawImage(preview, (width - imageW) / 2, previewTop + 30, imageW, imageH);
        const pageBreaks = [];
        const rowBreaks = [];
        let y = detailsTop;
        ctx.textBaseline = 'top';
        for (const row of rows) {
            ctx.fillStyle = '#606060';
            ctx.font = 'bold 21px Arial, sans-serif';
            ctx.fillText(row.label, margin, y);
            ctx.fillStyle = '#232323';
            ctx.font = '22px Arial, sans-serif';
            row.lines.forEach((line, index) => {
                ctx.fillText(line, valueX, y + index * rowLineHeight);
                // Very long rows may continue onto another page without cutting a line.
                if (index < row.lines.length - 1) pageBreaks.push(y + (index + 1) * rowLineHeight - 4);
            });
            y += Math.max(1, row.lines.length) * rowLineHeight + 24;
            ctx.strokeStyle = '#e5e5e5';
            ctx.beginPath(); ctx.moveTo(margin, y - 12); ctx.lineTo(width - margin, y - 12); ctx.stroke();
            pageBreaks.push(y - 6);
            rowBreaks.push(y - 6);
        }
        ctx.fillStyle = '#606060';
        ctx.font = '19px Arial, sans-serif';
        ctx.fillText('Design reference only. Final finish may vary. Estimated price is not an order confirmation.', margin, y + 30);
        const file = await createDesignPdf(canvas, pageBreaks, rowBreaks);
        if (!file) throw new Error('Could not create the download. Please try again.');
        return file;
    } finally {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
    }
}

async function downloadDesignWithDetails() {
    const button = document.getElementById('downloadDesignBtn');
    const status = document.getElementById('downloadDesignStatus');
    if (button.disabled) return;
    if (!updateTextFitWarning()) {
        status.textContent = 'Please adjust the text fit before downloading.';
        return;
    }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.style.opacity = '0.55';
    button.style.cursor = 'wait';
    status.textContent = 'Preparing your plaque image and design details...';
    let downloadUrl = null;
    try {
        if (document.fonts && document.fonts.ready) await document.fonts.ready;
        // Freeze artwork and details together, before asynchronous image rendering.
        const designId = newDesignId();
        const savedAt = new Date().toLocaleString();
        const properties = buildReviewProperties(designId);
        const snapshot = capturePlaqueExport();
        const file = await buildReviewPdf(designId, properties, savedAt, snapshot);
        downloadUrl = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = 'PorthoMall-Plaque-' + designId + '.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        status.textContent = 'Your PDF download has started. It includes the plaque preview and design details.';
    } catch (error) {
        console.error('Design download failed', error);
        status.textContent = 'Download failed: ' + error.message;
    } finally {
        if (downloadUrl) { const url = downloadUrl; setTimeout(() => URL.revokeObjectURL(url), 60000); }
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.style.opacity = '';
        button.style.cursor = '';
    }
}

/* ---------- Full-page "processing" overlay (Add to Cart & Pay) ----------
   Add to Cart dabate hi poora page blur ho jata hai aur beech me Portho shopping-bag mascot
   plaque lekar bhagta (run karta) dikhta hai. Sab kuch JS se inject hota hai (SVG + CSS animation),
   koi image file ya liquid/CSS change ki zarurat nahi. */
const CartOverlay = (() => {
    let root = null, msgEl = null, barEl = null, stepEl = null, prevOverflow = '';

    const MASCOT_SVG = `
    <svg class="pq-mascot" viewBox="0 0 260 200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <defs>
            <linearGradient id="pqBag" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#ff7a45"/><stop offset="1" stop-color="#e6301b"/></linearGradient>
        </defs>

        <!-- ground: dashed road jo peeche ki taraf bhagti hai -->
        <line class="pq-ground" x1="8" y1="190" x2="252" y2="190" stroke="rgba(255,255,255,.55)" stroke-width="3" stroke-dasharray="14 12" stroke-linecap="round"/>
        <ellipse class="pq-shadow" cx="135" cy="192" rx="46" ry="5" fill="rgba(0,0,0,.30)"/>

        <!-- speed lines -->
        <g class="pq-lines">
            <rect class="pq-zip z1" x="14" y="76"  width="54" height="9" rx="4.5" fill="#ff4a2a"/>
            <rect class="pq-zip z2" x="30" y="94"  width="40" height="9" rx="4.5" fill="#e11d1d"/>
            <rect class="pq-zip z3" x="8"  y="112" width="62" height="9" rx="4.5" fill="#ff6a3d"/>
            <rect class="pq-zip z4" x="26" y="130" width="44" height="9" rx="4.5" fill="#d91616"/>
            <rect class="pq-zip z5" x="20" y="60"  width="36" height="3" rx="1.5" fill="#fff" opacity=".8"/>
            <rect class="pq-zip z6" x="12" y="146" width="46" height="3" rx="1.5" fill="#fff" opacity=".8"/>
        </g>

        <g class="pq-bounce">
            <!-- legs -->
            <g transform="translate(118,138)"><g class="pq-leg pq-leg-a">
                <path d="M0 0 L0 22 L4 37" stroke="#2b2140" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                <path d="M-8 41 q0 -9 10 -9 h9 q9 0 9 9 v3 h-28z" fill="#ec5a2a"/><rect x="-8" y="43" width="28" height="4" rx="2" fill="#fff"/>
            </g></g>
            <g transform="translate(150,138)"><g class="pq-leg pq-leg-b">
                <path d="M0 0 L0 22 L4 37" stroke="#2b2140" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                <path d="M-8 41 q0 -9 10 -9 h9 q9 0 9 9 v3 h-28z" fill="#ec5a2a"/><rect x="-8" y="43" width="28" height="4" rx="2" fill="#fff"/>
            </g></g>

            <!-- bag -->
            <path d="M78 70 L90 62 L90 140 L82 132 Z" fill="#b8200e"/>
            <path d="M110 63 C108 30 152 30 150 63" fill="none" stroke="#f04a24" stroke-width="7" stroke-linecap="round"/>
            <rect x="90" y="62" width="80" height="78" rx="6" fill="url(#pqBag)"/>
            <ellipse cx="116" cy="88" rx="4" ry="5.5" fill="#fff"/>
            <ellipse cx="144" cy="88" rx="4" ry="5.5" fill="#fff"/>
            <path d="M106 100 Q130 128 156 100 Q131 109 106 100 Z" fill="#fff"/>

            <!-- plaque + arm + hands -->
            <g transform="translate(0,9)">
            <path d="M92 108 Q82 136 114 136" fill="none" stroke="#f26a35" stroke-width="7" stroke-linecap="round"/>
            <rect x="112" y="110" width="68" height="38" rx="2" fill="#1f2428" stroke="#d9ad4e" stroke-width="3"/>
            <rect x="117" y="115" width="58" height="28" fill="none" stroke="#d9ad4e" stroke-width="1" opacity=".7"/>
            <text x="146" y="133" text-anchor="middle" font-size="8.5" fill="#e8c36a" font-family="Georgia,'Times New Roman',serif">Custom Plaque</text>
            <circle cx="116" cy="136" r="6.5" fill="#f6c47c"/>
            <circle cx="181" cy="131" r="6.5" fill="#f6c47c"/>
            </g>
        </g>
    </svg>`;

    function build() {
        if (root) return;
        const style = document.createElement('style');
        style.textContent = `
        .pq-overlay{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:20px;
            background:rgba(15,23,42,.42);-webkit-backdrop-filter:blur(12px);backdrop-filter:blur(12px);
            opacity:0;visibility:hidden;transition:opacity .25s ease,visibility .25s ease;cursor:progress}
        .pq-overlay.is-on{opacity:1;visibility:visible}
        .pq-stage{display:flex;flex-direction:column;align-items:center;text-align:center;width:100%;max-width:420px}
        .pq-mascot{width:min(340px,80vw);height:auto;overflow:visible;filter:drop-shadow(0 14px 18px rgba(0,0,0,.25))}
        .pq-msg{margin:14px 0 2px;font-size:18px;font-weight:700;color:#fff;text-shadow:0 2px 10px rgba(0,0,0,.45)}
        .pq-step{margin:0 0 14px;font-size:12px;color:rgba(255,255,255,.85);text-shadow:0 1px 6px rgba(0,0,0,.45)}
        .pq-track{width:min(240px,70vw);height:6px;border-radius:99px;background:rgba(255,255,255,.28);overflow:hidden}
        .pq-bar{height:100%;width:0;border-radius:99px;background:linear-gradient(90deg,#ffb27a,#ff4d2a);transition:width .5s ease}
        .pq-note{margin:14px 0 0;font-size:11.5px;color:rgba(255,255,255,.75);text-shadow:0 1px 6px rgba(0,0,0,.45)}

        .pq-bounce{animation:pqbounce .6s ease-in-out infinite;transform-origin:135px 150px}
        .pq-leg{transform-origin:0 0}
        .pq-leg-a{animation:pqleg .6s ease-in-out infinite}
        .pq-leg-b{animation:pqleg .6s ease-in-out infinite;animation-delay:-.3s}
        .pq-ground{animation:pqground .45s linear infinite}
        .pq-shadow{transform-box:fill-box;transform-origin:center;animation:pqshadow .6s ease-in-out infinite}
        .pq-zip{animation:pqzip .7s linear infinite;opacity:0}
        .pq-zip.z2{animation-delay:-.15s}.pq-zip.z3{animation-delay:-.3s}.pq-zip.z4{animation-delay:-.45s}
        .pq-zip.z5{animation-delay:-.2s}.pq-zip.z6{animation-delay:-.5s}
        @keyframes pqbounce{0%,100%{transform:translateY(0) rotate(-2deg)}25%{transform:translateY(-8px) rotate(-3.5deg)}50%{transform:translateY(0) rotate(-2deg)}75%{transform:translateY(-8px) rotate(-3.5deg)}}
        @keyframes pqleg{0%,100%{transform:rotate(-42deg)}50%{transform:rotate(42deg)}}
        @keyframes pqground{to{stroke-dashoffset:26}}
        @keyframes pqshadow{0%,100%{transform:scaleX(1);opacity:1}25%,75%{transform:scaleX(.86);opacity:.7}50%{transform:scaleX(1);opacity:1}}
        @keyframes pqzip{0%{transform:translateX(26px);opacity:0}25%{opacity:1}100%{transform:translateX(-34px);opacity:0}}
        @media (prefers-reduced-motion:reduce){.pq-bounce,.pq-leg-a,.pq-leg-b,.pq-ground,.pq-shadow,.pq-zip{animation-duration:1.8s}.pq-overlay,.pq-bar{transition:none}}`;
        document.head.appendChild(style);

        root = document.createElement('div');
        root.className = 'pq-overlay';
        root.setAttribute('role', 'alertdialog');
        root.setAttribute('aria-modal', 'true');
        root.setAttribute('aria-live', 'assertive');
        root.setAttribute('aria-label', 'Processing your order');
        root.innerHTML = `
            <div class="pq-stage">
                ${MASCOT_SVG}
                <p class="pq-msg">Please wait…</p>
                <p class="pq-step"></p>
                <div class="pq-track"><div class="pq-bar"></div></div>
                <p class="pq-note">Please do not close or refresh this page.</p>
            </div>`;
        document.body.appendChild(root);
        msgEl  = root.querySelector('.pq-msg');
        stepEl = root.querySelector('.pq-step');
        barEl  = root.querySelector('.pq-bar');
    }

    return {
        show(text, step, total) {
            build();
            prevOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            this.update(text, step, total);
            root.classList.add('is-on');
        },
        update(text, step, total) {
            build();
            if (text) msgEl.textContent = text;
            if (step && total) {
                stepEl.textContent = 'Step ' + step + ' of ' + total;
                barEl.style.width = Math.round((step / total) * 100) + '%';
            }
        },
        hide() {
            if (!root) return;
            root.classList.remove('is-on');
            document.body.style.overflow = prevOverflow;
            if (barEl) barEl.style.width = '0';
        }
    };
})();

/* Browser Back from checkout: make the button usable again. */
window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    const btn = document.getElementById('addToCartBtn');
    const label = btn && btn.querySelector('span');
    if (btn) btn.disabled = false;
    if (label) label.textContent = 'Add to Cart & Pay';
    CartOverlay.hide();
});

/* Remove old plaque lines from the cart. Other products are only removed if the customer agrees. */
function readCartEarly(C) {
    return fetch(C.CART_READ_URL, { headers: { 'Accept': 'application/json' } })
        .then(res => res.ok ? res.json() : null)
        .catch(readError => { console.warn('Could not read the cart', readError); return null; });
}

async function prepareCartForPlaque(C, cartPromise) {
    const cart = await (cartPromise || readCartEarly(C));

    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;   // nothing to clean

    const plaqueIds = new Set([C.VARIANT_2D, C.VARIANT_3D, C.VARIANT_COLOR]);
    const otherItems = cart.items.filter(item => !plaqueIds.has(Number(item.variant_id)));
    const removeOthers = otherItems.length
        ? window.confirm('Your cart has other items. Press OK to remove them and check out with only this plaque, or Cancel to keep them.')
        : false;

    const updates = {};
    cart.items.forEach(item => {
        const isPlaque = plaqueIds.has(Number(item.variant_id));
        if (isPlaque || removeOthers) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return;

    const res = await fetch(C.CART_UPDATE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
    });
    if (!res.ok) throw new Error('Could not update your cart. Please try again.');
}

/* ---------- main: Add to cart (Optimized) ---------- */

async function addToShopifyCart() {
    const C = SHOPIFY_CONFIG;
    if (!C.VARIANT_2D || !C.VARIANT_3D || !C.VARIANT_COLOR) {
        showNotification('Setup incomplete: Add Shopify variant IDs (SHOPIFY_CONFIG).');
        return;
    }
    if (!updateTextFitWarning()) {
        showNotification('Please fix the text highlighted in the fit warning first.');
        return;
    }

    const btn = document.getElementById('addToCartBtn');
    const label = btn && btn.querySelector('span');
    if (btn) btn.disabled = true;

    const TOTAL_STEPS = 4;
    const setStep = (n, text) => {
        if (label) label.textContent = text;
        CartOverlay.update(text, n, TOTAL_STEPS);
    };
    CartOverlay.show('Starting…', 1, TOTAL_STEPS);   // poora page blur + center me logo loader
    
    try {
        const designId = newDesignId();
        const plaqueCount = plaqueQty();
        if (plaqueCount < 1 || plaqueCount > MAX_PLAQUES) throw new Error('Please choose between 1 and ' + MAX_PLAQUES + ' plaques.');
        const props = Object.assign({ 'Plaques Ordered Quantity': String(plaqueCount) }, buildReadableProperties(designId));
        state.textLines.forEach((line, index) => {
            props['Text Line ' + (index + 1)] += ' | style: ' + (line.style === 'norm' ? 'normal' : line.style);
        });

        props['_Width'] = String(state.width);
        props['_Height'] = String(state.height);
        props['_Plaque Qty'] = String(plaqueCount);
        props['_Sq In Per Plaque'] = String(state.width * state.height);
        props['_Expected Qty'] = String(state.width * state.height * plaqueCount);   // cart quantity = sq in x plaques
        // Server-side check ke liye (Shopify Flow / Function): order me inhe dekhkar price mismatch pakda ja sakta hai.
        props['_Depth'] = state.designDepth;                                   // '2d' ya '3d' => sahi variant hona chahiye
        props['_Color Charge'] = String(getPriceBreakdown().colorCharge);      // total colour charge = $39 x plaques
        props['_Color Charge Each'] = String(getPriceBreakdown().colorChargeEach);      // '39' ho to colour-charge line zaroori hai

        // Cart ki read-only call abhi se shuru (uploads ke saath chalti hai, alag se wait nahi karna padta)
        const cartPromise = C.CLEAR_CART_FIRST ? readCartEarly(C) : null;

        // Step 1: Preview ek hi baar render hota hai (chhota WebP) aur aage PDF me bhi wahi use hota hai
        setStep(1, 'Generating preview...');
        const design = capturePlaqueExport();
        const previewBlob = await renderPreviewPng(design, { maxDim: 1600, type: 'image/webp', quality: 0.92 });

        // Step 2: Preview, design JSON aur review PDF - teeno ek saath upload (pehle line se hote the)
        setStep(2, 'Saving design files...');
        const storageOn = !!(C.CLOUDINARY_CLOUD && C.CLOUDINARY_PRESET);

        const previewTask = cloudinaryUpload(previewBlob, 'image');

        const snapshotTask = buildDesignSnapshot(designId).then(snapshot =>
            cloudinaryUpload(new Blob([JSON.stringify(snapshot)], { type: 'application/json' }), 'raw')
        );

        const pdfTask = storageOn ?
            buildReviewPdf(designId, buildReviewProperties(designId), new Date().toLocaleString(), design, previewBlob)
                .then(reviewPdf => cloudinaryUpload(reviewPdf, 'image', 'PorthoMall-Plaque-' + designId + '.pdf'))
                .catch(err => { console.warn('PDF skipped:', err); return null; }) : Promise.resolve(null);

        const [previewUrl, designUrl, reviewUrl] = await Promise.all([previewTask, snapshotTask, pdfTask]);
        if (previewUrl) props['_Preview Image'] = previewUrl;
        if (designUrl) props['_Design File'] = designUrl;
        if (reviewUrl) props['_Review PDF'] = reviewUrl;

        // When file storage is set up, the preview and design file are required to reproduce the order.
        // Do not let the customer pay for a design that we could not save. (The review PDF is optional.)
        if (C.CLOUDINARY_CLOUD && C.CLOUDINARY_PRESET && (!previewUrl || !designUrl)) {
            throw new Error('Your design files could not be saved. Please check your internet connection and try again.');
        }

        // Step 3: Shopify Cart Add
        setStep(3, 'Adding to cart...');
        const price = getPriceBreakdown();
        const sqIn = state.width * state.height;
        // Sanity check: the cart quantity must be a whole number of square inches within the allowed size range.
        if (!Number.isInteger(state.width) || !Number.isInteger(state.height) ||
            state.width < 3 || state.width > 100 || state.height < 2 || state.height > 100 ||
            !Number.isInteger(sqIn) || sqIn < 1) {
            throw new Error('Invalid plaque size. Please choose the width and height again.');
        }
        const items = [{
            id: state.designDepth === '3d' ? C.VARIANT_3D : C.VARIANT_2D,
            quantity: sqIn * plaqueCount,      // per-sq-inch variant: sq in x number of plaques
            properties: props
        }];
        if (price.colorCharge > 0) {
            items.push({ id: C.VARIANT_COLOR, quantity: plaqueCount, properties: { 'Design ID': designId } });   // $39 x plaques
        }

        if (C.CLEAR_CART_FIRST) await prepareCartForPlaque(C, cartPromise);
        
        const res = await fetch(C.CART_ADD_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
        });
        
        if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || err.message || 'Cart error ' + res.status);
        }
        
        // GTM / GA4 / Meta ke liye add_to_cart event. Tracking kabhi checkout ko rokna nahi chahiye (try/catch).
        try {
            window.dataLayer = window.dataLayer || [];
            const gtmLoaded = !!(window.google_tagmanager && window.google_tagmanager['GTM-WTN29M4']);
            await new Promise(resolve => {
                let finished = false;
                const finish = () => { if (!finished) { finished = true; resolve(); } };
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    event: 'add_to_cart',
                    ecommerce: {
                        currency: 'USD',
                        value: price.total,
                        // Poora plaque 1 item ki tarah (cart quantity = sq inch hai, wo revenue bigaad deti)
                        items: [{ item_id: String(items[0].id), item_name: 'Custom Plaque ' + state.designDepth.toUpperCase(),
                                  price: price.total / plaqueCount, quantity: plaqueCount }]
                    },
                    eventCallback: finish,
                    eventTimeout: 800
                });
                if (!gtmLoaded) finish();          // GTM block/load nahi hua to wait nahi
                else setTimeout(finish, 800);      // safety: 0.8s se zyada nahi rukna
            });
        } catch (trackError) { console.warn('Tracking skipped:', trackError); }

        setStep(4, 'Redirecting to checkout...');
        window.location.href = C.AFTER_ADD_URL;    
        
    } catch (e) {
        console.error(e);
        CartOverlay.hide();
        showNotification('Could not add to cart: ' + e.message);
        if (btn) btn.disabled = false;
        if (label) label.textContent = 'Add to Cart & Pay';
    }
}

        function showNotification(msg) {
            const box = document.getElementById('notificationBox');
            document.getElementById('notificationText').innerText = msg;
            box.classList.remove('translate-y-20', 'opacity-0');
            setTimeout(() => {
                box.classList.add('translate-y-20', 'opacity-0');
            }, 3500);
        }
   

/* =====================================================================
   MOBILE ENHANCEMENTS
   - pinch-to-zoom + two-finger pan + one-finger pan on the empty preview area
   - collapsible bottom panel (more room for the plaque)
   - keeps the layout correct when the on-screen keyboard / URL bar changes the viewport
   ===================================================================== */
(function initMobileStudio() {
    const main = document.querySelector('main.studio-preview') || document.querySelector('main');
    const wrap = document.getElementById('previewWrapper');
    if (!main || !wrap) return;

    /* ---- gestures ---- */
    const pts = new Map();
    let pinch = null, panning = null;
    const noGestureTarget = '.plaque-element, .resize-handle, #shapeEditOverlay, .preview-toolbar, #shapeEditBar, #textFitWarning, .sheet-handle';

    const setGesturing = on => wrap.classList.toggle('is-gesturing', on);
    const mid = () => { const a = [...pts.values()]; return { x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2, d: Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y) || 1 }; };

    main.addEventListener('pointerdown', e => {
        if (!isMobileLayout() || e.pointerType === 'mouse') return;
        if (typeof isDragging !== 'undefined' && (isDragging || isResizing)) return;     // an element is being moved
        if (e.target.closest(noGestureTarget) && pts.size === 0) return;
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pts.size === 2) {
            const m = mid();
            pinch = { d: m.d, x: m.x, y: m.y, zoom: userZoom, panX, panY };
            panning = null;
            setGesturing(true);
        } else if (pts.size === 1) {
            panning = { x: e.clientX, y: e.clientY, panX, panY, moved: false };
        }
    });

    main.addEventListener('pointermove', e => {
        if (!pts.has(e.pointerId)) return;
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pinch && pts.size >= 2) {
            const m = mid();
            userZoom = Math.max(0.4, Math.min(4, pinch.zoom * (m.d / pinch.d)));
            panX = pinch.panX + (m.x - pinch.x);
            panY = pinch.panY + (m.y - pinch.y);
            fitPreview(); renderShapeEditOverlay();
        } else if (panning && pts.size === 1) {
            const dx = e.clientX - panning.x, dy = e.clientY - panning.y;
            if (!panning.moved && Math.hypot(dx, dy) < 6) return;
            if (typeof activePointerId !== 'undefined' && activePointerId !== null) { panning = null; return; }
            if (!panning.moved) { panning.moved = true; setGesturing(true); }
            panX = panning.panX + dx; panY = panning.panY + dy;
            fitPreview(); renderShapeEditOverlay();
        }
    });

    const endPtr = e => {
        if (!pts.delete(e.pointerId)) return;
        if (pts.size < 2) pinch = null;
        if (pts.size === 0) {
            if (panning && panning.moved) {      // swallow the click that would deselect the current element
                const block = ev => { ev.stopPropagation(); ev.preventDefault(); };
                main.addEventListener('click', block, { capture: true, once: true });
                setTimeout(() => main.removeEventListener('click', block, true), 60);
            }
            panning = null; setGesturing(false);
        } else if (pts.size === 1) {               // finger lifted during a pinch: continue as a one-finger pan
            const p = [...pts.values()][0];
            panning = { x: p.x, y: p.y, panX, panY, moved: true };
        }
    };
    main.addEventListener('pointerup', endPtr);
    main.addEventListener('pointercancel', endPtr);

    // Double-tap on the empty preview area = fit to screen.
    let lastBgTap = 0;
    main.addEventListener('pointerup', e => {
        if (!isMobileLayout() || e.pointerType === 'mouse') return;
        if (e.target.closest(noGestureTarget) || e.target.closest('#plaqueObject')) return;
        if (panning && panning.moved) return;
        const now = performance.now();
        if (now - lastBgTap < 320) { resetZoom(); lastBgTap = 0; } else lastBgTap = now;
    });

    /* ---- collapsible bottom panel ---- */
    const aside = document.querySelector('.studio-controls');
    if (aside && !document.getElementById('sheetHandle')) {
        const handle = document.createElement('button');
        handle.type = 'button';
        handle.id = 'sheetHandle';
        handle.className = 'sheet-handle';
        handle.setAttribute('aria-label', 'Show or hide the controls panel');
        handle.innerHTML = '<span class="sheet-grip"></span><span class="sheet-label" id="sheetLabel">Hide controls</span>';
        aside.parentNode.insertBefore(handle, aside);
        handle.addEventListener('click', () => setSheetState(document.body.classList.contains('sheet-min') ? 'normal' : 'min'));
    }
    window.setSheetState = function (s) {
        document.body.classList.toggle('sheet-min', s === 'min');
        const l = document.getElementById('sheetLabel');
        if (l) l.textContent = s === 'min' ? 'Show controls' : 'Hide controls';
        setTimeout(() => { fitPreview(); renderShapeEditOverlay(); }, 30);
    };

    // Shape edit on a phone: give the plaque the whole screen, restore afterwards.
    const _toggle = window.toggleShapeEdit;
    if (typeof _toggle === 'function') {
        window.toggleShapeEdit = function () {
            _toggle();
            if (isMobileLayout()) setSheetState(shapeEdit.active ? 'min' : 'normal');
        };
    }

    /* ---- keep everything fitted when the viewport changes (rotation, URL bar, keyboard) ---- */
    let raf = 0;
    const refit = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { fitPreview(); renderShapeEditOverlay(); }); };
    window.addEventListener('orientationchange', () => setTimeout(refit, 250));
    if (window.visualViewport) window.visualViewport.addEventListener('resize', refit);
    if (window.ResizeObserver) new ResizeObserver(refit).observe(main);
    MOBILE_MQ.addEventListener ? MOBILE_MQ.addEventListener('change', () => { userZoom = isMobileLayout() ? 1 : 1.5; panX = panY = 0; refit(); }) : null;
    refit();

    // Text fields: scroll the focused one into view above the keyboard.
    document.addEventListener('focusin', e => {
        if (!isMobileLayout() || !e.target.closest || !e.target.closest('.studio-controls')) return;
        if (!/INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
        setTimeout(() => e.target.scrollIntoView({ block: 'center', behavior: 'smooth' }), 300);
    });
})();